import { useState, useCallback, useEffect, useRef, Fragment } from "react";

import { API } from "../config";

// ===== CONFIGURAZIONE MERCATI (23 mercati, come power_matrice.py) =====
const MERCATI = [
  {id:"1_ore8",label:"1",g:"1X2 ore8"},{id:"x_ore8",label:"X",g:"1X2 ore8"},{id:"2_ore8",label:"2",g:"1X2 ore8"},
  {id:"1_ore9",label:"1",g:"1X2 ore9"},{id:"x_ore9",label:"X",g:"1X2 ore9"},{id:"2_ore9",label:"2",g:"1X2 ore9"},
  {id:"1_5mko",label:"1",g:"1X2 5mKO"},{id:"x_5mko",label:"X",g:"1X2 5mKO"},{id:"2_5mko",label:"2",g:"1X2 5mKO"},
  {id:"u15_ore8",label:"U1.5",g:"O/U ore8"},{id:"o15_ore8",label:"O1.5",g:"O/U ore8"},
  {id:"u25_ore8",label:"U2.5",g:"O/U ore8"},{id:"o25_ore8",label:"O2.5",g:"O/U ore8"},
  {id:"u35_ore8",label:"U3.5",g:"O/U ore8"},{id:"o35_ore8",label:"O3.5",g:"O/U ore8"},
  {id:"u15_5mko",label:"U1.5",g:"O/U 5mKO"},{id:"o15_5mko",label:"O1.5",g:"O/U 5mKO"},
  {id:"u25_5mko",label:"U2.5",g:"O/U 5mKO"},{id:"o25_5mko",label:"O2.5",g:"O/U 5mKO"},
  {id:"u35_5mko",label:"U3.5",g:"O/U 5mKO"},{id:"o35_5mko",label:"O3.5",g:"O/U 5mKO"},
  {id:"btts_si",label:"SI",g:"BTTS"},{id:"btts_no",label:"NO",g:"BTTS"},
];

// ===== PARAMETRI raggruppati come VBA =====
const PARAMETRI = [
  {cat:"Quote BF — 1X2 (ore8)", items:[
    {id:"q_1_ore8",l:"@Punta 1 (ore8)"},{id:"q_x_ore8",l:"@Punta X (ore8)"},{id:"q_2_ore8",l:"@Punta 2 (ore8)"},
    {id:"qb_1_ore8",l:"@Banca 1 (ore8)"},{id:"qb_x_ore8",l:"@Banca X (ore8)"},{id:"qb_2_ore8",l:"@Banca 2 (ore8)"},
  ]},
  {cat:"Quote BF — 1X2 (ore9)", items:[
    {id:"q_1_ore9",l:"@Punta 1 (ore9)"},{id:"q_x_ore9",l:"@Punta X (ore9)"},{id:"q_2_ore9",l:"@Punta 2 (ore9)"},
    {id:"aggio_bf",l:"Aggio Bookmaker (ore9)"},
  ]},
  {cat:"Quote INS", items:[
    {id:"q_ins_1",l:"@INS 1"},{id:"q_ins_x",l:"@INS X"},{id:"q_ins_2",l:"@INS 2"},
  ]},
  {cat:"Differenza Quote (INS - ore9)", items:[
    {id:"diff_ins_1",l:"dQ 1 (INS-BF ore9)"},{id:"diff_ins_x",l:"dQ X (INS-BF ore9)"},{id:"diff_ins_2",l:"dQ 2 (INS-BF ore9)"},
  ]},
  {cat:"Quote BF — 1X2 (5mKO)", items:[
    {id:"qp_1",l:"@Punta 1 (5mKO)"},{id:"qp_x",l:"@Punta X (5mKO)"},{id:"qp_2",l:"@Punta 2 (5mKO)"},
    {id:"qb_1",l:"@Banca 1 (5mKO)"},{id:"qb_x",l:"@Banca X (5mKO)"},{id:"qb_2",l:"@Banca 2 (5mKO)"},
  ]},
  {cat:"Differenza Quote (5mKO - ore9)", items:[
    {id:"d_q_1",l:"dQ 1 (5mKO-ore9)"},{id:"d_q_x",l:"dQ X (5mKO-ore9)"},{id:"d_q_2",l:"dQ 2 (5mKO-ore9)"},
  ]},
  {cat:"Quote BF — O/U (ore8)", items:[
    {id:"qp_u15_ore8",l:"@Punta U1.5 (ore8)"},{id:"qb_u15_ore8",l:"@Banca U1.5 (ore8)"},
    {id:"qp_o15_ore8",l:"@Punta O1.5 (ore8)"},{id:"qb_o15_ore8",l:"@Banca O1.5 (ore8)"},
    {id:"qp_u25_ore8",l:"@Punta U2.5 (ore8)"},{id:"qb_u25_ore8",l:"@Banca U2.5 (ore8)"},
    {id:"qp_o25_ore8",l:"@Punta O2.5 (ore8)"},{id:"qb_o25_ore8",l:"@Banca O2.5 (ore8)"},
    {id:"qp_u35_ore8",l:"@Punta U3.5 (ore8)"},{id:"qb_u35_ore8",l:"@Banca U3.5 (ore8)"},
    {id:"qp_o35_ore8",l:"@Punta O3.5 (ore8)"},{id:"qb_o35_ore8",l:"@Banca O3.5 (ore8)"},
  ]},
  {cat:"Quote BF — O/U (5mKO)", items:[
    {id:"qp_u15",l:"@Punta U1.5 (5mKO)"},{id:"qb_u15",l:"@Banca U1.5 (5mKO)"},
    {id:"qp_o15",l:"@Punta O1.5 (5mKO)"},{id:"qb_o15",l:"@Banca O1.5 (5mKO)"},
    {id:"qp_u25",l:"@Punta U2.5 (5mKO)"},{id:"qb_u25",l:"@Banca U2.5 (5mKO)"},
    {id:"qp_o25",l:"@Punta O2.5 (5mKO)"},{id:"qb_o25",l:"@Banca O2.5 (5mKO)"},
    {id:"qp_u35",l:"@Punta U3.5 (5mKO)"},{id:"qb_u35",l:"@Banca U3.5 (5mKO)"},
    {id:"qp_o35",l:"@Punta O3.5 (5mKO)"},{id:"qb_o35",l:"@Banca O3.5 (5mKO)"},
  ]},
  {cat:"Quote BF — BTTS (ore8)", items:[
    {id:"qp_btts_si",l:"@Punta BTTS SI (ore8)"},{id:"qb_btts_si",l:"@Banca BTTS SI (ore8)"},
    {id:"qp_btts_no",l:"@Punta BTTS NO (ore8)"},{id:"qb_btts_no",l:"@Banca BTTS NO (ore8)"},
  ]},
  {cat:"Rating ELO", items:[
    {id:"rating_home",l:"ELO Home"},{id:"rating_away",l:"ELO Away"},{id:"d_rating",l:"Delta ELO (H-A)"},
    {id:"frating_home",l:"Fascia ELO Home"},{id:"frating_away",l:"Fascia ELO Away"},
    {id:"scontro_frating",l:"Fascia ELO Scontro (H/A)"},
  ]},
  {cat:"Fascia Classifica", items:[
    {id:"fclass_home",l:"Fascia Classifica Home"},{id:"fclass_away",l:"Fascia Classifica Away"},
    {id:"scontro_fclass",l:"Fascia Classifica Scontro (H/A)"},
  ]},
  {cat:"Colori Forma L6", items:[
    {id:"colore_l6_home",l:"Colore L6 Home"},{id:"colore_l6_away",l:"Colore L6 Away"},
    {id:"scontro_colore_l6",l:"Colori L6 Scontro (H/A)"},
  ]},
  {cat:"Trend Last 5", items:[
    {id:"gc_gt_l5",l:"GolH-GolA Last 5"},
    {id:"tmp_l5_stag_home",l:"Trend MP Home@Home"},{id:"tmp_l5_stag_away",l:"Trend MP Away@Away"},
    {id:"tp_l5_sl5_home",l:"Trend Punti Home"},{id:"tp_l5_sl5_away",l:"Trend Punti Away"},
  ]},
  {cat:"Neoaggiunte", items:[
    {id:"home_neoagg",l:"NeoAgg Home"},{id:"away_neoagg",l:"NeoAgg Away"},
  ]},
  {cat:"Varie", items:[
    {id:"mese",l:"Mese"},
    {id:"lega",l:"Campionato"},
    {id:"stagione",l:"Stagione"},
  ]},
];

// Visualizzazione di default (Ripristina visuale)
const DEFAULT_PARAMS = new Set([
  "q_1_ore9","q_x_ore9","q_2_ore9","aggio_bf",
  "lega","colore_l6_home","colore_l6_away","scontro_colore_l6"
]);
const getDefaultMercati = () => {
  const init = {};
  MERCATI.forEach(m => { init[m.id] = m.g === "1X2 ore9" ? 1 : 0; });
  return init;
};

// Stati mercato: 0=OFF, 1=VIS, 2=PUNTA, 3=BANCA
const STATI = ["off","vis","punta","banca"];
const STATI_LABEL = ["OFF","VIS","PUN","BAN"];

// ===== BLOCCHI CON DATA DI NASCITA (D870/D871) =====
// Mercati e parametri che non coprono tutto lo storico.
// La data mostrata all'utente e' sempre la piu' recente fra i blocchi toccati.
const BLOCCHI_DATATI = [
  {
    id: "ore8",
    nome: "ore 8",
    data: "28/10/2022",
    dal: "dal 28/10/2022",
    ordine: 2,
    mercati: [
      "1_ore8","x_ore8","2_ore8",
      "u15_ore8","o15_ore8","u25_ore8","o25_ore8","u35_ore8","o35_ore8",
      "btts_si","btts_no",
    ],
    parametri: [
      "q_1_ore8","q_x_ore8","q_2_ore8","qb_1_ore8","qb_x_ore8","qb_2_ore8",
      "qp_u15_ore8","qb_u15_ore8","qp_o15_ore8","qb_o15_ore8",
      "qp_u25_ore8","qb_u25_ore8","qp_o25_ore8","qb_o25_ore8",
      "qp_u35_ore8","qb_u35_ore8","qp_o35_ore8","qb_o35_ore8",
      "qp_btts_si","qb_btts_si","qp_btts_no","qb_btts_no",
    ],
  },
  {
    id: "5mko",
    nome: "5 minuti dal via",
    data: "08/09/2017",
    dal: "dall'08/09/2017",
    ordine: 1,
    mercati: [
      "1_5mko","x_5mko","2_5mko",
      "u15_5mko","o15_5mko","u25_5mko","o25_5mko","u35_5mko","o35_5mko",
    ],
    parametri: [
      "qp_1","qp_x","qp_2","qb_1","qb_x","qb_2",
      "qp_u15","qb_u15","qp_o15","qb_o15",
      "qp_u25","qb_u25","qp_o25","qb_o25",
      "qp_u35","qb_u35","qp_o35","qb_o35",
      "d_q_1","d_q_x","d_q_2",
    ],
  },
];

function getParamLabel(id) {
  for (const cat of PARAMETRI) {
    for (const item of cat.items) {
      if (item.id === id) return item.l;
    }
  }
  return id;
}

const COL_PL_LABELS = {
  "pl_p1_ore8":"P1 ore8","pl_b1_ore8":"B1 ore8",
  "pl_px_ore8":"PX ore8","pl_bx_ore8":"BX ore8",
  "pl_p2_ore8":"P2 ore8","pl_b2_ore8":"B2 ore8",
  "pl_p1_ore9":"P1 ore9","pl_b1_ore9":"B1 ore9",
  "pl_px_ore9":"PX ore9","pl_bx_ore9":"BX ore9",
  "pl_p2_ore9":"P2 ore9","pl_b2_ore9":"B2 ore9",
  "pl_qp_1":"P1 5mKO","pl_qb_1":"B1 5mKO",
  "pl_qp_x":"PX 5mKO","pl_qb_x":"BX 5mKO",
  "pl_qp_2":"P2 5mKO","pl_qb_2":"B2 5mKO",
  "pl_p_u15_ore8":"P U1.5 ore8","pl_b_u15_ore8":"B U1.5 ore8",
  "pl_p_o15_ore8":"P O1.5 ore8","pl_b_o15_ore8":"B O1.5 ore8",
  "pl_p_u25_ore8":"P U2.5 ore8","pl_b_u25_ore8":"B U2.5 ore8",
  "pl_p_o25_ore8":"P O2.5 ore8","pl_b_o25_ore8":"B O2.5 ore8",
  "pl_p_u35_ore8":"P U3.5 ore8","pl_b_u35_ore8":"B U3.5 ore8",
  "pl_p_o35_ore8":"P O3.5 ore8","pl_b_o35_ore8":"B O3.5 ore8",
  "pl_qp_u15":"P U1.5 5mKO","pl_qb_u15":"B U1.5 5mKO",
  "pl_qp_o15":"P O1.5 5mKO","pl_qb_o15":"B O1.5 5mKO",
  "pl_qp_u25":"P U2.5 5mKO","pl_qb_u25":"B U2.5 5mKO",
  "pl_qp_o25":"P O2.5 5mKO","pl_qb_o25":"B O2.5 5mKO",
  "pl_qp_u35":"P U3.5 5mKO","pl_qb_u35":"B U3.5 5mKO",
  "pl_qp_o35":"P O3.5 5mKO","pl_qb_o35":"B O3.5 5mKO",
  "pl_p_btts_si":"P BTTS SI","pl_b_btts_si":"B BTTS SI",
  "pl_p_btts_no":"P BTTS NO","pl_b_btts_no":"B BTTS NO",
};
function fmtCol(c) {
  return COL_PL_LABELS[c] || c;
}

// Mapping mercato_id → [col_punta, col_banca] (allineato a power_engine.py)
const MERCATI_PL_MAP = {
  "1_ore8":   ["pl_p1_ore8",  "pl_b1_ore8"],
  "x_ore8":   ["pl_px_ore8",  "pl_bx_ore8"],
  "2_ore8":   ["pl_p2_ore8",  "pl_b2_ore8"],
  "1_ore9":   ["pl_p1_ore9",  "pl_b1_ore9"],
  "x_ore9":   ["pl_px_ore9",  "pl_bx_ore9"],
  "2_ore9":   ["pl_p2_ore9",  "pl_b2_ore9"],
  "1_5mko":   ["pl_qp_1",     "pl_qb_1"],
  "x_5mko":   ["pl_qp_x",     "pl_qb_x"],
  "2_5mko":   ["pl_qp_2",     "pl_qb_2"],
  "u15_ore8": ["pl_p_u15_ore8","pl_b_u15_ore8"],
  "o15_ore8": ["pl_p_o15_ore8","pl_b_o15_ore8"],
  "u25_ore8": ["pl_p_u25_ore8","pl_b_u25_ore8"],
  "o25_ore8": ["pl_p_o25_ore8","pl_b_o25_ore8"],
  "u35_ore8": ["pl_p_u35_ore8","pl_b_u35_ore8"],
  "o35_ore8": ["pl_p_o35_ore8","pl_b_o35_ore8"],
  "u15_5mko": ["pl_qp_u15",   "pl_qb_u15"],
  "o15_5mko": ["pl_qp_o15",   "pl_qb_o15"],
  "u25_5mko": ["pl_qp_u25",   "pl_qb_u25"],
  "o25_5mko": ["pl_qp_o25",   "pl_qb_o25"],
  "u35_5mko": ["pl_qp_u35",   "pl_qb_u35"],
  "o35_5mko": ["pl_qp_o35",   "pl_qb_o35"],
  "btts_si":  ["pl_p_btts_si","pl_b_btts_si"],
  "btts_no":  ["pl_p_btts_no","pl_b_btts_no"],
};

function heatBg(val, maxAbs) {
  if (!val || !maxAbs) return {};
  const intensity = Math.min(Math.abs(val) / maxAbs, 1);
  const alpha = 0.06 + intensity * 0.35;
  if (val > 0) return { backgroundColor: `rgba(22,163,74,${alpha})` };
  return { backgroundColor: `rgba(220,38,38,${alpha})` };
}

function FmtVal({ v }) {
  if (v === 0 || v === undefined || v === null) {
    return <span style={{color:"#A3A39E"}}>—</span>;
  }
  const cls = v > 0 ? "val-pos" : "val-neg";
  return <span className={cls}>{v > 0 ? "+" : ""}{v.toFixed(2)}</span>;
}

function fmtRange(v1, v2) {
  if (v2 === null || v2 === undefined) return String(v1);
  const f = n => (Number.isInteger(n) || Math.abs(n) >= 10) ? String(n) : n.toFixed(2);
  return `> ${f(v1)}  |  ≤ ${f(v2)}`;
}

// ===== STORICO REVISIONI: confronto fra i filtri di due revisioni =====
// _mercati_stato non e' un filtro (memorizza i mercati accesi) e resta fuori.
function filtriVisibili(filtri) {
  const out = {};
  Object.entries(filtri || {}).forEach(([k, v]) => {
    if (k !== "_mercati_stato" && v) out[k] = v;
  });
  return out;
}

function elencoFiltriRev(filtri) {
  return Object.entries(filtriVisibili(filtri))
    .map(([pid, cfg]) => ({ paramId: pid, ...fmtFiltro(pid, cfg) }))
    .sort((a, b) => a.label.localeCompare(b.label));
}

function differenzeRev(filtriPrec, filtriCorr) {
  const prec = filtriVisibili(filtriPrec);
  const corr = filtriVisibili(filtriCorr);
  const chiavi = Array.from(new Set([...Object.keys(prec), ...Object.keys(corr)]));
  const diff = [];
  chiavi.forEach(pid => {
    const a = prec[pid], b = corr[pid];
    if (a && !b) {
      diff.push({ tipo: "tolto", paramId: pid, ...fmtFiltro(pid, a) });
    } else if (!a && b) {
      diff.push({ tipo: "aggiunto", paramId: pid, ...fmtFiltro(pid, b) });
    } else if (a && b && JSON.stringify(a) !== JSON.stringify(b)) {
      const da = fmtFiltro(pid, a), al = fmtFiltro(pid, b);
      diff.push({ tipo: "modificato", paramId: pid, label: al.label, desc: al.desc, descPrec: da.desc });
    }
  });
  return diff.sort((a, b) => a.label.localeCompare(b.label));
}

const COLORI_DIFF = {
  tolto:      { bg:"#EEEDFE", fg:"#534AB7", fg2:"#26215C", pallino:"#7F77DD", titolo:"Filtro rimosso" },
  aggiunto:   { bg:"#E6F1FB", fg:"#185FA5", fg2:"#042C53", pallino:"#378ADD", titolo:"Nuovo filtro" },
  modificato: { bg:"#FAEEDA", fg:"#854F0B", fg2:"#412402", pallino:"#BA7517", titolo:"Filtro modificato" },
};

function fmtFiltro(paramId, config) {
  const label = getParamLabel(paramId);
  const f = n => (n !== null && n !== undefined && n.toFixed)
    ? (Math.abs(n) >= 10 || Number.isInteger(n) ? String(n) : n.toFixed(2).replace(".",","))
    : String(n);
  // Compatta intervalli adiacenti (A.max == B.min) e restituisce array ordinato
  const compattaIntervalli = (arr) => {
    const sorted = [...arr].map(i => ({ min: i.min, max: i.max })).sort((a, b) => a.min - b.min);
    const merged = [];
    for (const iv of sorted) {
      const last = merged[merged.length - 1];
      if (last && iv.min === last.max) {
        last.max = iv.max;
      } else {
        merged.push({ ...iv });
      }
    }
    return merged;
  };
  const parts = [];
  if (config.includi && config.includi.length) {
    if (config.tipo === "intervallo") {
      const merged = compattaIntervalli(config.includi.filter(v => !naVoce(v)));
      const pezzi = merged.map(iv =>
        iv.min === iv.max ? `Uguale a ${f(iv.min)}` : `> ${f(iv.min)} e ≤ ${f(iv.max)}`
      );
      if (config.includi.some(naVoce)) pezzi.push("N.A.");
      parts.push(pezzi.join("; "));
    } else {
      parts.push(`= ${config.includi.join(", ")}`);
    }
  }
  if (config.escludi && config.escludi.length) {
    if (config.tipo === "intervallo") {
      const merged = compattaIntervalli(config.escludi.filter(v => !naVoce(v)));
      const pezzi = merged.map(iv =>
        iv.min === iv.max ? `Escluso ${f(iv.min)}` : `≠ > ${f(iv.min)} e ≤ ${f(iv.max)}`
      );
      if (config.escludi.some(naVoce)) pezzi.push("Escluso N.A.");
      parts.push(pezzi.join("; "));
    } else {
      parts.push(`≠ ${config.escludi.join(", ")}`);
    }
  }
  return { label, desc: parts.join(" | ") };
}

// ===== PARAMETRI SCONTRO (tipo speciale: combinazione home/away) =====
const PARAMETRI_SCONTRO = ["scontro_frating", "scontro_fclass", "scontro_colore_l6"];

// ===== RIGA N.A. (cella vuota) =====
// La matrice mette sempre in fondo una riga N.A. con le partite senza quel
// dato. Su un parametro a intervalli non e' una fascia: viaggia nel filtro
// come voce {na:true}, che il motore riconosce.
const naRiga = (r) => !!r && String(r.v1) === "N.A." && (r.v2 === null || r.v2 === undefined);
const naVoce = (v) => !!v && typeof v === "object" && v.na === true;
// Riga N.A. dei parametri dove il vuoto non e' uno stato ma un dato che non
// c'era (quote, differenze, aggio). Il motore esclude gia' quelle partite
// appena su quella colonna c'e' un filtro, quindi spuntarla non darebbe
// nessun evento: si mostra col suo nome e con il conteggio — serve a far
// quadrare il totale — ma non si seleziona. Il nome lo decide il backend.
const naBloccata = (r) => !!r && r.senza_dato === true;
const TITOLO_NA_BLOCCATA = "Per queste partite il dato non esiste. Non entrano in nessun filtro su questo parametro.";
// Il tipo di filtro dipende dal PARAMETRO, non dalla riga spuntata per prima.
const tipoParametro = (paramId, righe) =>
  PARAMETRI_SCONTRO.includes(paramId) ? "scontro"
    : (righe || []).some(r => r && r.v2 !== null && r.v2 !== undefined) ? "intervallo"
    : "elenco";
const voceFiltro = (tipoP, r) =>
  tipoP !== "intervallo" ? r.v1
    : naRiga(r) ? { na: true }
    : { min: Number(r.v1), max: Number(r.v2) };
// Allinea un filtro gia' presente al tipo del parametro, convertendo le voci
// N.A. scritte nella forma vecchia. Se il tipo coincide non tocca nulla.
const allineaTipo = (f, tipoP) => {
  if (!f) return { tipo: tipoP, includi: [], escludi: [] };
  if (f.tipo === tipoP) return { ...f };
  const conv = (lista) => (lista || []).map(v =>
    (tipoP === "intervallo" && String(v) === "N.A.") ? { na: true } : v);
  return { ...f, tipo: tipoP, includi: conv(f.includi), escludi: conv(f.escludi) };
};

// ===== STILI COMUNI =====
const thStyle = {
  position:"sticky",top:0,background:"#fff",color:"#6B6B66",
  padding:"8px 8px",textAlign:"right",fontSize:11,fontWeight:600,
  whiteSpace:"nowrap",borderBottom:"2px solid #E8E8E4",
  textTransform:"uppercase",letterSpacing:"0.04em",zIndex:10,
  boxShadow:"0 2px 4px rgba(0,0,0,0.06)",
};
const tdStyle = {
  padding:"4px 8px",borderBottom:"1px solid #F0F0EC",
  fontFamily:"'Roboto Mono',monospace",fontSize:11,
};
const btnBase = {
  fontFamily:"'DM Sans',sans-serif",fontSize:12,fontWeight:600,
  border:"none",borderRadius:6,padding:"6px 14px",cursor:"pointer",
  display:"inline-flex",alignItems:"center",gap:4,
};
const btnPrimary = {...btnBase,background:"#2563EB",color:"#fff"};
const btnForza = {...btnBase,background:"#16A34A",color:"#fff"};
const btnEscludi = {...btnBase,background:"#DC2626",color:"#fff"};
const btnGhost = {...btnBase,background:"transparent",color:"#6B6B66",border:"1px solid #E8E8E4"};
const btnSave = {...btnBase,background:"#16A34A",color:"#fff"};
const btnNew = {...btnBase,background:"#2563EB",color:"#fff"};
const modalLabel = {fontSize:11,fontWeight:600,color:"#6B6B66",display:"block",marginBottom:4,marginTop:12};
const modalInput = {
  width:"100%",border:"1px solid #E8E8E4",borderRadius:6,padding:"8px 10px",
  fontSize:13,fontFamily:"'DM Sans',sans-serif",outline:"none",
};

// Inject CSS
if (typeof document !== "undefined" && !document.getElementById("inv-styles")) {
  const style = document.createElement("style");
  style.id = "inv-styles";
  style.textContent = `
    @keyframes progress-pulse {
      0% { transform: translateX(-100%); }
      50% { transform: translateX(60%); }
      100% { transform: translateX(200%); }
    }
    .val-pos { color: #16A34A; font-weight: 600; }
    .val-neg { color: #DC2626; font-weight: 600; }
    .toolbar-group { display:flex; flex-direction:column; align-items:center; gap:2px; }
    .toolbar-group-label {
      font-size:9px; font-weight:700; color:#1A1A18;
      text-transform:uppercase; letter-spacing:0.08em;
      margin-top:2px;
    }
    .toolbar-group-btns { display:flex; gap:2px; align-items:flex-end; }
    .toolbar-sep {
      width:1px; background:#E8E8E4; align-self:stretch; margin:0 8px;
    }
    .tb-btn {
      display:flex; flex-direction:column; align-items:center; justify-content:center;
      gap:3px; padding:5px 10px; border:none; border-radius:6px;
      cursor:pointer; background:transparent; min-width:46px;
      font-family:'DM Sans',sans-serif; transition:background 0.12s;
    }
    .tb-btn:hover { background:#F0F4FF; }
    .tb-btn:disabled { opacity:0.35; cursor:default; }
    .tb-btn:disabled:hover { background:transparent; }
    .tb-btn-icon { font-size:18px; line-height:1; }
    .tb-btn-label { font-size:10px; font-weight:700; white-space:nowrap; }
    .tb-btn-wide { min-width:56px; }
    .param-dropdown {
      position:absolute; top:calc(100% + 4px); left:0;
      background:#fff; border:1.5px solid #E0E0DA; border-radius:10px;
      box-shadow:0 8px 32px rgba(0,0,0,0.12);
      z-index:200; min-width:340px; max-height:400px;
      overflow-y:auto; padding:8px 0;
    }
  `;
  document.head.appendChild(style);
}

// ===== D882 — memoria di sessione =====
// Vive fuori dal componente, quindi sopravvive al cambio di pagina; vive
// dentro il modulo, quindi F5 e chiusura del browser la azzerano. Voluto:
// a distanza di tempo, vedere a schermo filtri non salvati senza saperlo
// sarebbe peggio che ricominciare.
let memoriaSessione = null;

export default function CreazioneSistemi({ onNavigate }) {
  // ===== STATO =====
  const [parametro, setParametro] = useState("");
  const [usaSingolo, setUsaSingolo] = useState(false);
  const [mercatiStato, setMercatiStato] = useState(() => getDefaultMercati());
  const [filtri, setFiltri] = useState({});
  const [risultato, setRisultato] = useState(null);
  const [risultatiMulti, setRisultatiMulti] = useState([]);
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [sommaMode, setSommaMode] = useState(true);
  const [loading, setLoading] = useState(false);
  const [errore, setErrore] = useState(null);
  const [hasCalcolato, setHasCalcolato] = useState(false);
  const [multiParams, setMultiParams] = useState(new Set(DEFAULT_PARAMS));
  const [paramsUltimoCalcolo, setParamsUltimoCalcolo] = useState(new Set());
  const [pannelloAperto, setPannelloAperto] = useState(false);
  const [accordionOpen, setAccordionOpen] = useState(() => {
    const init = {};
    PARAMETRI.forEach(cat => { init[cat.cat] = false; });
    return init;
  });
  const [filtriBarraAperta, setFiltriBarraAperta] = useState(true);
  const [parametriBarraAperta, setParametriBarraAperta] = useState(true);
  const [mercatiBarraAperta, setMercatiBarraAperta] = useState(true);
  const [undoStack, setUndoStack] = useState([]);
  const [redoStack, setRedoStack] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [sysId, setSysId] = useState("");
  const [sysIdOriginale, setSysIdOriginale] = useState(""); // ID originale al caricamento (per gestire rename su PUT)
  const [sysNome, setSysNome] = useState("");
  const [sysComm, setSysComm] = useState("");
  const [sysAttivo, setSysAttivo] = useState(false);
  const [sysDataAttiv, setSysDataAttiv] = useState(null);
  const [sysDataSosp, setSysDataSosp] = useState(null);
  const [sysEsisteInDb, setSysEsisteInDb] = useState(false);
  const [revInfo, setRevInfo] = useState(null);
  const [storicoRevAperto, setStoricoRevAperto] = useState(false);
  const [annullamentoRevInCorso, setAnnullamentoRevInCorso] = useState(false);
  const [nascondiNonAttiviArch, setNascondiNonAttiviArch] = useState(false);
  const [editDataAttiv, setEditDataAttiv] = useState(false);
  const [bozzaDataAttiv, setBozzaDataAttiv] = useState("");
  const [isNuovoSistema, setIsNuovoSistema] = useState(true);
  const [sistemiSalvati, setSistemiSalvati] = useState([]);
  const [sistemiDrawerAperto, setSistemiDrawerAperto] = useState(false);
  const [progressoCalcolo, setProgressoCalcolo] = useState({ completati: 0, totale: 0 });
  const [statSistema, setStatSistema] = useState(null);
  const [statLoading, setStatLoading] = useState(false);
  const [statErrore, setStatErrore] = useState(null);
  const [vistaPL, setVistaPL] = useState(false);
  const [vistaPLSortDir, setVistaPLSortDir] = useState("asc"); // asc = peggiori in cima
  const [vistaPLConfirm, setVistaPLConfirm] = useState(null); // { tipo, paramId, label, intervallo, eventi, plSistema, newFiltri }
  const [vistaZone, setVistaZone] = useState(false);
  const [zoneMostraTutte, setZoneMostraTutte] = useState(false);
  const [zoneSortCol, setZoneSortCol] = useState(null); // null = ordine naturale della classifica
  const [zoneSortDir, setZoneSortDir] = useState("desc");
  const [vistaMercati, setVistaMercati] = useState(false);
  const [vistaMercatiSortCol, setVistaMercatiSortCol] = useState(null); // colonna mercato attiva
  const [vistaMercatiSortDir, setVistaMercatiSortDir] = useState("desc"); // desc = migliori in cima
  const [statPannelloAperto, setStatPannelloAperto] = useState(true);
  const [statStagioniAperte, setStatStagioniAperte] = useState(false);
  // Consultazione per stagione: elenco delle stagioni accese nella tabellina
  // Breakdown. Vuoto = si guarda l'intera storia del sistema.
  const [stagioniVista, setStagioniVista] = useState([]);

  // --- LISTA STANDBY ---
  // Ogni riga: { id, paramId, label, v1, v2, aperto, dett, dettLoading, dettErr }
  // Se sia applicata o no NON si memorizza: si legge dai filtri attivi (versoApplicatoDi).
  // I numeri NON sono mai memorizzati: si ricalcolano a ogni render sul sistema corrente.
  const [standby, setStandby] = useState([]);
  const [standbyOpen, setStandbyOpen] = useState(false);
  const [tenutaOpen, setTenutaOpen] = useState(false);
  const [tenutaSel, setTenutaSel] = useState(null);
  const [tenutaDati, setTenutaDati] = useState(null);
  const [tenutaLoading, setTenutaLoading] = useState(false);
  const [tenutaErrore, setTenutaErrore] = useState(null);
  const [standbyAnnullaInfo, setStandbyAnnullaInfo] = useState({});
  const standbySeq = useRef(1);
  const statReqSeq = useRef(0);
  const standbyCaricatoPer = useRef(null);
  const standbyInVolo = useRef(new Set());

  // --- WHAT IF ---
  const [whatifOpen, setWhatifOpen] = useState(false);
  const [whatifLato, setWhatifLato] = useState("punta");
  const [whatifDati, setWhatifDati] = useState(null);
  const [whatifLoading, setWhatifLoading] = useState(false);
  const [whatifErrore, setWhatifErrore] = useState(null);
  const [whatifFiltriHash, setWhatifFiltriHash] = useState("");

  const paramDropdownRef = useRef(null);

  // ===== IMPOSTAZIONI — Drawer Parametri + Filtro dropdown =====
  const [drawerParametriAperto, setDrawerParametriAperto] = useState(false);
  const [filtroAperto, setFiltroAperto] = useState(false);
  const [filtroParams, setFiltroParams] = useState(new Set());
  const [defaultParams, setDefaultParams] = useState(new Set(DEFAULT_PARAMS));
  const [drawerAccordionOpen, setDrawerAccordionOpen] = useState(() => {
    const init = {};
    PARAMETRI.forEach(cat => { init[cat.cat] = false; });
    return init;
  });
  const [filtroAccordionOpen, setFiltroAccordionOpen] = useState(() => {
    const init = {};
    PARAMETRI.forEach(cat => { init[cat.cat] = false; });
    return init;
  });
  const filtroDropdownRef = useRef(null);

  // ===== ORDINAMENTO COLONNE MATRICE =====
  const [sortCol, setSortCol] = useState(null);
  const [sortDir, setSortDir] = useState(null);
  const [recalcPending, setRecalcPending] = useState(false);

  // ===== INPUT PERSONALIZZATO MATRICE =====
  // customInput: { [paramId]: { valore:"", da:"", a:"", opDa:">", opA:"≤" } }
  const [customInput, setCustomInput] = useState({});
  const getCI = (pid) => customInput[pid] || { valore:"", da:"", a:"", opDa:">", opA:"≤" };
  const setCI = (pid, field, val) => {
    setCustomInput(prev => {
      const cur = prev[pid] || { valore:"", da:"", a:"", opDa:">", opA:"≤" };
      return { ...prev, [pid]: { ...cur, [field]: val } };
    });
  };
  const resetCI = (pid) => {
    setCustomInput(prev => {
      const next = { ...prev };
      delete next[pid];
      return next;
    });
  };
  const applicaCustomInput = (pid, tipo) => {
    const ci = getCI(pid);
    const v = ci.valore.trim();
    const da = ci.da.trim();
    const a = ci.a.trim();
    // Validazione: almeno un campo compilato
    if (!v && !da && !a) return;
    pushUndo();
    const newFiltri = { ...filtri };
    if (!newFiltri[pid]) {
      newFiltri[pid] = { tipo: "intervallo", includi: [], escludi: [] };
    }
    const fkey = tipo === "forza" ? "includi" : "escludi";
    let entry;
    if (v) {
      // Valore esatto: min = max = valore con >= e <=
      const num = parseFloat(v.replace(",", "."));
      if (isNaN(num)) return;
      entry = { min: num, max: num, opMin: "≥", opMax: "≤" };
    } else {
      // Intervallo personalizzato
      const numDa = da ? parseFloat(da.replace(",", ".")) : null;
      const numA = a ? parseFloat(a.replace(",", ".")) : null;
      if (da && isNaN(numDa)) return;
      if (a && isNaN(numA)) return;
      entry = {
        min: numDa !== null ? numDa : -999999,
        max: numA !== null ? numA : 999999,
        opMin: ci.opDa,
        opMax: ci.opA
      };
    }
    newFiltri[pid][fkey] = [...(newFiltri[pid][fkey] || []), entry];
    setFiltri(newFiltri);
    resetCI(pid);
    calcola(newFiltri);
  };
  const toggleSortCol = (colId) => {
    if (sortCol !== colId) { setSortCol(colId); setSortDir("desc"); }
    else if (sortDir === "desc") { setSortDir("asc"); }
    else { setSortCol(null); setSortDir(null); }
  };

  const sortRows = (righe) => {
    if (!sortCol || !sortDir) return righe;
    const mapped = righe.map((r, idx) => ({ r, idx }));
    mapped.sort((a, b) => {
      const va = sommaMode ? (a.r.mercati[sortCol]||0) : (a.r.eventi>0 ? (a.r.mercati[sortCol]||0)/a.r.eventi : 0);
      const vb = sommaMode ? (b.r.mercati[sortCol]||0) : (b.r.eventi>0 ? (b.r.mercati[sortCol]||0)/b.r.eventi : 0);
      return sortDir === "desc" ? vb - va : va - vb;
    });
    return mapped;
  };

  // ===== DRAG SELEZIONE RIGHE =====
  const isDragging = useRef(false);
  const hasDragged = useRef(false);
  const dragStartRow = useRef(null);
  const matriceRef = useRef(null);
  const toolbarRef = useRef(null);

  const handleRowMouseDown = (rowId, e) => {
    if (e.button !== 0) return; // solo click sinistro
    e.preventDefault();
    isDragging.current = true;
    hasDragged.current = false;
    dragStartRow.current = rowId;
  };

  const handleRowMouseEnter = (rowId) => {
    if (!isDragging.current) return;
    if (rowId !== dragStartRow.current) {
      hasDragged.current = true;
      setSelectedRows(prev => {
        const next = new Set(prev);
        if (!next.has(dragStartRow.current)) next.add(dragStartRow.current);
        next.add(rowId);
        return next;
      });
    }
  };

  const handleRowMouseUp = (rowId) => {
    if (!isDragging.current) return;
    isDragging.current = false;
    // Se non ha trascinato → click singolo → toggle
    if (!hasDragged.current) {
      setSelectedRows(prev => {
        const next = new Set(prev);
        if (next.has(rowId)) next.delete(rowId); else next.add(rowId);
        return next;
      });
    }
    dragStartRow.current = null;
  };

  useEffect(() => {
    const handleMouseUp = () => {
      isDragging.current = false;
      dragStartRow.current = null;
    };
    const handleClickOutside = (e) => {
      if (matriceRef.current && !matriceRef.current.contains(e.target)
          && (!toolbarRef.current || !toolbarRef.current.contains(e.target))) {
        setSelectedRows(new Set());
      }
    };
    window.addEventListener("mouseup", handleMouseUp);
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // ===== LOGICA MERCATI =====
  const getConfig = useCallback(() => {
    const vis = [], sys = [];
    Object.entries(mercatiStato).forEach(([id, s]) => {
      if (s >= 1) vis.push(id);
      if (s === 2) sys.push({ mercato: id, tipo: "punta" });
      if (s === 3) sys.push({ mercato: id, tipo: "banca" });
    });
    return { vis, sys, hasSistema: sys.length > 0 };
  }, [mercatiStato]);

  const { vis, sys, hasSistema } = getConfig();
  const inConsultazione = stagioniVista.length > 0;

  const toggleMercato = (id) => {
    pushUndo();
    setStagioniVista([]);
    setMercatiStato(prev => ({ ...prev, [id]: (prev[id] + 1) % 4 }));
  };

  const toggleGruppo = (gruppo) => {
    pushUndo();
    setStagioniVista([]);
    const ids = MERCATI.filter(m => m.g === gruppo).map(m => m.id);
    const allOff = ids.every(id => mercatiStato[id] === 0);
    setMercatiStato(prev => {
      const next = { ...prev };
      ids.forEach(id => { next[id] = allOff ? 1 : 0; });
      return next;
    });
  };

  // ===== UNDO/REDO =====
  const getSnapshot = useCallback(() => ({
    filtri: JSON.parse(JSON.stringify(filtri)),
    parametro,
    mercatiStato: JSON.parse(JSON.stringify(mercatiStato)),
    multiParams: new Set(multiParams),
  }), [filtri, parametro, mercatiStato, multiParams]);

  const pushUndo = useCallback(() => {
    setUndoStack(prev => [...prev, getSnapshot()]);
    setRedoStack([]);
  }, [getSnapshot]);

  const undo = () => {
    if (undoStack.length === 0) return;
    const last = undoStack[undoStack.length - 1];
    setRedoStack(prev => [...prev, getSnapshot()]);
    setFiltri(last.filtri);
    setParametro(last.parametro);
    setMercatiStato(last.mercatiStato);
    if (last.multiParams) setMultiParams(last.multiParams);
    setUndoStack(prev => prev.slice(0, -1));
    if (hasCalcolato) setRecalcPending(true);
  };

  const redo = () => {
    if (redoStack.length === 0) return;
    const last = redoStack[redoStack.length - 1];
    setUndoStack(prev => [...prev, getSnapshot()]);
    setFiltri(last.filtri);
    setParametro(last.parametro);
    setMercatiStato(last.mercatiStato);
    if (last.multiParams) setMultiParams(last.multiParams);
    setRedoStack(prev => prev.slice(0, -1));
    if (hasCalcolato) setRecalcPending(true);
  };


  // ===== CALCOLO =====
  const calcola = async (filtriOverride, paramsOverride, mercatiOverride, stagioniOverride) => {
    const filtriUsati = filtriOverride !== undefined ? filtriOverride : filtri;
    // Cambiare i filtri cambia il sistema: la consultazione per stagione si spegne
    // da sola, cosi' i numeri non restano ristretti senza che si veda piu' perche'.
    const stagioniUsate = stagioniOverride !== undefined
      ? stagioniOverride
      : (filtriOverride !== undefined ? [] : stagioniVista);
    if (stagioniUsate.length === 0 && stagioniVista.length > 0) setStagioniVista([]);
    const baseParams = paramsOverride !== undefined ? paramsOverride : multiParams;
    const paramList = (usaSingolo || baseParams.size === 0)
      ? (parametro ? [parametro] : [])
      : [...baseParams];

    if (paramList.length === 0) {
      setErrore("Seleziona almeno un parametro statistico dal pannello per avviare il calcolo.");
      return;
    }
    setLoading(true);
    setErrore(null);
    setSelectedRows(new Set());
    setSortCol(null);
    setSortDir(null);
    setRisultato(null);
    setRisultatiMulti([]);
    setProgressoCalcolo({ completati: 0, totale: paramList.length });
    try {
      const sysUsati = mercatiOverride !== undefined ? mercatiOverride : sys;
      if (paramList.length === 1 && paramsOverride === undefined) {
        const pid = paramList[0];
        const body = { filtri: filtriUsati, parametro: pid, mercati_visibili: vis, mercati_sistema: sysUsati,
          stagioni_vista: stagioniUsate.length > 0 ? stagioniUsate : null };
        const res = await fetch(`${API}/power/matrice`, {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        if (data.errore) throw new Error(data.errore);
        setProgressoCalcolo({ completati: 1, totale: 1 });
        setRisultato({ ...data, _paramId: pid });
      } else {
        setProgressoCalcolo({ completati: 0, totale: 1 });
        const body = { filtri: filtriUsati, parametri: paramList, mercati_visibili: vis, mercati_sistema: sysUsati,
          stagioni_vista: stagioniUsate.length > 0 ? stagioniUsate : null };
        const res = await fetch(`${API}/power/matrice_multi`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        if (data.errore) throw new Error(data.errore);
        setProgressoCalcolo({ completati: 1, totale: 1 });
        const results = data.risultati.map(r => ({
          paramId: r.parametro_id,
          label: getParamLabel(r.parametro_id),
          data: r,
        }));
        setRisultatiMulti(results);
      }
      setHasCalcolato(true);
      setParamsUltimoCalcolo(new Set(paramList));
      aggiornaStatistiche(filtriUsati, stagioniUsate, sysUsati);
    } catch (e) {
      setErrore(e.message);
    } finally {
      setLoading(false);
    }
  };

  // ===== CONSULTAZIONE PER STAGIONE =====
  // Sola lettura: accende una o piu' stagioni e ricalcola subito, senza toccare
  // i filtri del sistema e senza passare dal pulsante Calcola.
  const toggleStagione = (stag) => {
    const next = stagioniVista.includes(stag)
      ? stagioniVista.filter(x => x !== stag)
      : [...stagioniVista, stag];
    setStagioniVista(next);
    calcola(undefined, undefined, undefined, next);
  };

  const azzeraStagioni = () => {
    if (stagioniVista.length === 0) return;
    setStagioniVista([]);
    calcola(undefined, undefined, undefined, []);
  };

  // Ricalcolo: DISATTIVATO — parte solo premendo "Calcola"
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) { isFirstRender.current = false; return; }
    // Nessun ricalcolo automatico
  }, [filtri, multiParams, parametro, usaSingolo]);

  // Ricalcolo differito per undo/redo (attende aggiornamento stato React)
  useEffect(() => {
    if (recalcPending) {
      setRecalcPending(false);
      calcola();
    }
  }, [recalcPending]);

  // ===== FORZA / ESCLUDI =====
  const forzaEscl = (tipo) => {
    if (selectedRows.size === 0) return;
    pushUndo();
    let rows = [];
    let paramId = risultato?._paramId || parametro;

    if (risultato) {
      rows = [...selectedRows].map(i => risultato.righe[i]).filter(Boolean);
    } else if (risultatiMulti.length > 0) {
      const byParam = {};
      [...selectedRows].forEach(key => {
        const [pid, idx] = key.split("__");
        if (!byParam[pid]) byParam[pid] = [];
        const block = risultatiMulti.find(b => b.paramId === pid);
        if (block) byParam[pid].push(block.data.righe[parseInt(idx)]);
      });
      const newFiltri = { ...filtri };
      Object.entries(byParam).forEach(([pid, pRows]) => {
        const righeP = risultatiMulti.find(b => b.paramId === pid)?.data?.righe || pRows;
        const tipoP = tipoParametro(pid, righeP);
        newFiltri[pid] = allineaTipo(newFiltri[pid], tipoP);
        const key = tipo === "forza" ? "includi" : "escludi";
        newFiltri[pid][key] = [...(newFiltri[pid][key]||[]), ...pRows.map(r => voceFiltro(tipoP, r))];
      });
      setFiltri(newFiltri);
      setSelectedRows(new Set());
      calcola(newFiltri);
      return;
    }

    if (rows.length === 0) return;
    const tipoP = tipoParametro(paramId, risultato?.righe || rows);
    const newFiltri = { ...filtri };
    newFiltri[paramId] = allineaTipo(newFiltri[paramId], tipoP);
    const fkey = tipo === "forza" ? "includi" : "escludi";
    newFiltri[paramId][fkey] = [...(newFiltri[paramId][fkey]||[]), ...rows.map(r => voceFiltro(tipoP, r))];
    setFiltri(newFiltri);
    setSelectedRows(new Set());
    calcola(newFiltri);
  };

  const rimuoviFiltro = (paramKey) => {
    pushUndo();
    const newFiltri = { ...filtri };
    delete newFiltri[paramKey];
    setFiltri(newFiltri);
    if (hasCalcolato) calcola(newFiltri);
  };

  const toggleRow = (i) => {
    setSelectedRows(prev => {
      const next = new Set(prev);
      if (next.has(i)) next.delete(i); else next.add(i);
      return next;
    });
  };

  const getMercatoSistemaLabel = () => {
    const parts = [];
    Object.entries(mercatiStato).forEach(([id, s]) => {
      const m = MERCATI.find(x => x.id === id);
      if (s === 2) parts.push(`Punta ${m.label} ${m.g}`);
      if (s === 3) parts.push(`Banca ${m.label} ${m.g}`);
    });
    return parts.length ? parts.join(" + ") : "Nessuno";
  };

  // ===== SISTEMI =====
  const caricaSistemi = async () => {
    try {
      const res = await fetch(`${API}/sistemi`);
      const data = await res.json();
      setSistemiSalvati(data);
    } catch (e) {
      console.error("Errore caricamento sistemi:", e);
    }
  };

  const caricaStatistiche = async (filtriCorrenti, mercatiSistema, stagioniCorrenti) => {
    if (!mercatiSistema || mercatiSistema.length === 0) return;
    // Vale sempre l'ultima richiesta partita: le risposte in ritardo si scartano.
    const mia = ++statReqSeq.current;
    setStatLoading(true);
    setStatErrore(null);
    try {
      const res = await fetch(`${API}/power/statistiche_sistema`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ filtri: filtriCorrenti, mercati_sistema: mercatiSistema,
          stagioni_vista: (stagioniCorrenti && stagioniCorrenti.length > 0) ? stagioniCorrenti : null }),
      });
      if (mia !== statReqSeq.current) return;
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      if (mia !== statReqSeq.current) return;
      if (data.errore) throw new Error(data.errore);
      // Converte per_stagione (oggetto) in array stagioni
      if (data.per_stagione && !data.stagioni) {
        data.stagioni = Object.entries(data.per_stagione).map(([stagione, v]) => ({
          stagione, ...v
        }));
      }
      setStatSistema(data);
    } catch (e) {
      if (mia !== statReqSeq.current) return;
      setStatErrore(e.message);
    } finally {
      if (mia === statReqSeq.current) setStatLoading(false);
    }
  };

  const caricaSistema = (sys) => {
    pushUndo();
    setStagioniVista([]);
    let mercatiSistema = [];
    let filtriPuliti = {};
    if (sys.filtri) {
      const { _mercati_stato, ...fp } = sys.filtri;
      filtriPuliti = fp;
      setFiltri(filtriPuliti);
      if (_mercati_stato) {
        setMercatiStato(_mercati_stato);
        mercatiSistema = Object.entries(_mercati_stato)
          .filter(([, s]) => s === 2 || s === 3)
          .map(([id, s]) => ({ mercato: id, tipo: s === 2 ? "punta" : "banca" }));
      }
    }
    setSysId(sys.id);
    setSysIdOriginale(sys.id);
    setSysNome(sys.nome);
    setSysComm(sys.commenti || "");
    setSysAttivo(sys.attivo === true);
    setSysDataAttiv(sys.data_attivazione || null);
    setSysDataSosp(sys.data_sospensione || null);
    setSysEsisteInDb(true);
    setIsNuovoSistema(false);
    caricaStandbyDaDb(sys.id);
    caricaRevisioni(sys.id);
    caricaStatistiche(filtriPuliti, mercatiSistema);
    return { filtriPuliti, mercatiSistema };
  };

  const aggiornaStatistiche = (filtriCorrenti, stagioniCorrenti, mercatiOverride) => {
    if (!sysId) return;
    const { vis, sys } = getConfig();
    // Se il calcolo e' partito con mercati propri (caricamento di un sistema),
    // i KPI devono usare quelli: i mercati a schermo sono ancora del sistema precedente.
    const mercatiUsati = (mercatiOverride !== undefined && mercatiOverride !== null)
      ? mercatiOverride : sys;
    if (mercatiUsati.length === 0) return;
    caricaStatistiche(filtriCorrenti, mercatiUsati, stagioniCorrenti);
  };
  const eliminaSistema = async (id) => {
    if (!window.confirm(`Eliminare il sistema "${id}"?`)) return;
    try {
      await fetch(`${API}/sistemi/${id}`, { method: "DELETE" });
      setSistemiSalvati(prev => prev.filter(s => s.id !== id));
      if (sysId === id) { setSysId(""); setSysIdOriginale(""); setSysNome(""); setSysComm(""); }
    } catch (e) {
      alert("Errore eliminazione: " + e.message);
    }
  };

  const oggiISO = () => {
    const d = new Date();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const gg = String(d.getDate()).padStart(2, "0");
    return `${d.getFullYear()}-${mm}-${gg}`;
  };
  const formattaDataIT = (iso) =>
    iso ? String(iso).slice(0, 10).split("-").reverse().join("/") : "";

  const etichettaRev = (() => {
    if (!revInfo || revInfo.numero_corrente === null || revInfo.numero_corrente === undefined) return null;
    const n = revInfo.numero_corrente;
    // La rev. 0 nasce con l'attivazione: la sua data e' gia' scritta in "Attivo dal",
    // ripeterla farebbe sembrare le due cose la stessa data per errore.
    const corr = (revInfo.revisioni || []).find(x => x.numero === n);
    const data = (n > 0 && corr && corr.data_inizio) ? ` dal ${formattaDataIT(corr.data_inizio)}` : "";
    return (
      <span
        onClick={() => setStoricoRevAperto(true)}
        title="Vedi come sono cambiati i filtri"
        style={{fontSize:11,fontWeight:600,color:"#93C5FD",cursor:"pointer",
          borderBottom:"1px dotted #93C5FD"}}>
        rev. {n}{data}
      </span>
    );
  })();

  const annullaUltimaRevisione = async () => {
    const revs = (revInfo && revInfo.revisioni) ? revInfo.revisioni : [];
    if (revs.length < 2) return;
    const ultima = revs[revs.length - 1];
    const precedente = revs[revs.length - 2];
    const ok = window.confirm(
      `Annullare la rev. ${ultima.numero} di ${sysId}?\n\n` +
      `Il sistema torna ai filtri della rev. ${precedente.numero} e la rev. ${ultima.numero} ` +
      `sparisce dallo storico, come se non fosse mai stata creata.`
    );
    if (!ok) return;
    setAnnullamentoRevInCorso(true);
    try {
      const res = await fetch(`${API}/sistemi/${encodeURIComponent(sysId)}/revisioni/annulla-ultima`, { method: "POST" });
      const d = await res.json();
      if (!res.ok || (d && d.errore)) throw new Error((d && d.errore) || `HTTP ${res.status}`);
      const r2 = await fetch(`${API}/sistemi/${encodeURIComponent(sysId)}`);
      const sys = await r2.json();
      if (sys && !sys.errore) {
        const { filtriPuliti, mercatiSistema } = caricaSistema(sys);
        setSistemiSalvati(prev => prev.map(x => x.id === sys.id ? { ...x, ...sys } : x));
        // Come nel Ripristina: la matrice a schermo e' ancora quella dei filtri
        // sostituiti e va rifatta, altrimenti resta un conteggio eventi diverso.
        if (risultato || risultatiMulti.length > 0) calcola(filtriPuliti, undefined, mercatiSistema);
      }
      await caricaRevisioni(sysId);
    } catch (e) {
      alert("Errore annullamento revisione: " + e.message);
    } finally {
      setAnnullamentoRevInCorso(false);
    }
  };

  const testoGiorniScarto = () => {
    const g = revInfo ? revInfo.giorni_scarto : null;
    if (g === null || g === undefined) return "Filtri cambiati, mai confermati";
    if (g === 0) return "Filtri cambiati oggi, mai confermati";
    if (g === 1) return "Filtri cambiati da 1 giorno, mai confermati";
    return `Filtri cambiati da ${g} giorni, mai confermati`;
  };

  const caricaRevisioni = async (id) => {
    if (!id) { setRevInfo(null); return; }
    try {
      const res = await fetch(`${API}/sistemi/${encodeURIComponent(id)}/revisioni`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const d = await res.json();
      setRevInfo(d && !d.errore ? d : null);
    } catch (e) {
      setRevInfo(null);
    }
  };

  const confermaNuovaRevisione = async () => {
    const ok = window.confirm(
      `Confermi i filtri attuali come nuova revisione del sistema ${sysId}?\n\n` +
      `Da oggi la Tenuta dei filtri conta i risultati in un periodo nuovo. ` +
      `I filtri precedenti restano consultabili.`
    );
    if (!ok) return;
    try {
      const res = await fetch(`${API}/sistemi/${encodeURIComponent(sysId)}/revisioni`, { method: "POST" });
      const d = await res.json();
      if (!res.ok || (d && d.errore)) throw new Error((d && d.errore) || `HTTP ${res.status}`);
      await caricaRevisioni(sysId);
    } catch (e) {
      alert("Errore conferma revisione: " + e.message);
    }
  };

  const ripristinaFiltriRevisione = async () => {
    const ok = window.confirm(
      `Rimetti i filtri dell'ultima revisione del sistema ${sysId}?\n\n` +
      `I filtri che hai provato dopo l'ultima revisione vengono sostituiti e non si recuperano.`
    );
    if (!ok) return;
    try {
      const res = await fetch(`${API}/sistemi/${encodeURIComponent(sysId)}/revisioni/ripristina`, { method: "POST" });
      const d = await res.json();
      if (!res.ok || (d && d.errore)) throw new Error((d && d.errore) || `HTTP ${res.status}`);
      const r2 = await fetch(`${API}/sistemi/${encodeURIComponent(sysId)}`);
      const sys = await r2.json();
      if (sys && !sys.errore) {
        const { filtriPuliti, mercatiSistema } = caricaSistema(sys);
        setSistemiSalvati(prev => prev.map(x => x.id === sys.id ? { ...x, ...sys } : x));
        // La matrice a schermo e' ancora quella dei filtri sostituiti: va rifatta,
        // altrimenti resta un conteggio eventi diverso da quello del sistema (v214).
        if (risultato || risultatiMulti.length > 0) calcola(filtriPuliti, undefined, mercatiSistema);
      }
      await caricaRevisioni(sysId);
    } catch (e) {
      alert("Errore ripristino filtri: " + e.message);
    }
  };

  const salvaDataAttivazione = async (nuovaISO) => {
    if (sysDataAttiv && String(sysDataAttiv).slice(0,10) !== nuovaISO) {
      const ok = window.confirm(
        `Stai spostando la data di attivazione dal ${formattaDataIT(sysDataAttiv)} al ${formattaDataIT(nuovaISO)}.\n\n` +
        `La data divide il backtest da quello che il sistema ha fatto da attivo. Spostandola, alcune partite cambiano lato: ` +
        `la Tenuta dei filtri le ricalcolera' tutte, e il giudizio su ogni filtro puo' cambiare.\n\n` +
        `Nessun dato viene modificato: cambia solo come vengono letti.`
      );
      if (!ok) return;
    }
    try {
      const res = await fetch(`${API}/sistemi/${sysId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: sysId, nome: sysNome, attivo: sysAttivo,
          mercato: getMercatoSistemaLabel(),
          commenti: sysComm || null,
          filtri: { ...filtri, _mercati_stato: mercatiStato },
          data_attivazione: nuovaISO,
        }),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setSysDataAttiv(nuovaISO);
      setSistemiSalvati(prev => prev.map(x => x.id === sysId ? { ...x, data_attivazione: nuovaISO } : x));
      setEditDataAttiv(false);
    } catch (e) {
      alert("Errore salvataggio data di attivazione: " + e.message);
    }
  };

  const cambiaStatoSistema = async (id, nuovoValore) => {
    try {
      const res = await fetch(`${API}/sistemi/${id}/stato`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attivo: nuovoValore }),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const agg = await res.json();
      if (agg && agg.errore) throw new Error(agg.errore);
      setSistemiSalvati(prev => prev.map(x => x.id === id ? { ...x, ...agg } : x));
      if (sysId === id) {
        setSysAttivo(agg.attivo === true);
        setSysDataAttiv(agg.data_attivazione || null);
        setSysDataSosp(agg.data_sospensione || null);
        caricaRevisioni(id);
      }
    } catch (e) {
      alert("Errore aggiornamento stato: " + e.message);
    }
  };
  const toggleAttivoSistema = async (s) => cambiaStatoSistema(s.id, !s.attivo);

  const salvaSistema = async () => {
    if (!sysId.trim() || !sysNome.trim()) {
      alert("Inserisci ID e Nome");
      return;
    }
    try {
      const filtriConMercati = { ...filtri, _mercati_stato: mercatiStato };
      const body = {
        id: sysId.trim(),
        nome: sysNome.trim(),
        attivo: sysAttivo,
        mercato: getMercatoSistemaLabel(),
        commenti: sysComm.trim() || null,
        filtri: filtriConMercati,
        data_attivazione: sysDataAttiv || null,
      };
      const url = isNuovoSistema ? `${API}/sistemi` : `${API}/sistemi/${sysIdOriginale.trim() || sysId.trim()}`;
      const method = isNuovoSistema ? "POST" : "PUT";
      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || data.errore || `HTTP ${res.status}`);
      alert(`Sistema ${body.id} salvato!`);
      // Gli appunti presi prima del salvataggio si attaccano ora al sistema
      const idPrecedente = sysIdOriginale.trim();
      if (idPrecedente && idPrecedente !== body.id) {
        try {
          await fetch(`${SUPA_URL}/rest/v1/${SB_TAB}?sistema_id=eq.${encodeURIComponent(idPrecedente)}`,
            { method: "DELETE", headers: sbHeaders() });
        } catch (e) { /* la riga vecchia resta, senza conseguenze */ }
      }
      standbyCaricatoPer.current = body.id;
      await scriviStandbySuDb(body.id, standby);
      setSysId(body.id);
      setSysIdOriginale(body.id);
      setSysEsisteInDb(true);
      setIsNuovoSistema(false);
      setShowModal(false);
      caricaRevisioni(body.id);
    } catch (e) {
      console.error("Errore salvataggio:", e);
      alert("Errore: " + e.message);
    }
  };

  // ===== COMPUTED =====
  const maxAbs = risultato ? Math.max(
    ...risultato.righe.flatMap(r => Object.values(r.mercati).map(v => Math.abs(v || 0))), 1
  ) : 1;

  const haRisultati = risultato !== null || risultatiMulti.length > 0;
  const totaleEventi = risultato
    ? risultato.totale_partite
    : risultatiMulti.length > 0 ? (risultatiMulti[0].data.totale_partite || 0) : 0;

  // ===== VISTA P/L — costruisce righe aggregate da tutti i parametri =====
  const buildVistaPLRighe = () => {
    if (risultatiMulti.length === 0 || !hasSistema) return { righe: [], totale: null };
    const righe = [];
    let totEventi = 0, totPL = 0, totPct = 0;
    risultatiMulti.forEach(({ paramId, label, data }) => {
      (data.righe || []).forEach((row, i) => {
        if (row.eventi === 0) return;
        const plSistema = sommaMode
          ? (row.sistema || 0)
          : (row.eventi > 0 ? +((row.sistema || 0) / row.eventi).toFixed(2) : 0);
        const pct = data.totale_partite > 0 ? (row.eventi / data.totale_partite * 100) : 0;
        righe.push({ paramId, label, row, rowIdx: i, plSistema, pct });
      });
      totEventi = data.totale_partite || 0;
      totPL += (data.totale_sistema || 0);
    });
    // Totale P/L Sistema: usa statSistema.punti che è già corretto
    const totSistema = sommaMode
      ? (statSistema?.punti ?? 0)
      : (statSistema?.ppe ?? 0);
    // Ordina: asc = peggiori in cima (più negativi prima)
    righe.sort((a, b) => vistaPLSortDir === "asc"
      ? a.plSistema - b.plSistema
      : b.plSistema - a.plSistema);
    return { righe, totEventi, totSistema };
  };

  // ===== VISTA P/L MERCATI — righe aggregate da tutti i parametri, colonne = mercati visibili =====
  const buildVistaMercatiRighe = () => {
    if (risultatiMulti.length === 0) return { righe: [], colonnePL: [] };
    // Colonne P/L dei mercati visibili
    const colonnePL = [];
    vis.forEach(mv => {
      if (mv in MERCATI_PL_MAP) {
        const [cp, cb] = MERCATI_PL_MAP[mv];
        colonnePL.push({ mercato: mv, lato: "punta", col: cp });
        colonnePL.push({ mercato: mv, lato: "banca", col: cb });
      }
    });
    const righe = [];
    let totEventi = 0;
    risultatiMulti.forEach(({ paramId, label, data }) => {
      (data.righe || []).forEach((row, i) => {
        if (row.eventi === 0) return;
        const pct = data.totale_partite > 0 ? (row.eventi / data.totale_partite * 100) : 0;
        righe.push({ paramId, label, row, rowIdx: i, pct });
      });
      totEventi = data.totale_partite || 0;
    });
    // Ordina per colonna selezionata
    const sortCol = vistaMercatiSortCol || (colonnePL.length > 0 ? colonnePL[0].col : null);
    if (sortCol) {
      righe.sort((a, b) => {
        const va = sommaMode ? (a.row.mercati?.[sortCol] || 0) : (a.row.eventi > 0 ? (a.row.mercati?.[sortCol] || 0) / a.row.eventi : 0);
        const vb = sommaMode ? (b.row.mercati?.[sortCol] || 0) : (b.row.eventi > 0 ? (b.row.mercati?.[sortCol] || 0) / b.row.eventi : 0);
        return vistaMercatiSortDir === "desc" ? vb - va : va - vb;
      });
    }
    return { righe, colonnePL, totEventi };
  };

  // ===== ZONE CONTINUE — fascia peggiore e migliore per ogni parametro a intervalli =====
  const buildZoneContinue = () => {
    if (risultatiMulti.length === 0 || !hasSistema) {
      return { daEscludere: [], daForzare: [], forzareTot: 0, escludereTot: 0, sysPunti: 0, sysEventi: 0, sysPPE: 0 };
    }
    const sysPunti = statSistema?.punti ?? (risultatiMulti[0]?.data?.totale_sistema ?? 0);
    const sysEventi = risultatiMulti[0]?.data?.totale_partite || 0;
    const sysPPE = sysEventi > 0 ? sysPunti / sysEventi : 0;
    const nStagioni = statSistema?.stagioni?.length || 0;
    const SOGLIA_EVENTI_STAGIONE = 50;
    const sysPerStagione = nStagioni > 0 ? Math.round(sysEventi / nStagioni) : null;

    // Kadane su somma P/L: restituisce indici della sequenza contigua minima e massima
    const estremiContigui = (righe) => {
      let worst = null, best = null;
      let curMin = 0, curMinStart = 0, curMax = 0, curMaxStart = 0;
      righe.forEach((r, i) => {
        const v = r.sistema || 0;
        if (curMin + v > v) { curMin = v; curMinStart = i; } else { curMin = curMin + v; }
        if (worst === null || curMin < worst.pl) worst = { start: curMinStart, end: i, pl: curMin };
        if (curMax + v < v) { curMax = v; curMaxStart = i; } else { curMax = curMax + v; }
        if (best === null || curMax > best.pl) best = { start: curMaxStart, end: i, pl: curMax };
      });
      return { worst, best };
    };

    // Toglie dagli estremi gli intervalli senza eventi (non aggiungono informazione)
    const rifila = (righe, seg) => {
      if (!seg) return null;
      let { start, end } = seg;
      while (start <= end && (righe[start].eventi || 0) === 0) start++;
      while (end >= start && (righe[end].eventi || 0) === 0) end--;
      if (start > end) return null;
      return { start, end };
    };

    const componi = (paramId, label, righe, seg, verso) => {
      const t = rifila(righe, seg);
      if (!t) return null;
      const dentro = righe.slice(t.start, t.end + 1);
      const eventi = dentro.reduce((a, r) => a + (r.eventi || 0), 0);
      if (eventi === 0) return null;
      const pl = +dentro.reduce((a, r) => a + (r.sistema || 0), 0).toFixed(2);
      const ppe = +(pl / eventi).toFixed(2);
      const v1 = righe[t.start].v1;
      const v2 = righe[t.end].v2;
      const dopoPL = verso === "escludi" ? +(sysPunti - pl).toFixed(2) : pl;
      const dopoEventi = verso === "escludi" ? sysEventi - eventi : eventi;
      const dopoPPE = dopoEventi > 0 ? +(dopoPL / dopoEventi).toFixed(2) : 0;
      const dopoPerStagione = nStagioni > 0 ? +(dopoEventi / nStagioni).toFixed(0) : null;
      return {
        paramId, label, v1, v2, eventi, pl, ppe,
        _a: t.start, _b: t.end,
        dopoPL, dopoEventi, dopoPPE, dopoPerStagione,
        sottoSoglia: dopoPerStagione !== null && dopoPerStagione < SOGLIA_EVENTI_STAGIONE,
        varPL: +(dopoPL - sysPunti).toFixed(2),
        varPPE: +(dopoPPE - sysPPE).toFixed(2),
        pct: sysEventi > 0 ? (eventi / sysEventi * 100) : 0,
      };
    };

    // Tutte le fasce contigue di un parametro, poi le migliori N senza sovrapposizioni forti
    const MAX_PER_PARAM = 3;
    const SOGLIA_SOVRAPP = 0.45;
    const miglioriN = (righe, paramId, label, verso) => {
      let primoUtile = 0, ultimoUtile = righe.length - 1;
      while (primoUtile < righe.length && (righe[primoUtile].eventi || 0) === 0) primoUtile++;
      while (ultimoUtile >= 0 && (righe[ultimoUtile].eventi || 0) === 0) ultimoUtile--;
      const cand = [], visti = new Set();
      for (let i = 0; i < righe.length; i++) {
        for (let j = i; j < righe.length; j++) {
          const z = componi(paramId, label, righe, { start: i, end: j }, verso);
          if (!z) continue;
          if (verso === "escludi" && z.pl >= 0) continue;
          if (verso === "escludi" && z._a !== primoUtile && z._b !== ultimoUtile) continue;
          if (verso === "forza" && z.pl <= 0) continue;
          const chiave = `${z._a}_${z._b}`;
          if (visti.has(chiave)) continue;
          visti.add(chiave);
          cand.push(z);
        }
      }
      cand.sort((a, b) => verso === "escludi" ? a.pl - b.pl : b.dopoPL - a.dopoPL);
      const tenute = [];
      cand.forEach(z => {
        if (tenute.length >= MAX_PER_PARAM) return;
        const collide = tenute.some(t => {
          const ov = Math.min(t._b, z._b) - Math.max(t._a, z._a) + 1;
          if (ov <= 0) return false;
          const lung = Math.max(t._b - t._a + 1, z._b - z._a + 1);
          return ov / lung > SOGLIA_SOVRAPP;
        });
        if (!collide) tenute.push(z);
      });
      return tenute;
    };

    const daEscludere = [], forzareTutte = [];
    risultatiMulti.forEach(({ paramId, label, data }) => {
      const tutte = (data.righe || []).filter(r => !naRiga(r));
      if (tutte.length === 0) return;
      if (tutte[0].v2 === null || tutte[0].v2 === undefined) return; // solo parametri a intervalli
      const righe = [...tutte].sort((a, b) => (a.v1 ?? 0) - (b.v1 ?? 0));
      miglioriN(righe, paramId, label, "escludi").forEach(z => daEscludere.push(z));
      miglioriN(righe, paramId, label, "forza").forEach(z => forzareTutte.push(z));
    });

    // Forzature: restano solo le alternative che nessun'altra batte sia sui punti sia sul PPE
    const candidate = forzareTutte.filter(z => z.varPL > 0 || z.varPPE > 0);
    const daForzare = candidate.filter(z => !candidate.some(o =>
      o !== z && o.dopoPL >= z.dopoPL && o.dopoPPE >= z.dopoPPE &&
      (o.dopoPL > z.dopoPL || o.dopoPPE > z.dopoPPE)
    ));

    daEscludere.sort((a, b) => a.pl - b.pl);
    candidate.sort((a, b) => b.dopoPL - a.dopoPL);
    daForzare.sort((a, b) => b.dopoPL - a.dopoPL);

    return {
      daEscludere, daForzare, candidate,
      forzareTot: candidate.length, escludereTot: daEscludere.length,
      sysPunti, sysEventi, sysPPE, nStagioni, sysPerStagione,
      sogliaEventiStagione: SOGLIA_EVENTI_STAGIONE,
    };
  };

  // ===== LISTA STANDBY — misura di una fascia sul sistema di adesso =====
  // Normalizza le due viste (singolo parametro / multi) in un unico elenco di blocchi.
  const blocchiCorrenti = () => {
    if (risultatiMulti.length > 0) return risultatiMulti;
    if (risultato) {
      const pid = risultato._paramId || parametro;
      return [{ paramId: pid, label: getParamLabel(pid), data: risultato }];
    }
    return [];
  };

  const sbSysPunti = statSistema?.punti ?? (blocchiCorrenti()[0]?.data?.totale_sistema ?? 0);
  const sbSysEventi = statSistema?.eventi ?? (blocchiCorrenti()[0]?.data?.totale_partite ?? 0);
  const sbNStagioni = statSistema?.stagioni?.length || 0;
  const SB_SOGLIA_STAGIONE = 50;

  // ── Righe a valore (parametri a elenco e scontro) ────────────────────────
  // Per questi parametri la fascia da–a non esiste: ogni valore è una riga a
  // sé. Le funzioni della Lista Standby reggono entrambe le forme e si
  // distinguono su v2: assente = riga a valore, presente = fascia numerica.
  const sbEValore = (r) => r === null || r === undefined || r.v2 === null || r.v2 === undefined;
  const sbTipoFiltro = (paramId, r) => sbEValore(r)
    ? (PARAMETRI_SCONTRO.includes(paramId) ? "scontro" : "elenco")
    : "intervallo";
  const sbVoce = (r) => sbEValore(r) ? r.v1 : { min: Number(r.v1), max: Number(r.v2) };
  const sbStessaVoce = (e, r) => sbEValore(r)
    ? String(e) === String(r.v1)
    : (e !== null && typeof e === "object" &&
       Number(e.min) === Number(r.v1) && Number(e.max) === Number(r.v2));

  // Misura una fascia [v1, v2] di un parametro sul risultato corrente.
  // Il verso NON è memorizzato: lo decide il segno del P/L della fascia.
  const misuraFascia = (paramId, v1, v2) => {
    const blocco = blocchiCorrenti().find(b => b.paramId === paramId);
    if (!blocco) return null;
    const aValore = v2 === null || v2 === undefined;
    const dentro = (blocco.data?.righe || []).filter(r =>
      aValore
        ? ((r.v2 === null || r.v2 === undefined) && String(r.v1) === String(v1))
        : (r.v2 !== null && r.v2 !== undefined &&
           Number(r.v1) >= Number(v1) - 1e-9 && Number(r.v2) <= Number(v2) + 1e-9)
    );
    if (dentro.length === 0) return null;
    const eventi = dentro.reduce((a, r) => a + (r.eventi || 0), 0);
    const pl = +dentro.reduce((a, r) => a + (r.sistema || 0), 0).toFixed(2);
    const ppe = eventi > 0 ? +(pl / eventi).toFixed(2) : 0;
    const verso = pl < 0 ? "escludi" : "forza";
    const sysPPE = sbSysEventi > 0 ? sbSysPunti / sbSysEventi : 0;
    const dopoPL = verso === "escludi" ? +(sbSysPunti - pl).toFixed(2) : pl;
    const dopoEventi = verso === "escludi" ? sbSysEventi - eventi : eventi;
    const dopoPPE = dopoEventi > 0 ? dopoPL / dopoEventi : 0;
    const dopoPerStagione = sbNStagioni > 0 ? +(dopoEventi / sbNStagioni).toFixed(0) : null;
    return {
      eventi, pl, ppe, verso, dopoPL, dopoEventi, dopoPPE, dopoPerStagione,
      sottoSoglia: dopoPerStagione !== null && dopoPerStagione < SB_SOGLIA_STAGIONE,
      varPL: +(dopoPL - sbSysPunti).toFixed(2),
      varPPE: dopoPPE - sysPPE,
    };
  };

  // Raggruppa le righe selezionate in fasce contigue.
  // Le righe senza eventi in mezzo fanno da ponte, non spezzano la fascia.
  const fasceDaSelezione = () => {
    const perParam = {};
    if (risultato && risultatiMulti.length === 0) {
      const pid = risultato._paramId || parametro;
      perParam[pid] = { label: getParamLabel(pid), idx: [...selectedRows].filter(i => typeof i === "number"), righe: risultato.righe || [] };
    } else {
      [...selectedRows].forEach(key => {
        if (typeof key !== "string") return;
        const [pid, idx] = key.split("__");
        const blocco = risultatiMulti.find(b => b.paramId === pid);
        if (!blocco) return;
        if (!perParam[pid]) perParam[pid] = { label: blocco.label, idx: [], righe: blocco.data?.righe || [] };
        perParam[pid].idx.push(parseInt(idx));
      });
    }
    const fasce = [];
    Object.entries(perParam).forEach(([pid, info]) => {
      const righe = info.righe;
      if (righe.length === 0) return;
      if (righe[0].v2 === null || righe[0].v2 === undefined) {
        // Parametro a valori: nessuna fusione di righe contigue, una riga per
        // valore scelto. La riga N.A. non entra: non è un valore filtrabile.
        info.idx.forEach(i => {
          const r = righe[i];
          if (!r || String(r.v1) === "N.A.") return;
          fasce.push({ paramId: pid, label: info.label, v1: r.v1, v2: null });
        });
        return;
      }
      const ordinate = righe.map((r, i) => ({ r, i })).filter(o => !naRiga(o.r))
        .sort((a, b) => (a.r.v1 ?? 0) - (b.r.v1 ?? 0));
      const posDi = new Map();
      ordinate.forEach((o, pos) => posDi.set(o.i, pos));
      const posSel = info.idx.map(i => posDi.get(i)).filter(p => p !== undefined).sort((a, b) => a - b);
      if (posSel.length === 0) return;
      let start = posSel[0], prev = posSel[0];
      const chiudi = (a, b) => fasce.push({
        paramId: pid, label: info.label,
        v1: ordinate[a].r.v1, v2: ordinate[b].r.v2,
      });
      for (let k = 1; k < posSel.length; k++) {
        const p = posSel[k];
        let ponte = true;
        for (let q = prev + 1; q < p; q++) {
          if ((ordinate[q].r.eventi || 0) !== 0) { ponte = false; break; }
        }
        if (!ponte) { chiudi(start, prev); start = p; }
        prev = p;
      }
      chiudi(start, prev);
    });
    return fasce;
  };

  // Una riga è applicata se la sua fascia si trova DAVVERO fra i filtri attivi.
  // Così se il filtro viene tolto dalla barra in alto, la riga se ne accorge da sola.
  const versoApplicatoDi = (riga) => {
    const b = filtri[riga.paramId];
    if (!b) return null;
    const dentro = lista => (lista || []).some(e => sbStessaVoce(e, riga));
    if (dentro(b.escludi)) return "escludi";
    if (dentro(b.includi)) return "forza";
    return null;
  };

  const aggiungiFasce = (fasce) => {
    if (!fasce || fasce.length === 0) return;
    setStandby(prev => {
      const nuove = fasce
        .filter(f => !prev.some(r => r.paramId === f.paramId && r.v1 === f.v1 && r.v2 === f.v2))
        .map(f => ({ ...f, id: standbySeq.current++, aperto: false, dett: null, dettLoading: false, dettErr: null }));
      return [...prev, ...nuove];
    });
    setStandbyOpen(true);
  };

  const mettiInStandby = () => {
    const fasce = fasceDaSelezione();
    if (fasce.length === 0) return;
    aggiungiFasce(fasce);
    setSelectedRows(new Set());
  };

  const applicaStandby = (riga) => {
    const m = misuraFascia(riga.paramId, riga.v1, riga.v2);
    if (!m) return;
    pushUndo();
    const newFiltri = { ...filtri };
    const tipoF = sbTipoFiltro(riga.paramId, riga);
    if (!newFiltri[riga.paramId]) newFiltri[riga.paramId] = { tipo: tipoF, includi: [], escludi: [] };
    else newFiltri[riga.paramId] = { ...newFiltri[riga.paramId], tipo: tipoF };
    const fkey = m.verso === "forza" ? "includi" : "escludi";
    newFiltri[riga.paramId][fkey] = [...(newFiltri[riga.paramId][fkey] || []), sbVoce(riga)];
    setStandby(prev => prev.map(r => r.id === riga.id
      ? { ...r, aperto: false, dett: null, dettErr: null } : r));
    setFiltri(newFiltri);
    calcola(newFiltri);
  };

  const annullaStandby = (riga) => {
    pushUndo();
    const newFiltri = { ...filtri };
    const blocco = newFiltri[riga.paramId];
    if (blocco) {
      const fkey = versoApplicatoDi(riga) === "forza" ? "includi" : "escludi";
      const lista = [...(blocco[fkey] || [])];
      const pos = lista.findIndex(e => sbStessaVoce(e, riga));
      if (pos >= 0) lista.splice(pos, 1);
      const aggiornato = { ...blocco, [fkey]: lista };
      if ((aggiornato.includi || []).length === 0 && (aggiornato.escludi || []).length === 0) delete newFiltri[riga.paramId];
      else newFiltri[riga.paramId] = aggiornato;
    }
    setStandby(prev => prev.map(r => r.id === riga.id
      ? { ...r, aperto: false, dett: null, dettErr: null } : r));
    setFiltri(newFiltri);
    calcola(newFiltri);
  };

  const togliDaStandby = (riga) => {
    if (versoApplicatoDi(riga) && !window.confirm(
      "Questa riga è applicata al sistema. Il filtro resta attivo.")) return;
    setStandby(prev => prev.filter(r => r.id !== riga.id));
  };

  const svuotaStandby = () => {
    const nApp = standby.filter(r => versoApplicatoDi(r)).length;
    if (nApp > 0) {
      const testo = nApp === 1
        ? "Una riga è applicata al sistema. I filtri restano attivi."
        : `${nApp} righe sono applicate al sistema. I filtri restano attivi.`;
      if (!window.confirm(testo)) return;
    }
    setStandby([]);
  };

  // ===== LISTA STANDBY — memoria sul database, una lista per sistema =====
  const SB_TAB = "standby_liste";
  const sbHeaders = () => ({
    "apikey": SUPA_KEY, "Authorization": `Bearer ${SUPA_KEY}`,
    "Content-Type": "application/json",
  });

  const caricaStandbyDaDb = async (sistemaId) => {
    standbyCaricatoPer.current = null;
    setStandby([]);
    setStandbyAnnullaInfo({});
    if (!sistemaId) return;
    try {
      const res = await fetch(`${SUPA_URL}/rest/v1/${SB_TAB}?sistema_id=eq.${encodeURIComponent(sistemaId)}&select=righe`,
        { headers: sbHeaders() });
      const dati = await res.json();
      const righe = Array.isArray(dati) && dati.length > 0 && Array.isArray(dati[0].righe) ? dati[0].righe : [];
      const massimo = righe.reduce((a, r) => Math.max(a, Number(r.id) || 0), 0);
      standbySeq.current = massimo + 1;
      setStandby(righe.map(r => ({ ...r, aperto: false, dett: null, dettLoading: false, dettErr: null })));
    } catch (e) {
      // lista non caricata: si riparte da vuota, nessun dato perso sul database
    } finally {
      standbyCaricatoPer.current = sistemaId;
    }
  };

  const scriviStandbySuDb = async (sistemaId, righe) => {
    if (!sistemaId) return;
    const pulite = righe.map(({ id, paramId, label, v1, v2 }) =>
      ({ id, paramId, label, v1, v2 }));
    try {
      await fetch(`${SUPA_URL}/rest/v1/${SB_TAB}?on_conflict=sistema_id`, {
        method: "POST",
        headers: { ...sbHeaders(), "Prefer": "resolution=merge-duplicates" },
        body: JSON.stringify({ sistema_id: sistemaId, righe: pulite, updated_at: new Date().toISOString() }),
      });
    } catch (e) { /* la lista resta comunque a video */ }
  };

  // Scrittura differita: si salva solo la lista del sistema effettivamente caricato
  useEffect(() => {
    if (!sysId) return;
    if (standbyCaricatoPer.current !== sysId) return;
    const t = setTimeout(() => { scriviStandbySuDb(sysId, standby); }, 700);
    return () => clearTimeout(t);
  }, [standby, sysId]);

  // Una riga della matrice è "già in lista" se cade dentro una fascia messa in standby
  const rigaInStandby = (paramId, v1, v2) => standby.some(r =>
    r.paramId === paramId && (
      (v2 === null || v2 === undefined)
        ? (sbEValore(r) && String(v1) === String(r.v1))
        : (!sbEValore(r) &&
           Number(v1) >= Number(r.v1) - 1e-9 && Number(v2) <= Number(r.v2) + 1e-9)
    )
  );

  // Filtri correnti senza il contributo di una riga già applicata
  const filtriSenza = (riga) => {
    const nf = JSON.parse(JSON.stringify(filtri));
    const blocco = nf[riga.paramId];
    if (!blocco) return nf;
    const fkey = versoApplicatoDi(riga) === "forza" ? "includi" : "escludi";
    const lista = [...(blocco[fkey] || [])];
    const pos = lista.findIndex(e => sbStessaVoce(e, riga));
    if (pos >= 0) lista.splice(pos, 1);
    blocco[fkey] = lista;
    if ((blocco.includi || []).length === 0 && (blocco.escludi || []).length === 0) delete nf[riga.paramId];
    return nf;
  };

  // Chiede al server le statistiche di uno scenario (per righe applicate e per il dettaglio stagioni)
  const statsScenario = async (filtriScenario) => {
    const { sys: sysMerc } = getConfig();
    if (!sysMerc || sysMerc.length === 0) return null;
    const res = await fetch(`${API}/power/statistiche_sistema`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ filtri: filtriScenario, mercati_sistema: sysMerc }),
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    if (data.errore) throw new Error(data.errore);
    if (data.per_stagione && !data.stagioni) {
      data.stagioni = Object.entries(data.per_stagione).map(([stagione, v]) => ({ stagione, ...v }));
    }
    return data;
  };

  // Righe applicate: i numeri dicono cosa succederebbe togliendole → serve lo scenario senza quel filtro
  const hashFiltri = JSON.stringify(filtri);
  useEffect(() => {
    if (!standbyOpen) return;
    const applicate = standby.filter(r => versoApplicatoDi(r));
    if (applicate.length === 0) return;
    (async () => {
      for (const riga of applicate) {
        const chiave = `${riga.id}__${hashFiltri}`;
        // già noto, oppure già in corso: non si richiede due volte
        if (standbyAnnullaInfo[chiave] || standbyInVolo.current.has(chiave)) continue;
        standbyInVolo.current.add(chiave);
        try {
          const d = await statsScenario(filtriSenza(riga));
          setStandbyAnnullaInfo(prev => ({ ...prev, [chiave]: d
            ? { eventi: d.eventi, punti: d.punti, stagioni: d.stagioni || [] }
            : { errore: true } }));
        } catch (e) {
          // anche l'esito negativo viene memorizzato: senza, la riga riproverebbe all'infinito
          setStandbyAnnullaInfo(prev => ({ ...prev, [chiave]: { errore: true } }));
        } finally {
          standbyInVolo.current.delete(chiave);
        }
      }
    })();
  }, [standbyOpen, standby, hashFiltri]);

  // Dettaglio stagione per stagione: caricato solo all'apertura della freccetta
  const caricaDettStandby = async (riga) => {
    setStandby(prev => prev.map(r => r.id === riga.id ? { ...r, aperto: !r.aperto } : r));
    if (riga.aperto || riga.dett || riga.dettLoading) return;
    setStandby(prev => prev.map(r => r.id === riga.id ? { ...r, dettLoading: true, dettErr: null } : r));
    try {
      let scenario;
      if (versoApplicatoDi(riga)) {
        scenario = await statsScenario(filtriSenza(riga));
      } else {
        const m = misuraFascia(riga.paramId, riga.v1, riga.v2);
        const nf = JSON.parse(JSON.stringify(filtri));
        const tipoF = sbTipoFiltro(riga.paramId, riga);
        if (!nf[riga.paramId]) nf[riga.paramId] = { tipo: tipoF, includi: [], escludi: [] };
        nf[riga.paramId].tipo = tipoF;
        const fkey = m && m.verso === "forza" ? "includi" : "escludi";
        nf[riga.paramId][fkey] = [...(nf[riga.paramId][fkey] || []), sbVoce(riga)];
        scenario = await statsScenario(nf);
      }
      setStandby(prev => prev.map(r => r.id === riga.id
        ? { ...r, dettLoading: false, dett: { stagioni: scenario?.stagioni || [] } } : r));
    } catch (e) {
      setStandby(prev => prev.map(r => r.id === riga.id
        ? { ...r, dettLoading: false, dettErr: e.message || "Errore" } : r));
    }
  };

  const gruppiMercati = [...new Set(MERCATI.map(m => m.g))];
  const hasFiltri = Object.keys(filtri).length > 0;

  // ===== AVVISO STORICO PARZIALE (D870/D871) =====
  // Un blocco e' "usato" se un suo mercato e' operativo (PUN/BAN) o se un suo
  // parametro compare fra i filtri. E' "solo visto" se un suo mercato e' in VIS.
  const avvisoStorico = (() => {
    const usati = [];
    const visti = [];
    BLOCCHI_DATATI.forEach(b => {
      const operativo = b.mercati.some(id => (mercatiStato[id] || 0) >= 2);
      const filtrato = b.parametri.some(id => {
        const f = filtri[id];
        return !!f && ((f.includi && f.includi.length > 0) || (f.escludi && f.escludi.length > 0));
      });
      if (operativo || filtrato) usati.push(b);
      else if (b.mercati.some(id => (mercatiStato[id] || 0) === 1)) visti.push(b);
    });
    const piuRecente = arr => arr.slice().sort((a, b) => b.ordine - a.ordine)[0];
    if (usati.length > 0) return { tipo: "usa", blocco: piuRecente(usati) };
    if (visti.length > 0) return { tipo: "vede", blocco: piuRecente(visti) };
    return null;
  })();
  const numMultiParams = multiParams.size;

  // --- WHAT IF: caricamento dati ---
  const caricaWhatIf = useCallback(async () => {
    const filtriAttuali = JSON.parse(JSON.stringify(filtri));
    const hashAttuale = JSON.stringify(filtriAttuali);
    if (whatifDati && hashAttuale === whatifFiltriHash) {
      return;
    }
    setWhatifLoading(true);
    setWhatifErrore(null);
    try {
      const res = await fetch(`${API}/power/whatif`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ filtri: filtriAttuali }),
      });
      if (!res.ok) {
        throw new Error(`Errore server (${res.status})`);
      }
      const data = await res.json();
      setWhatifDati(data);
      setWhatifFiltriHash(hashAttuale);
    } catch (e) {
      setWhatifErrore(e.message || "Errore di caricamento");
    } finally {
      setWhatifLoading(false);
    }
  }, [filtri, whatifDati, whatifFiltriHash]);

  // Elenco delle voci della Tenuta filtri: una per verso, stesse etichette delle pillole
  const vociTenuta = () => {
    const out = [];
    Object.entries(filtri).forEach(([key, config]) => {
      if (config.includi && config.includi.length > 0) {
        const f = fmtFiltro(key, { tipo: config.tipo, includi: config.includi, escludi: [] });
        out.push({ id: `${key}__includi`, key, verso: "includi", label: f.label, desc: f.desc });
      }
      if (config.escludi && config.escludi.length > 0) {
        const f = fmtFiltro(key, { tipo: config.tipo, includi: [], escludi: config.escludi });
        out.push({ id: `${key}__escludi`, key, verso: "escludi", label: f.label, desc: f.desc });
      }
    });
    // Strada 2 (v215): l'elenco contiene tutti i filtri usati almeno una volta,
    // non solo quelli di oggi. Un filtro tolto e' proprio quello su cui si vuole
    // sapere se si e' fatto bene: senza questo non sarebbe piu' selezionabile.
    const gia = new Set(out.map(v => v.id));
    ((revInfo && revInfo.revisioni) ? revInfo.revisioni : []).forEach(rev => {
      Object.entries(filtriVisibili(rev.filtri)).forEach(([key, config]) => {
        ["includi", "escludi"].forEach(verso => {
          if (!config[verso] || config[verso].length === 0) return;
          const id = `${key}__${verso}`;
          if (gia.has(id)) return;
          gia.add(id);
          const f = fmtFiltro(key, {
            tipo: config.tipo,
            includi: verso === "includi" ? config.includi : [],
            escludi: verso === "escludi" ? config.escludi : [],
          });
          out.push({ id, key, verso, label: f.label, desc: f.desc, dismesso: true });
        });
      });
    });
    return out;
  };

  // Filtri del sistema senza la voce indicata
  const filtriSenzaVoce = (voce) => {
    const nf = JSON.parse(JSON.stringify(filtri));
    const blocco = nf[voce.key];
    if (!blocco) return nf;
    blocco[voce.verso] = [];
    if ((blocco.includi || []).length === 0 && (blocco.escludi || []).length === 0) delete nf[voce.key];
    return nf;
  };

  // Le bande della Tenuta: il backtest fino all'attivazione con i filtri della
  // rev. 0, poi una banda per revisione, ciascuna con i propri filtri (v215).
  // 'da' incluso, 'a' escluso; l'ultima resta aperta.
  const costruisciBande = () => {
    const revs = (revInfo && revInfo.revisioni) ? [...revInfo.revisioni].sort((a,b) => a.numero - b.numero) : [];
    if (revs.length === 0 || !sysDataAttiv) return null;
    const attiv = String(sysDataAttiv).slice(0,10);
    const out = [{
      chiave: "backtest",
      etichetta: "Backtest storico \u00B7 filtri rev. 0",
      da: null, a: attiv,
      filtri: filtriVisibili(revs[0].filtri),
      backtest: true,
    }];
    revs.forEach((r, i) => {
      const succ = revs[i + 1];
      out.push({
        chiave: `rev${r.numero}`,
        etichetta: `rev. ${r.numero} \u00B7 dal ${formattaDataIT(r.data_inizio)}`,
        da: String(r.data_inizio).slice(0,10),
        a: succ ? String(succ.data_inizio).slice(0,10) : null,
        filtri: filtriVisibili(r.filtri),
        backtest: false,
      });
    });
    return out;
  };

  // La voce in esame puo' non esistere nei filtri di una banda vecchia:
  // li' non c'e' niente da togliere e i due scenari darebbero numeri uguali.
  const voceNellaBanda = (banda, voce) => {
    const b = banda.filtri[voce.key];
    return !!(b && b[voce.verso] && b[voce.verso].length > 0);
  };

  const bandaSenzaVoce = (banda, voce) => {
    const nf = JSON.parse(JSON.stringify(banda.filtri));
    const blocco = nf[voce.key];
    if (!blocco) return nf;
    blocco[voce.verso] = [];
    if ((blocco.includi || []).length === 0 && (blocco.escludi || []).length === 0) delete nf[voce.key];
    return nf;
  };

  const chiediPerBande = async (bande, voce, togliVoce) => {
    const { sys: sysMerc } = getConfig();
    const payload = bande.map((b, i) => ({
      numero: i,
      da: b.da,
      a: b.a,
      filtri: (togliVoce && voceNellaBanda(b, voce)) ? bandaSenzaVoce(b, voce) : b.filtri,
    }));
    const res = await fetch(`${API}/power/statistiche_per_bande`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ bande: payload, mercati_sistema: sysMerc }),
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    if (data.errore) throw new Error(data.errore);
    return data.bande || [];
  };

  const chiediPerPeriodo = async (filtriScenario) => {
    const { sys: sysMerc } = getConfig();
    const res = await fetch(`${API}/power/statistiche_sistema`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ filtri: filtriScenario, mercati_sistema: sysMerc, data_taglio: sysDataAttiv }),
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    if (data.errore) throw new Error(data.errore);
    return data;
  };

  const apriTenutaVoce = async (voce) => {
    setTenutaSel(voce.id);
    setTenutaDati(null);
    setTenutaErrore(null);
    setTenutaLoading(true);
    try {
      const bande = costruisciBande();
      if (bande) {
        const [conFiltro, senzaFiltro] = await Promise.all([
          chiediPerBande(bande, voce, false),
          chiediPerBande(bande, voce, true),
        ]);
        setTenutaDati({ voce, bande, conFiltro, senzaFiltro });
      } else {
        const [conFiltro, senzaFiltro] = await Promise.all([
          chiediPerPeriodo(filtri),
          chiediPerPeriodo(filtriSenzaVoce(voce)),
        ]);
        setTenutaDati({ voce, conFiltro, senzaFiltro });
      }
    } catch (e) {
      setTenutaErrore(e.message);
    } finally {
      setTenutaLoading(false);
    }
  };

  const apriTenuta = () => {
    if (!sysId || !sysDataAttiv || !hasFiltri) return;
    setTenutaSel(null);
    setTenutaDati(null);
    setTenutaErrore(null);
    setTenutaOpen(true);
  };

  const apriWhatIf = () => {
    if (!hasFiltri) return;
    setWhatifOpen(true);
    caricaWhatIf();
  };

  // Toggle parametro nel dropdown
  const toggleParam = (pid) => {
    pushUndo();
    setUsaSingolo(false);
    setMultiParams(prev => {
      const next = new Set(prev);
      if (next.has(pid)) next.delete(pid); else next.add(pid);
      return next;
    });
  };

  const toggleCat = (cat) => {
    pushUndo();
    setUsaSingolo(false);
    const ids = cat.items.map(i => i.id);
    const allOn = ids.every(id => multiParams.has(id));
    setMultiParams(prev => {
      const next = new Set(prev);
      ids.forEach(id => { if (allOn) next.delete(id); else next.add(id); });
      return next;
    });
  };

  // Chiudi dropdown cliccando fuori
  useEffect(() => {
    const handler = (e) => {
      if (paramDropdownRef.current && !paramDropdownRef.current.contains(e.target)) {
        setPannelloAperto(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // Chiudi filtro dropdown cliccando fuori
  useEffect(() => {
    const handlerFiltro = (e) => {
      if (filtroDropdownRef.current && !filtroDropdownRef.current.contains(e.target)) {
        setFiltroAperto(false);
      }
    };
    document.addEventListener("mousedown", handlerFiltro);
    return () => document.removeEventListener("mousedown", handlerFiltro);
  }, []);

  // ===== SUPABASE — default parametri =====
  const SUPA_URL = "https://sgecrzhklzwypbtiwjxh.supabase.co";
  const SUPA_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNnZWNyemhrbHp3eXBidGl3anhoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE3Nzk0MTMsImV4cCI6MjA4NzM1NTQxM30.mPtOfWQeruUSfeMmKqSk6BqVxatxaZ0P4rSuYrTCRnI";

  const caricaDefaultParams = async () => {
    try {
      const res = await fetch(`${SUPA_URL}/rest/v1/user_settings?user_id=eq.admin&select=parametri_default&order=updated_at.desc&limit=1`, {
        headers: { "apikey": SUPA_KEY, "Authorization": `Bearer ${SUPA_KEY}` }
      });
      const data = await res.json();
      let params;
      if (data?.length > 0 && Array.isArray(data[0].parametri_default) && data[0].parametri_default.length > 0) {
        params = new Set(data[0].parametri_default);
      } else {
        params = new Set(DEFAULT_PARAMS);
      }
      setDefaultParams(params);
      setMultiParams(params);
      return params;
    } catch(e) {
      console.error("caricaDefaultParams:", e);
      return new Set(DEFAULT_PARAMS);
    }
  };

  const salvaDefaultParams = async (params) => {
    try {
      await fetch(`${SUPA_URL}/rest/v1/user_settings?on_conflict=user_id`, {
        method: "POST",
        headers: {
          "apikey": SUPA_KEY, "Authorization": `Bearer ${SUPA_KEY}`,
          "Content-Type": "application/json", "Prefer": "resolution=merge-duplicates,return=minimal"
        },
        body: JSON.stringify({ user_id: "admin", parametri_default: [...params], updated_at: new Date().toISOString() })
      });
    } catch(e) { console.error("salvaDefaultParams:", e); }
  };

  // Carica default parametri all'avvio
  useEffect(() => { caricaDefaultParams(); }, []);

  // Carica sistemi all'avvio per mostrare il badge contatore
  useEffect(() => { caricaSistemi(); }, []);

  // ===== D882 — il lavoro sopravvive al cambio di pagina =====
  // Si conserva solo con un sistema caricato: quello e' lavoro. Senza sistema
  // sono prove, e la pagina riparte pulita.
  const memoriaRef = useRef(null);
  memoriaRef.current = {
    sysEsisteInDb, sysId, sysIdOriginale, sysNome, sysComm,
    sysAttivo, sysDataAttiv, sysDataSosp, isNuovoSistema,
    filtri, mercatiStato, parametro, usaSingolo,
    multiParams, stagioniVista, selectedRows, undoStack, redoStack,
  };

  useEffect(() => () => {
    const m = memoriaRef.current;
    memoriaSessione = (m && m.sysEsisteInDb) ? m : null;
  }, []);

  const [ripristino, setRipristino] = useState(null);

  useEffect(() => {
    const m = memoriaSessione;
    memoriaSessione = null;
    if (!m) return;
    setSysId(m.sysId); setSysIdOriginale(m.sysIdOriginale);
    setSysNome(m.sysNome); setSysComm(m.sysComm);
    setSysAttivo(m.sysAttivo); setSysDataAttiv(m.sysDataAttiv);
    setSysDataSosp(m.sysDataSosp); setSysEsisteInDb(true);
    setIsNuovoSistema(m.isNuovoSistema);
    setFiltri(m.filtri); setMercatiStato(m.mercatiStato);
    setParametro(m.parametro); setUsaSingolo(m.usaSingolo);
    setMultiParams(m.multiParams); setStagioniVista(m.stagioniVista);
    setUndoStack(m.undoStack); setRedoStack(m.redoStack);
    setRipristino(m);
  }, []);

  // Secondo passo, dopo che lo stato e' tornato a schermo: si ricalcola con i
  // valori nuovi, non con quelli vecchi rimasti nella chiusura del primo passo.
  useEffect(() => {
    if (!ripristino) return;
    setRipristino(null);
    const mercatiSistema = Object.entries(ripristino.mercatiStato || {})
      .filter(([, s]) => s === 2 || s === 3)
      .map(([id, s]) => ({ mercato: id, tipo: s === 2 ? "punta" : "banca" }));
    caricaStandbyDaDb(ripristino.sysId);
    caricaRevisioni(ripristino.sysId);
    caricaStatistiche(ripristino.filtri, mercatiSistema, ripristino.stagioniVista);
    (async () => {
      await calcola(ripristino.filtri, undefined, mercatiSistema, ripristino.stagioniVista);
      if (ripristino.selectedRows && ripristino.selectedRows.size > 0) {
        setSelectedRows(ripristino.selectedRows);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ripristino]);

  // Fine della logica — il JSX del return segue
  // ===== RENDER =====
  return (
    <div style={{minHeight:"100vh", background:"#FAFBFC", fontFamily:"'DM Sans',-apple-system,sans-serif"}}>


      {/* ===== HEADER PAGINA ===== */}
      <div style={{padding:"24px 32px 0 32px"}}>
        <h1 style={{fontSize:22,fontWeight:700,color:"#1E293B",marginBottom:4,letterSpacing:"-0.02em"}}>
          ⚙️ Creazione Sistemi
        </h1>
        <p style={{fontSize:13,color:"#64748B",marginBottom:16}}>
          Costruisci e analizza sistemi combinando parametri statistici e filtri.
        </p>
      </div>

      {/* ================================================================
          STRATO 1 — TOOLBAR FISSA (stile ribbon VBA)
          ================================================================ */}
      <div ref={toolbarRef} style={{
        background:"#fff", borderBottom:"1px solid #D8D8D4",
        borderTop:"3px solid #2563EB",
        padding:"4px 12px 6px",
        position:"sticky", top:0, zIndex:100,
        boxShadow:"0 2px 8px rgba(0,0,0,0.08)",
        display:"flex", alignItems:"stretch", gap:0,
      }}>

        {/* Gruppo: Impostazioni — solo Parametri statistici */}
        <div className="toolbar-group" style={{padding:"0 4px"}}>
          <div className="toolbar-group-btns">

            {/* Icona Parametri statistici — apre drawer */}
            <button className="tb-btn tb-btn-wide"
              onClick={() => setDrawerParametriAperto(true)}
              style={{background: drawerParametriAperto ? "#EFF4FF" : undefined,
                borderRadius:6, border: drawerParametriAperto ? "1px solid #93C5FD" : "1px solid transparent"}}>
              <span className="tb-btn-icon" style={{position:"relative",display:"inline-block"}}>
                📊
                {defaultParams.size > 0 && (
                  <span style={{
                    position:"absolute",top:-4,right:-8,
                    background:"#1B2846",color:"#fff",borderRadius:10,
                    fontSize:9,fontWeight:700,padding:"0 4px",lineHeight:"14px",
                    minWidth:14,textAlign:"center",
                  }}>{defaultParams.size}</span>
                )}
              </span>
              <span className="tb-btn-label" style={{color: drawerParametriAperto ? "#1D4ED8" : "#444440"}}>
                Parametri statistici
              </span>
            </button>

          </div>
          <span className="toolbar-group-label">Impostazioni</span>
        </div>

        <div style={{width:1,background:"#E8E8E4",margin:"4px 6px"}} />

        {/* Gruppo: Calcolo */}
        <div className="toolbar-group" style={{padding:"0 4px"}}>
          <div className="toolbar-group-btns">
            <button className="tb-btn" onClick={() => calcola()} disabled={loading}
              style={{opacity:loading?0.7:1}}>
              <span className="tb-btn-icon" style={{color:"#2563EB"}}>{loading ? "⏳" : "▶"}</span>
              <span className="tb-btn-label" style={{color:"#2563EB"}}>{loading ? "Calcolo..." : "Calcola"}</span>
            </button>
            <button className="tb-btn" onClick={() => forzaEscl("forza")}
              disabled={selectedRows.size===0 || inConsultazione}
              title={inConsultazione ? "Non disponibile mentre stai consultando alcune stagioni." : undefined}
              style={{opacity:(selectedRows.size>0 && !inConsultazione)?1:0.3}}>
              <span className="tb-btn-icon" style={{color:"#16A34A"}}>＋</span>
              <span className="tb-btn-label" style={{color:"#16A34A"}}>
                Forza{selectedRows.size>0?` (${selectedRows.size})`:""}
              </span>
            </button>
            <button className="tb-btn" onClick={() => forzaEscl("escludi")}
              disabled={selectedRows.size===0 || inConsultazione}
              title={inConsultazione ? "Non disponibile mentre stai consultando alcune stagioni." : undefined}
              style={{opacity:(selectedRows.size>0 && !inConsultazione)?1:0.3}}>
              <span className="tb-btn-icon" style={{color:"#DC2626"}}>✕</span>
              <span className="tb-btn-label" style={{color:"#DC2626"}}>
                Escludi{selectedRows.size>0?` (${selectedRows.size})`:""}
              </span>
            </button>
            <button className="tb-btn" onClick={mettiInStandby}
              disabled={selectedRows.size===0 || inConsultazione}
              title={inConsultazione ? "Non disponibile mentre stai consultando alcune stagioni." : "Mette la fascia selezionata nella Lista Standby, senza applicarla al sistema."}
              style={{opacity:(selectedRows.size>0 && !inConsultazione)?1:0.3}}>
              <span className="tb-btn-icon" style={{color:"#7C3AED"}}>⏸</span>
              <span className="tb-btn-label" style={{color:"#7C3AED"}}>
                Standby{selectedRows.size>0?` (${selectedRows.size})`:""}
              </span>
            </button>
            <button className="tb-btn" onClick={undo} disabled={undoStack.length===0 || inConsultazione}
              title={inConsultazione ? "Non disponibile mentre stai consultando alcune stagioni." : undefined}>
              <span className="tb-btn-icon" style={{color:"#6B6B66"}}>↩</span>
              <span className="tb-btn-label" style={{color:"#6B6B66"}}>Annulla</span>
            </button>
            <button className="tb-btn" onClick={redo} disabled={redoStack.length===0 || inConsultazione}
              title={inConsultazione ? "Non disponibile mentre stai consultando alcune stagioni." : undefined}>
              <span className="tb-btn-icon" style={{color:"#6B6B66"}}>↪</span>
              <span className="tb-btn-label" style={{color:"#6B6B66"}}>Ripristina</span>
            </button>
            {haRisultati && (
              <button className="tb-btn" onClick={() => setSommaMode(!sommaMode)}
                title={sommaMode ? "PPE = Punti Per Evento. Divide il P/L per il numero di eventi" : "Somma: mostra il P/L totale"}>
                <span className="tb-btn-icon" style={{color: sommaMode ? "#1D4ED8" : "#15803D"}}>
                  {sommaMode ? "μ" : "Σ"}
                </span>
                <span className="tb-btn-label" style={{color: sommaMode ? "#1D4ED8" : "#15803D"}}>
                  {sommaMode ? "PPE" : "Somma"}
                </span>
              </button>
            )}
            {/* Icona Filtro parametri statistici — dropdown */}
            <div ref={filtroDropdownRef} style={{position:"relative"}}>
              <button className="tb-btn tb-btn-wide"
                onClick={() => setFiltroAperto(p => !p)}
                style={{background: filtroAperto ? "#EFF4FF" : undefined,
                  borderRadius:6, border: filtroAperto ? "1px solid #93C5FD" : "1px solid transparent"}}>
                <span className="tb-btn-icon" style={{position:"relative",display:"inline-block"}}>
                  ⚙
                  {filtroParams.size > 0 && (
                    <span style={{
                      position:"absolute",top:-4,right:-8,
                      background:"#1B2846",color:"#fff",borderRadius:10,
                      fontSize:9,fontWeight:700,padding:"0 4px",lineHeight:"14px",
                      minWidth:14,textAlign:"center",
                    }}>{filtroParams.size}</span>
                  )}
                </span>
                <span className="tb-btn-label" style={{color: filtroAperto ? "#1D4ED8" : "#444440"}}>
                  Filtro parametri statistici {filtroAperto ? "▲" : "▼"}
                </span>
              </button>

              {/* Dropdown Filtro */}
              {filtroAperto && (
                <div style={{
                  position:"absolute",top:"calc(100% + 6px)",left:0,
                  background:"#fff",border:"1.5px solid #D8D8D4",borderRadius:10,
                  boxShadow:"0 8px 32px rgba(0,0,0,0.14)",
                  zIndex:300,width:280,maxHeight:480,overflowY:"auto",
                }}>
                  {/* Header */}
                  <div style={{padding:"10px 12px 6px",borderBottom:"1px solid #F0F0EC",
                    display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                    {filtroParams.size > 0
                      ? <span style={{fontSize:11,fontWeight:700,color:"#1D4ED8"}}>{filtroParams.size} {filtroParams.size===1?"parametro":"parametri"} selezionati</span>
                      : <span style={{fontSize:11,color:"#6B6B66"}}>Filtra parametri</span>
                    }
                    <button onClick={(e)=>{e.stopPropagation();setFiltroParams(new Set());setMultiParams(new Set(defaultParams));calcola(undefined, new Set(defaultParams));}}
                      style={{...btnGhost,fontSize:10,padding:"2px 8px",color:"#2563EB",borderColor:"#BFDBFE"}}>
                      Ripristina visuale
                    </button>
                  </div>
                  {/* Categorie collassabili */}
                  <div style={{padding:"6px 0"}}>
                    {PARAMETRI.map(cat => {
                      const itemsAttivi = cat.items; // mostra tutti i parametri
                      const isOpen = filtroAccordionOpen[cat.cat];
                      const someOn = itemsAttivi.some(i => filtroParams.has(i.id));
                      const allOn = itemsAttivi.every(i => filtroParams.has(i.id));
                      return (
                        <div key={cat.cat} style={{marginBottom:1}}>
                          {/* Header categoria */}
                          <div
                            onClick={(e)=>{e.stopPropagation();setFiltroAccordionOpen(prev=>({...prev,[cat.cat]:!prev[cat.cat]}));}}
                            style={{display:"flex",alignItems:"center",gap:6,padding:"5px 12px",
                              cursor:"pointer",userSelect:"none"}}>
                            <span style={{fontSize:8,color: someOn ? "#1D4ED8" : "#6B6B66",
                              transform:isOpen?"rotate(90deg)":"rotate(0deg)",
                              display:"inline-block",transition:"transform 0.15s"}}>▶</span>
                            <span style={{fontSize:10,fontWeight:700,textTransform:"uppercase",
                              letterSpacing:"0.06em",color: someOn ? "#1D4ED8" : "#6B6B66"}}>
                              {cat.cat}
                            </span>
                          </div>
                          {/* Items */}
                          {isOpen && (
                            <div style={{paddingLeft:12,paddingRight:8,paddingBottom:4}}>
                              {itemsAttivi.map(item => {
                                const isOn = filtroParams.has(item.id);
                                return (
                                  <div key={item.id}
                                    onClick={(e)=>{
                                      e.stopPropagation();
                                      const next = new Set(filtroParams);
                                      if (isOn) next.delete(item.id); else next.add(item.id);
                                      setFiltroParams(next);
                                      const paramsPerCalcolo = next.size === 0 ? new Set(defaultParams) : next;
                                      setMultiParams(paramsPerCalcolo);
                                      calcola(undefined, paramsPerCalcolo);
                                    }}
                                    style={{
                                      padding:"4px 8px",borderRadius:5,cursor:"pointer",
                                      fontSize:12,display:"flex",alignItems:"center",gap:7,
                                      color: isOn ? "#1D4ED8" : "#444440",
                                      background: isOn ? "#EFF4FF" : "transparent",
                                      fontWeight: isOn ? 600 : 400,
                                      marginBottom:1,
                                    }}>
                                    <span style={{
                                      width:13,height:13,borderRadius:3,flexShrink:0,display:"inline-flex",
                                      alignItems:"center",justifyContent:"center",fontSize:9,
                                      background: isOn ? "#1B2846" : "#E8E8E4",
                                      color:"#fff",
                                    }}>{isOn ? "✓" : ""}</span>
                                    {item.l}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            <button className="tb-btn" onClick={() => { pushUndo(); setFiltri({}); if(hasCalcolato) calcola({}); }}
              disabled={!hasFiltri || inConsultazione}
              title={inConsultazione ? "Non disponibile mentre stai consultando alcune stagioni." : undefined}
              style={{opacity:(hasFiltri && !inConsultazione)?1:0.3}}>
              <span className="tb-btn-icon" style={{color:"#DC2626"}}>🗑</span>
              <span className="tb-btn-label" style={{color:"#DC2626"}}>Cancella filtri</span>
            </button>
          </div>
          <span className="toolbar-group-label">Calcolo</span>
        </div>

        <div style={{width:1,background:"#E8E8E4",margin:"4px 6px"}} />

        {/* Gruppo: Analisi */}
        <div className="toolbar-group" style={{padding:"0 4px"}}>
          <div className="toolbar-group-btns">
            {/* Ordina P/L Mercati */}
            <button className="tb-btn tb-btn-wide"
              onClick={() => {
                if (!haRisultati) return;
                setVistaPL(false);
                setVistaZone(false);
                setVistaMercati(v => !v);
              }}
              disabled={!haRisultati}
              style={{
                background: vistaMercati ? "#EFF6FF" : undefined,
                border: vistaMercati ? "1px solid #93C5FD" : "1px solid transparent",
                borderRadius:6,
                opacity: !haRisultati ? 0.35 : (sysId && !vistaMercati ? 0.5 : 1),
              }}>
              <span className="tb-btn-icon" style={{color: vistaMercati ? "#2563EB" : "#444440"}}>{vistaMercati ? "↩" : "▼"}</span>
              <span className="tb-btn-label" style={{color: vistaMercati ? "#2563EB" : "#444440"}}>{vistaMercati ? "Vista norm." : "Ordina P/L Mercati"}</span>
            </button>
            {/* Vista P/L Sistema */}
            <button className="tb-btn tb-btn-wide"
              onClick={() => {
                if (!sysId) return;
                if (!haRisultati) return;
                setVistaMercati(false);
                setVistaZone(false);
                setVistaPL(v => !v);
              }}
              disabled={!sysId}
              title={!sysId ? "Disponibile solo dopo aver caricato o salvato un sistema. Vai su SISTEMI → Archivio per caricarne uno, oppure salva il sistema corrente." : undefined}
              style={{
                background: vistaPL ? "#FFF7ED" : undefined,
                border: vistaPL ? "1px solid #FED7AA" : "1px solid transparent",
                borderRadius:6,
                opacity: !sysId ? 0.35 : 1,
              }}>
              <span className="tb-btn-icon" style={{color: vistaPL ? "#EA580C" : "#444440"}}>{vistaPL ? "↩" : "▼"}</span>
              <span className="tb-btn-label" style={{color: vistaPL ? "#EA580C" : "#444440"}}>{vistaPL ? "Vista norm." : "Ordina P/L Sistema"}</span>
            </button>
            {/* Zone Continue */}
            <button className="tb-btn tb-btn-wide"
              onClick={() => {
                if (!hasSistema) return;
                if (!haRisultati) return;
                setVistaMercati(false);
                setVistaPL(false);
                setVistaZone(v => !v);
              }}
              disabled={!hasSistema || !haRisultati}
              title={!hasSistema ? "Serve almeno un mercato impostato come Punta o Banca." : undefined}
              style={{
                background: vistaZone ? "#F0FDFA" : undefined,
                border: vistaZone ? "1px solid #99F6E4" : "1px solid transparent",
                borderRadius:6,
                opacity: (!hasSistema || !haRisultati) ? 0.35 : 1,
              }}>
              <span className="tb-btn-icon" style={{color: vistaZone ? "#0D9488" : "#444440"}}>{vistaZone ? "↩" : "▤"}</span>
              <span className="tb-btn-label" style={{color: vistaZone ? "#0D9488" : "#444440"}}>{vistaZone ? "Vista norm." : "Zone Continue"}</span>
            </button>
            {/* Lista Standby */}
            <button className="tb-btn tb-btn-wide"
              onClick={() => setStandbyOpen(v => !v)}
              title="Apre l'elenco delle fasce messe da parte, per applicarle quando vuoi."
              style={{
                background: standbyOpen ? "#F5F3FF" : undefined,
                border: standbyOpen ? "1px solid #C4B5FD" : "1px solid transparent",
                borderRadius:6,
              }}>
              <span className="tb-btn-icon" style={{position:"relative",display:"inline-block",color: standbyOpen ? "#7C3AED" : "#444440"}}>
                ⏸
                {standby.length > 0 && (
                  <span style={{
                    position:"absolute",top:-4,right:-8,
                    background:"#7C3AED",color:"#fff",borderRadius:10,
                    fontSize:9,fontWeight:700,padding:"0 4px",lineHeight:"14px",
                    minWidth:14,textAlign:"center",
                  }}>{standby.length}</span>
                )}
              </span>
              <span className="tb-btn-label" style={{color: standbyOpen ? "#7C3AED" : "#444440"}}>Lista Standby</span>
            </button>
            {/* What If */}
            <button className="tb-btn tb-btn-wide"
              onClick={apriWhatIf}
              disabled={!hasFiltri || inConsultazione}
              title={inConsultazione ? "Non disponibile mentre stai consultando alcune stagioni."
                : (!hasFiltri ? "Disponibile quando ci sono filtri attivi." : undefined)}
              style={{
                background: whatifOpen ? "#F5F3FF" : undefined,
                border: whatifOpen ? "1px solid #C4B5FD" : "1px solid transparent",
                borderRadius:6,
                opacity: (!hasFiltri || inConsultazione) ? 0.35 : 1,
              }}>
              <span className="tb-btn-icon" style={{color: whatifOpen ? "#7C3AED" : "#444440"}}>⚖</span>
              <span className="tb-btn-label" style={{color: whatifOpen ? "#7C3AED" : "#444440"}}>What If</span>
            </button>

            {/* Tenuta filtri */}
            <button className="tb-btn tb-btn-wide"
              onClick={apriTenuta}
              disabled={!sysId || !sysDataAttiv || !hasFiltri || inConsultazione}
              title={
                inConsultazione ? "Non disponibile mentre stai consultando alcune stagioni."
                : !sysId ? "Disponibile su un sistema salvato."
                : !sysDataAttiv ? "Serve la data di attivazione: attiva il sistema dalla barra in alto."
                : !hasFiltri ? "Disponibile quando ci sono filtri attivi."
                : "Confronta ogni filtro prima e dopo l'attivazione del sistema."
              }
              style={{
                background: tenutaOpen ? "#F0FDFA" : undefined,
                border: tenutaOpen ? "1px solid #99F6E4" : "1px solid transparent",
                borderRadius:6,
                opacity: (!sysId || !sysDataAttiv || !hasFiltri || inConsultazione) ? 0.35 : 1,
              }}>
              <span className="tb-btn-icon" style={{color: tenutaOpen ? "#0D9488" : "#444440"}}>⏱</span>
              <span className="tb-btn-label" style={{color: tenutaOpen ? "#0D9488" : "#444440"}}>Tenuta filtri</span>
            </button>
          </div>
          <span className="toolbar-group-label">Analisi</span>
        </div>

        <div style={{width:1,background:"#E8E8E4",margin:"4px 6px"}} />

        {/* Gruppo: Sistemi */}
        <div className="toolbar-group" style={{padding:"0 4px"}}>
          <div className="toolbar-group-btns">
            <button className="tb-btn" onClick={() => {
                setSysId(""); setSysIdOriginale(""); setSysNome(""); setSysComm(""); setIsNuovoSistema(true);
                // Un sistema nuovo non e' mai stato attivato: senza questo azzeramento
                // resterebbero a schermo lo stato e la data del sistema aperto prima.
                setSysAttivo(false); setSysDataAttiv(null); setSysDataSosp(null); setSysEsisteInDb(false); setEditDataAttiv(false);
                setRevInfo(null);
                standbyCaricatoPer.current = null; setStandby([]); setStandbyAnnullaInfo({});
                setShowModal(true);
              }}>
              <span className="tb-btn-icon" style={{color:"#2563EB"}}>＋</span>
              <span className="tb-btn-label" style={{color:"#2563EB"}}>Nuovo</span>
            </button>
            <button className="tb-btn" onClick={() => {
                if (!sysId) { alert("Prima crea un sistema con '+ Nuovo'"); return; }
                setIsNuovoSistema(false); setShowModal(true);
              }}
              disabled={inConsultazione}
              title={inConsultazione ? "Non disponibile mentre stai consultando alcune stagioni." : undefined}
              style={{opacity: inConsultazione ? 0.3 : 1}}>
              <span className="tb-btn-icon" style={{color:"#16A34A"}}>💾</span>
              <span className="tb-btn-label" style={{color:"#16A34A"}}>Salva</span>
            </button>
            <button className="tb-btn tb-btn-wide" onClick={() => {
                const nuovoStato = !sistemiDrawerAperto;
                setSistemiDrawerAperto(nuovoStato);
                if (nuovoStato) caricaSistemi();
              }}
              style={{background: sistemiDrawerAperto ? "#EFF4FF" : undefined,
                border: sistemiDrawerAperto ? "1px solid #93C5FD" : "1px solid transparent",
                borderRadius:6}}>
              <span className="tb-btn-icon" style={{position:"relative",display:"inline-block"}}>
                📂
                {sistemiSalvati.length > 0 && (
                  <span style={{
                    position:"absolute",top:-4,right:-8,
                    background:"#2563EB",color:"#fff",borderRadius:10,
                    fontSize:9,fontWeight:700,padding:"0 4px",lineHeight:"14px",
                    minWidth:14,textAlign:"center",
                  }}>{sistemiSalvati.length}</span>
                )}
              </span>
              <span className="tb-btn-label" style={{color: sistemiDrawerAperto ? "#1D4ED8" : "#444440"}}>
                Archivio
              </span>
            </button>
          </div>
          <span className="toolbar-group-label">Sistemi</span>
        </div>

        {/* Spazio flessibile */}
        <div style={{flex:1}} />

        {/* Contatore eventi + loading */}
        <div style={{display:"flex",alignItems:"center",gap:10,padding:"0 4px",alignSelf:"center"}}>
          {loading && (
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <div style={{width:100,height:4,background:"#E8E8E4",borderRadius:10,overflow:"hidden"}}>
                <div style={{
                  height:"100%",borderRadius:10,background:"#2563EB",
                  animation:"progress-pulse 1.5s ease-in-out infinite",width:"40%"
                }}/>
              </div>
              <span style={{fontSize:10,color:"#6B6B66",fontFamily:"'Roboto Mono',monospace"}}>
                {multiParams.size > 1 ? `${multiParams.size} parametri...` : ""}
              </span>
            </div>
          )}
          {haRisultati && !loading && (
            <span style={{
              fontSize:13,fontWeight:700,color:"#1A1A18",
              fontFamily:"'Roboto Mono',monospace",
              background:"#F2F2EE",border:"1px solid #D8D8D4",
              borderRadius:6,padding:"4px 10px",
            }}>
              {totaleEventi.toLocaleString()} eventi
            </span>
          )}
        </div>
      </div>

      {/* ================================================================
          STRATO 2 — BARRA SISTEMA ATTIVO
          ================================================================ */}
      {sysId && (
        <div style={{
          background:"#1B2846",borderBottom:"1px solid #0f1f3d",
          padding:"8px 14px",
          display:"flex",alignItems:"center",justifyContent:"center",gap:8,
          flexWrap:"wrap",
          position:"relative",
        }}>
          <span style={{fontSize:11,fontWeight:700,color:"#93C5FD",
            textTransform:"uppercase",letterSpacing:"0.06em"}}>
            Sistema:
          </span>
          <span style={{fontSize:11,fontWeight:700,color:"#fff"}}>
            {sysNome}
          </span>
          {etichettaRev && (
            <>
              <span style={{fontSize:11,color:"#64748B"}}>·</span>
              {etichettaRev}
            </>
          )}

          {!editDataAttiv && (
            <>
              <span style={{fontSize:11,color:"#64748B"}}>·</span>
              <button
                disabled={!sysEsisteInDb}
                title={!sysEsisteInDb ? "Salva il sistema per poterlo attivare"
                  : (sysAttivo ? "Sospendi il sistema" : "Attiva il sistema")}
                onClick={() => { if (sysEsisteInDb) cambiaStatoSistema(sysId, !sysAttivo); }}
                style={{width:30,height:17,borderRadius:9,border:"none",
                  background: sysAttivo ? "#16A34A" : "#475569",
                  position:"relative",flexShrink:0,padding:0,
                  cursor: sysEsisteInDb ? "pointer" : "not-allowed",
                  opacity: sysEsisteInDb ? 1 : 0.5,
                  transition:"background 0.2s"}}>
                <div style={{width:12,height:12,borderRadius:6,background:"#fff",
                  position:"absolute",top:2.5,
                  left: sysAttivo ? 15 : 2.5,
                  transition:"left 0.2s",boxShadow:"0 1px 3px rgba(0,0,0,0.2)"}} />
              </button>
              {!sysEsisteInDb ? (
                <span style={{fontSize:11,color:"#64748B",fontStyle:"italic"}}>
                  salva il sistema per poterlo attivare
                </span>
              ) : sysAttivo ? (
                <span style={{fontSize:11,color:"#4ADE80",fontWeight:600}}>
                  Attivo dal {formattaDataIT(sysDataAttiv)}
                </span>
              ) : sysDataAttiv ? (
                <span style={{fontSize:11,color:"#94A3B8",fontWeight:600}}>
                  Dismesso{sysDataSosp ? ` dal ${formattaDataIT(sysDataSosp)}` : ""}
                </span>
              ) : (
                <span style={{fontSize:11,color:"#94A3B8",fontWeight:600}}>
                  Mai attivato
                </span>
              )}
              {sysAttivo && (
                <button
                  title="Modifica la data di attivazione"
                  onClick={() => { setBozzaDataAttiv(sysDataAttiv ? String(sysDataAttiv).slice(0,10) : oggiISO()); setEditDataAttiv(true); }}
                  style={{background:"transparent",border:"1px solid #3B4A6B",borderRadius:4,
                    color:"#93C5FD",fontSize:10,fontWeight:600,padding:"1px 6px",cursor:"pointer",lineHeight:1.4}}>
                  modifica
                </button>
              )}
            </>
          )}

          {editDataAttiv && (
            <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap",justifyContent:"center"}}>
              <input type="date" value={bozzaDataAttiv}
                onChange={e => setBozzaDataAttiv(e.target.value)}
                className="data-attiv-input"
                style={{fontSize:12,padding:"3px 8px",borderRadius:4,border:"1px solid #3B4A6B",
                  background:"#0F1B33",color:"#fff",colorScheme:"dark"}} />
              <button
                onClick={() => { if (bozzaDataAttiv) salvaDataAttivazione(bozzaDataAttiv); }}
                style={{background:"#16A34A",border:"none",borderRadius:4,color:"#fff",
                  fontSize:10,fontWeight:600,padding:"3px 10px",cursor:"pointer"}}>
                Salva
              </button>
              <button
                onClick={() => setEditDataAttiv(false)}
                style={{background:"transparent",border:"1px solid #3B4A6B",borderRadius:4,
                  color:"#93C5FD",fontSize:10,fontWeight:600,padding:"3px 10px",cursor:"pointer"}}>
                Annulla
              </button>
            </div>
          )}

          {sysAttivo && revInfo && revInfo.scarto_filtri && !editDataAttiv && (
            <div style={{flexBasis:"100%",display:"flex",alignItems:"center",
              justifyContent:"center",marginTop:8}}>
              <div style={{display:"inline-flex",alignItems:"center",
                justifyContent:"center",gap:10,flexWrap:"wrap",
                background:"#3A2A12",border:"1px solid #7A5A1E",
                borderRadius:6,padding:"6px 12px"}}>
              <span style={{fontSize:11,color:"#FAC775",fontWeight:600}}>
                &#9888; {testoGiorniScarto()}
              </span>
              <button
                title="Conferma i filtri attuali come nuova revisione"
                onClick={confermaNuovaRevisione}
                style={{background:"#BA7517",border:"none",borderRadius:4,
                  color:"#412402",fontSize:10,fontWeight:700,padding:"3px 9px",
                  cursor:"pointer",lineHeight:1.4}}>
                Nuova revisione
              </button>
              <button
                title="Rimetti i filtri dell'ultima revisione"
                onClick={ripristinaFiltriRevisione}
                style={{background:"transparent",border:"1px solid #7A5A1E",borderRadius:4,
                  color:"#FAC775",fontSize:10,fontWeight:600,padding:"3px 9px",
                  cursor:"pointer",lineHeight:1.4}}>
                Ripristina
              </button>
              </div>
            </div>
          )}

          <button
            onClick={() => {
              setSysId(""); setSysIdOriginale(""); setSysNome(""); setSysComm("");
              setIsNuovoSistema(true); setStatSistema(null);
              setSysAttivo(false); setSysDataAttiv(null); setSysDataSosp(null); setSysEsisteInDb(false); setEditDataAttiv(false);
              setRevInfo(null);
              setStagioniVista([]);
              setFiltri({});
              setRisultato(null); setRisultatiMulti([]);
              setSelectedRows(new Set());
              setHasCalcolato(false);
              setMercatiStato(prev => {
                const next = { ...prev };
                Object.keys(next).forEach(k => {
                  if (next[k] === 2 || next[k] === 3) next[k] = 1;
                });
                return next;
              });
            }}
            style={{position:"absolute",right:14,
              background:"#DC2626",border:"1px solid #B91C1C",borderRadius:5,
              color:"#fff",fontSize:11,fontWeight:500,
              padding:"3px 8px",cursor:"pointer",lineHeight:1}}>
            ✕
          </button>
        </div>
      )}

      {/* Barra di consultazione — visibile solo con stagioni accese */}
      {sysId && inConsultazione && (
        <div style={{display:"flex",alignItems:"center",gap:10,
          background:"#EFF6FF",borderBottom:"1px solid #93C5FD",
          padding:"6px 16px",fontSize:11,color:"#1E40AF"}}>
          <span style={{fontSize:13,lineHeight:1}}>👁</span>
          <span>
            Consultazione — stai guardando{" "}
            <b>{stagioniVista.length} {stagioniVista.length === 1 ? "stagione" : "stagioni"} su {statSistema?.stagioni?.length ?? "—"}</b>
            : {[...stagioniVista].sort().join(", ")}
          </span>
          <button onClick={azzeraStagioni}
            title="Torna a tutte le stagioni"
            style={{marginLeft:"auto",background:"transparent",border:"1px solid #93C5FD",
              borderRadius:5,color:"#1D4ED8",fontSize:13,fontWeight:600,
              padding:"0 7px",cursor:"pointer",lineHeight:1.6}}>
            ×
          </button>
        </div>
      )}

      {/* ================================================================
          STRATO 2.5 — PANNELLO STATISTICHE SISTEMA
          ================================================================ */}
      {sysId && (
        <div style={{background:"#fff",borderBottom:"1px solid #E8E8E4"}}>

          {/* Corpo pannello */}
          {statPannelloAperto && statSistema && (
            <>
              {/* Griglia KPI */}
              <div style={{display:"flex",flexWrap:"wrap",borderBottom:"1px solid #F0F0EC",
                background: inConsultazione ? "#F7FAFF" : undefined}}>
                {[
                  {label:"Eventi", val: statSistema.eventi?.toLocaleString("it-IT"), color:"#1D4ED8"},
                  {label:"Punti Totali", val: (statSistema.punti >= 0 ? "+" : "") + statSistema.punti?.toFixed(2), color: statSistema.punti >= 0 ? "#15803D" : "#DC2626"},
                  {label:"PPE", val: (statSistema.ppe >= 0 ? "+" : "") + statSistema.ppe?.toFixed(2), color: statSistema.ppe >= 0 ? "#15803D" : "#DC2626"},
                  {label:"Win Rate", val: statSistema.pct_vincenti?.toFixed(1) + "%", color:"#1D4ED8"},
                  {label:"Quota Media", val: statSistema.quota_media?.toFixed(2), color:"#1D4ED8"},
                  {label:"Max Win Run", val: statSistema.max_win_run, color:"#15803D"},
                  {label:"Max Lose Run", val: statSistema.max_lose_run, color:"#DC2626"},
                  {label:"Max Drawdown", val: statSistema.max_drawdown?.toFixed(2), color:"#DC2626"},
                  {label:"Esp. Max Giorn.", val: statSistema.espo_max_giornaliera?.toFixed(2), color:"#7C3AED"},
                  {label:"Esp. Max Sett.", val: statSistema.espo_max_settimanale?.toFixed(2), color:"#7C3AED"},
                  {label:"Size Ingresso", val: statSistema.size_ingresso != null ? (statSistema.size_ingresso * 100).toFixed(2) + "%" : "—", color:"#0369A1"},
                  {label:"Esp. Max Sett. Capitale", val: statSistema.esp_max_set_capitale != null ? statSistema.esp_max_set_capitale?.toFixed(1) + "%" : "—", color:"#0369A1"},
                ].map(({label, val, color}) => (
                  <div key={label} style={{flex:"1 1 100px",minWidth:100,
                    padding:"8px 12px",borderRight:"1px solid #F0F0EC",textAlign:"center"}}>
                    <div style={{fontSize:9,fontWeight:700,color:"#94A3B8",
                      textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:3}}>
                      {label}
                    </div>
                    <div style={{fontSize:15,fontWeight:700,color,
                      fontFamily:"'Roboto Mono',monospace"}}>
                      {val ?? "—"}
                    </div>
                  </div>
                ))}
              </div>

              {/* Tabella breakdown stagioni */}
              {statSistema.stagioni && statSistema.stagioni.length > 0 && (
                <div style={{margin:"8px 16px 10px",border:"1px solid #E8E8E4",
                  borderRadius:6,overflow:"hidden",fontSize:11,
                  width:"50%",minWidth:460}}>
                  <div onClick={() => setStatStagioniAperte(p => !p)}
                    style={{padding:"4px 10px",background:"#F8F8F5",cursor:"pointer",
                      display:"flex",alignItems:"center",gap:6,
                      borderBottom: statStagioniAperte ? "1px solid #E8E8E4" : "none",
                      userSelect:"none"}}>
                    <span style={{fontSize:9,fontWeight:700,color:"#1B2846",
                      textTransform:"uppercase",letterSpacing:"0.04em"}}>
                      Breakdown Stagioni
                    </span>
                    <span style={{fontSize:10,color:"#1B2846"}}>{statStagioniAperte ? "▲" : "▼"}</span>
                  </div>
                  {statStagioniAperte && <div style={{maxHeight:160,overflowY:"auto",paddingRight:10}}>
                    <table style={{width:"100%",borderCollapse:"collapse",tableLayout:"fixed"}}>
                      <colgroup>
                        <col style={{width:"13%"}} />
                        <col style={{width:"22%"}} />
                        <col style={{width:"20%"}} />
                        <col style={{width:"22%"}} />
                        <col style={{width:"23%"}} />
                      </colgroup>
                      <thead>
                        <tr>
                          {["Stagione","Punti","Eventi","% Eventi","PPE"].map(h => (
                            <th key={h} style={{position:"sticky",top:0,
                              background:"#F8F8F5",padding:"5px 10px",
                              textAlign: h === "Stagione" ? "left" : "right",
                              fontSize:9,fontWeight:700,color:"#94A3B8",
                              textTransform:"uppercase",letterSpacing:"0.04em",
                              borderBottom:"1px solid #E8E8E4"}}>
                              {h}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {statSistema.stagioni.map(s => {
                          const accesa = stagioniVista.includes(s.stagione);
                          const cella = {padding:"4px 10px",textAlign:"right",
                            fontFamily:"'Roboto Mono',monospace",
                            borderBottom: accesa ? "1px solid #BFDBFE" : "1px solid #F4F4F0",
                            background: accesa ? "#DBEAFE" : undefined};
                          return (
                          <tr key={s.stagione}
                            onClick={() => toggleStagione(s.stagione)}
                            title={accesa
                              ? "Togli questa stagione dalla consultazione"
                              : "Guarda i numeri di questa sola stagione"}
                            style={{cursor:"pointer"}}>
                            <td style={{...cella,textAlign:"left",fontWeight:accesa ? 700 : 600,
                              borderLeft: accesa ? "4px solid #1D4ED8" : "4px solid transparent",
                              color: accesa ? "#1E3A8A" : undefined}}>
                              {accesa && <span style={{marginRight:5,color:"#1D4ED8"}}>✓</span>}
                              {s.stagione}
                            </td>
                            <td style={{...cella,fontWeight:600,
                              color: s.punti >= 0 ? "#15803D" : "#DC2626"}}>
                              {s.punti >= 0 ? "+" : ""}{s.punti?.toFixed(2)}
                            </td>
                            <td style={cella}>
                              {s.eventi?.toLocaleString("it-IT")}
                            </td>
                            <td style={{...cella,color:"#6B6B66"}}>
                              {s.pct_ev?.toFixed(1)}%
                            </td>
                            <td style={{...cella,
                              color: s.ppe >= 0 ? "#15803D" : "#DC2626"}}>
                              {s.ppe >= 0 ? "+" : ""}{s.ppe?.toFixed(2)}
                            </td>
                          </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>}
                </div>
              )}
            </>
          )}
        </div>
      )}

      {/* ================================================================
          STRATO 3 — BARRA PARAMETRI + MERCATI (collassabile)
          ================================================================ */}
      <div style={{background:"#fff",borderBottom:"1px solid #E8E8E4"}}>

        {/* Riga mercati */}
        <div style={{padding:"8px 16px",display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
          <span onClick={() => setMercatiBarraAperta(p => !p)}
            style={{fontSize:10,fontWeight:700,color:"#1B2846",
              textTransform:"uppercase",letterSpacing:"0.06em",
              marginRight:2,whiteSpace:"nowrap",cursor:"pointer",userSelect:"none",
              display:"inline-flex",alignItems:"center",gap:4}}>
            Mercati
            <span style={{fontSize:10,opacity:0.7}}>{mercatiBarraAperta ? "▲" : "▼"}</span>
          </span>
          {mercatiBarraAperta && gruppiMercati.map((g, gi) => (
            <div key={g} style={{display:"flex",alignItems:"center",gap:3,
              paddingLeft: gi>0 ? 10 : 0,
              borderLeft: gi>0 ? "2px solid #CBD5E1" : "none"}}>
              <span onClick={(e) => { e.stopPropagation(); toggleGruppo(g); }}
                style={{fontSize:9,fontWeight:700,color:"#fff",cursor:"pointer",
                  textTransform:"uppercase",letterSpacing:"0.05em",
                  background:"#1B2846",borderRadius:4,padding:"2px 6px",
                  userSelect:"none",whiteSpace:"nowrap",marginRight:2}}>
                {g}
              </span>
              {MERCATI.filter(m => m.g === g).map(m => {
                const s = mercatiStato[m.id];
                const st = STATI[s];
                return (
                  <button key={m.id} onClick={(e) => { e.stopPropagation(); toggleMercato(m.id); }}
                    style={{
                      fontSize:10,fontWeight:600,
                      padding:"2px 7px",border:"1.5px solid",borderRadius:4,cursor:"pointer",
                      transition:"all 0.15s ease",
                      ...(st==="off" ? {background:"#F5F5F2",color:"#888880",borderColor:"#D0D0C8"} :
                         st==="vis" ? {background:"#DCFCE7",color:"#15803D",borderColor:"#86EFAC",boxShadow:"0 1px 3px rgba(22,163,74,0.2)"} :
                         st==="punta" ? {background:"#38BDF8",color:"#fff",borderColor:"#38BDF8",boxShadow:"0 1px 3px rgba(56,189,248,0.4)"} :
                         {background:"#F472B6",color:"#fff",borderColor:"#F472B6",boxShadow:"0 1px 3px rgba(244,114,182,0.4)"})
                    }}>
                    {m.label}{st!=="off" ? " "+STATI_LABEL[s] : ""}
                  </button>
                );
              })}
            </div>
          ))}
          {!mercatiBarraAperta && (() => {
            const attivi = Object.values(mercatiStato).filter(s => s >= 2).length;
            return attivi > 0 ? (
              <span style={{fontSize:11,fontWeight:600,color:"#0369A1",
                background:"#E0F2FE",border:"1px solid #7DD3FC",
                borderRadius:10,padding:"1px 8px"}}>
                {attivi} {attivi===1?"mercato":"mercati"} sistema
              </span>
            ) : <span style={{fontSize:11,color:"#A3A39E"}}>nessuno attivo</span>;
          })()}
        </div>
      </div>

      {/* ================================================================
          STRATO 4 — BARRA FILTRI ATTIVI (collassabile)
          ================================================================ */}
      {hasFiltri && (
        <div style={{background:"#FAFAF8",borderBottom:"1px solid #E8E8E4"}}>
          <div
            style={{padding:"5px 16px",display:"flex",alignItems:"center",
              flexWrap:"wrap",gap:5,userSelect:"none"}}>
            <span onClick={() => setFiltriBarraAperta(p => !p)}
              style={{fontSize:10,fontWeight:700,color:"#1B2846",
                textTransform:"uppercase",letterSpacing:"0.06em",
                cursor:"pointer",whiteSpace:"nowrap",
                display:"inline-flex",alignItems:"center",gap:4}}>
              Filtri attivi
              <span style={{fontSize:10,opacity:0.7}}>{filtriBarraAperta ? "▲" : "▼"}</span>
            </span>
            <span style={{fontSize:11,fontWeight:700,color:"#2563EB",
              background:"#EFF4FF",border:"1px solid #BFDBFE",
              borderRadius:10,padding:"1px 7px"}}>
              {Object.keys(filtri).length}
            </span>
            {filtriBarraAperta && Object.entries(filtri).map(([key, config]) => {
              const hasIncludi = config.includi && config.includi.length > 0;
              const hasEscludi = config.escludi && config.escludi.length > 0;
              const tags = [];
              if (hasIncludi) {
                tags.push(
                  <span key={key+"_f"} style={{
                    display:"inline-flex",alignItems:"center",gap:4,
                    padding:"3px 9px",borderRadius:20,fontSize:11,fontWeight:500,
                    fontFamily:"'Roboto Mono',monospace",
                    background:"#EFF4FF",color:"#1D4ED8",border:"1px solid #BFDBFE"
                  }}>
                    ✚ {fmtFiltro(key, {tipo:config.tipo,includi:config.includi,escludi:[]}).label}:&nbsp;
                    {fmtFiltro(key, {tipo:config.tipo,includi:config.includi,escludi:[]}).desc}
                    <button onClick={() => {
                      pushUndo();
                      const nf={...filtri};
                      nf[key]={...nf[key],includi:[]};
                      if (!nf[key].escludi?.length) delete nf[key];
                      setFiltri(nf);
                      if (hasCalcolato) calcola(nf);
                    }} style={{background:"none",border:"none",color:"#1D4ED8",cursor:"pointer",
                      fontSize:14,opacity:0.6,padding:0,lineHeight:1}}>×</button>
                  </span>
                );
              }
              if (hasEscludi) {
                tags.push(
                  <span key={key+"_e"} style={{
                    display:"inline-flex",alignItems:"center",gap:4,
                    padding:"3px 9px",borderRadius:20,fontSize:11,fontWeight:500,
                    fontFamily:"'Roboto Mono',monospace",
                    background:"#FEF2F2",color:"#DC2626",border:"1px solid #FECACA"
                  }}>
                    ✕ {fmtFiltro(key, {tipo:config.tipo,includi:[],escludi:config.escludi}).label}:&nbsp;
                    {fmtFiltro(key, {tipo:config.tipo,includi:[],escludi:config.escludi}).desc}
                    <button onClick={() => {
                      pushUndo();
                      const nf={...filtri};
                      nf[key]={...nf[key],escludi:[]};
                      if (!nf[key].includi?.length) delete nf[key];
                      setFiltri(nf);
                      if (hasCalcolato) calcola(nf);
                    }} style={{background:"none",border:"none",color:"#DC2626",cursor:"pointer",
                      fontSize:14,opacity:0.5,padding:0,lineHeight:1}}>×</button>
                  </span>
                );
              }
              return tags;
            })}
          </div>
        </div>
      )}

      {/* ================================================================
          AVVISO STORICO PARZIALE (D870/D871)
          Ancorato alla posizione, non alla barra filtri: compare qui anche
          quando non c'e' nessun filtro attivo.
          ================================================================ */}
      {avvisoStorico && (
        <div style={{padding:"8px 16px 0 16px"}}>
          <div style={{
            borderRadius:8,padding:"9px 14px",fontSize:12,lineHeight:1.6,
            ...(avvisoStorico.tipo === "usa"
              ? {background:"#E0F2FE",border:"1px solid #7DD3FC",color:"#0C4A6E"}
              : {background:"#FFF7ED",border:"1px solid #FED7AA",color:"#7C2D12"})
          }}>
            {avvisoStorico.tipo === "usa" ? (
              <>
                <strong>Il back test parte {avvisoStorico.blocco.dal}.</strong>{" "}
                Il sistema usa un mercato con le quote {avvisoStorico.blocco.nome}, che prima di quella data non
                esiste: le partite precedenti non sono operazioni e restano fuori dal conteggio.
              </>
            ) : (
              <>
                <strong>I mercati con le quote {avvisoStorico.blocco.nome} non coprono tutto lo storico.</strong>{" "}
                Esistono {avvisoStorico.blocco.dal} e prima di quella data non ci sono quote, quindi coprono meno
                partite rispetto ai mercati nati prima.
              </>
            )}
            {onNavigate && (
              <>
                {" "}
                <span onClick={() => onNavigate("anagrafica-storico")}
                  style={{textDecoration:"underline",cursor:"pointer",fontWeight:600,whiteSpace:"nowrap"}}>
                  Da quando parte ogni dato
                </span>
              </>
            )}
          </div>
        </div>
      )}

      {/* ================================================================
          STRATO 5 — ERRORI + BARRE NOTIFICA
          ================================================================ */}
      <div style={{padding:"0 16px"}}>
        {errore && (
          <div style={{background:"#FEF2F2",border:"1px solid #FECACA",borderRadius:8,
            padding:"7px 14px",color:"#DC2626",fontSize:12,marginTop:8}}>
            ⚠ {errore}
          </div>
        )}
        {haRisultati && usaSingolo && risultato && (
          <div style={{background:"#FFF7ED",border:"1px solid #FED7AA",borderRadius:8,
            padding:"6px 14px",marginTop:8,display:"flex",alignItems:"center",
            justifyContent:"space-between",fontSize:12}}>
            <span style={{color:"#92400E",fontWeight:500}}>
              👁 Vista singola: <strong>{getParamLabel(risultato._paramId || parametro)}</strong>
            </span>
            <button onClick={() => { setRisultato(null); setRisultatiMulti([]); setHasCalcolato(false); setUsaSingolo(false); }}
              style={{...btnGhost,fontSize:11,padding:"3px 10px",color:"#2563EB",borderColor:"#93C5FD"}}>
              Cancella vista
            </button>
          </div>
        )}

        {/* Barra somma selezione */}
        {selectedRows.size > 0 && haRisultati && (() => {
          let selRighe = [];
          let colonne = [];
          if (risultato) {
            selRighe = [...selectedRows].map(i => risultato.righe[i]).filter(Boolean);
            colonne = risultato.colonne || [];
          } else if (risultatiMulti.length > 0) {
            [...selectedRows].forEach(key => {
              const [pid, idx] = key.split("__");
              const block = risultatiMulti.find(b => b.paramId === pid);
              if (block) selRighe.push(block.data.righe[parseInt(idx)]);
            });
            colonne = risultatiMulti[0]?.data?.colonne || [];
          }
          const sumEv = selRighe.reduce((s,r) => s + r.eventi, 0);
          const sumSys = selRighe.reduce((s,r) => s + (r.sistema||0), 0);
          const sumMercati = {};
          colonne.forEach(c => {
            sumMercati[c] = selRighe.reduce((s,r) => s + (r.mercati[c]||0), 0);
          });
          const fmtSum = v => (v > 0 ? "+" : "") + v.toFixed(2);
          return (
            <div style={{display:"flex",flexWrap:"wrap",gap:5,alignItems:"center",
              marginTop:8,padding:"5px 10px",
              background:"#F8F8F6",borderRadius:8,border:"1px solid #E0E0DA"}}>
              <span style={{fontFamily:"'Roboto Mono',monospace",fontSize:11,fontWeight:600,
                padding:"3px 8px",borderRadius:5,
                background:"#F2F2EE",color:"#6B6B66",border:"1px solid #D8D8D4"}}>
                {selectedRows.size} righe | Ev: {sumEv.toLocaleString()}
              </span>
              <span style={{fontFamily:"'Roboto Mono',monospace",fontSize:11,fontWeight:700,
                padding:"3px 8px",borderRadius:5,
                background:sumSys>0?"#F0FDF4":sumSys<0?"#FEF2F2":"#F2F2EE",
                color:sumSys>0?"#15803D":sumSys<0?"#DC2626":"#6B6B66",
                border:"1px solid "+(sumSys>0?"#86EFAC":sumSys<0?"#FECACA":"#E8E8E4")}}>
                Sis: {fmtSum(sumSys)}
              </span>
              {colonne.map(c => {
                const v = sumMercati[c];
                if (v === 0) return null;
                const isB = c.includes("_b")||c.startsWith("pl_b")||c.startsWith("pl_qb");
                return (
                  <span key={c} style={{fontFamily:"'Roboto Mono',monospace",fontSize:11,
                    fontWeight:500,padding:"3px 7px",borderRadius:5,
                    ...(isB
                      ? {background:"#FDF2F8",color:"#BE185D",border:"1px solid #F9A8D4"}
                      : {background:"#F0F7FF",color:"#1D4ED8",border:"1px solid #BFDBFE"})}}>
                    {fmtCol(c)}: {fmtSum(v)}
                  </span>
                );
              })}
            </div>
          );
        })()}
      </div>

      {/* ================================================================
          STRATO 6a — PANNELLO SISTEMI SALVATI (quando aperto)
          ================================================================ */}
      {/* ================================================================
          DRAWER PARAMETRI STATISTICI
          ================================================================ */}
      {drawerParametriAperto && (
        <div style={{position:"fixed",inset:0,zIndex:1200}}
          onClick={() => setDrawerParametriAperto(false)}>
          <div style={{
            position:"fixed",top:0,right:0,height:"100vh",
            width:"calc(100vw - 56px)",
            background:"#fff",boxShadow:"-4px 0 24px rgba(0,0,0,0.13)",
            display:"flex",flexDirection:"column",zIndex:1201,
          }} onClick={e => e.stopPropagation()}>

            {/* Header drawer */}
            <div style={{padding:"16px 24px 12px",borderBottom:"1px solid #E8E8E4",
              display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0}}>
              <div style={{display:"flex",alignItems:"center",gap:10}}>
                <span style={{fontSize:16}}>📊</span>
                <span style={{fontSize:15,fontWeight:700,color:"#1A1A18"}}>Parametri statistici</span>
                <span style={{
                  background:"#1B2846",color:"#fff",borderRadius:10,
                  fontSize:10,fontWeight:700,padding:"1px 8px",
                }}>{defaultParams.size} attivi</span>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <button onClick={(e)=>{e.stopPropagation();
                  const all=new Set(); PARAMETRI.forEach(c=>c.items.forEach(i=>all.add(i.id)));
                  setDefaultParams(all); setMultiParams(all); salvaDefaultParams(all);}}
                  style={{...btnGhost,fontSize:11,padding:"4px 10px",color:"#16A34A",borderColor:"#BBF7D0"}}>
                  Seleziona tutti
                </button>
                <button onClick={(e)=>{e.stopPropagation();
                  setDefaultParams(new Set()); setMultiParams(new Set()); salvaDefaultParams(new Set());}}
                  style={{...btnGhost,fontSize:11,padding:"4px 10px",color:"#DC2626",borderColor:"#FECACA"}}>
                  Deseleziona tutti
                </button>
                {/* Separatore verticale */}
                <div style={{width:1,height:20,background:"#E8E8E4",margin:"0 4px"}}></div>
                {/* Pulsante Calcola — attivo solo se la selezione differisce dall'ultimo calcolo */}
                {(() => {
                  const selezioneDiversa = hasCalcolato && multiParams.size > 0 && (
                    multiParams.size !== paramsUltimoCalcolo.size ||
                    [...multiParams].some(p => !paramsUltimoCalcolo.has(p))
                  );
                  const attivo = selezioneDiversa && !loading;
                  return (
                    <button
                      onClick={(e)=>{
                        e.stopPropagation();
                        if (!attivo) return;
                        setDrawerParametriAperto(false);
                        calcola();
                      }}
                      disabled={!attivo}
                      title={attivo ? "Applica i nuovi parametri e ricalcola" : "Nessuna modifica da applicare"}
                      style={{
                        fontSize:11, fontWeight:700, padding:"4px 12px", borderRadius:6,
                        border: attivo ? "1px solid #2563EB" : "1px solid #E8E8E4",
                        background: attivo ? "#2563EB" : "#F5F5F4",
                        color: attivo ? "#fff" : "#A3A39E",
                        cursor: attivo ? "pointer" : "not-allowed",
                        display:"flex", alignItems:"center", gap:5,
                      }}>
                      <span style={{fontSize:10}}>▶</span>
                      Calcola
                      {selezioneDiversa && <span style={{
                        fontSize:8, background: attivo ? "#fff" : "transparent",
                        color: attivo ? "#2563EB" : "#A3A39E",
                        borderRadius:10, padding:"0 5px", fontWeight:700,
                      }}>●</span>}
                    </button>
                  );
                })()}
                <button onClick={() => setDrawerParametriAperto(false)}
                  style={{background:"none",border:"none",cursor:"pointer",
                    fontSize:20,color:"#6B6B66",lineHeight:1,padding:"0 4px"}}>✕</button>
              </div>
            </div>

            {/* Corpo — griglia categorie */}
            <div style={{flex:1,overflowY:"auto",padding:"16px 24px",
              display:"flex",flexWrap:"wrap",gap:14,alignItems:"start"}}>
              {PARAMETRI.map(cat => {
                const allOn = cat.items.every(i => defaultParams.has(i.id));
                return (
                  <div key={cat.cat} style={{
                    background:"#EFF6FF",borderRadius:8,padding:"12px",border:"0.5px solid #BFDBFE",width:"fit-content",
                  }}>
                    {/* Titolo categoria — click seleziona/deseleziona tutti */}
                    <div
                      onClick={(e)=>{
                        e.stopPropagation();
                        const next = new Set(defaultParams);
                        if (allOn) { cat.items.forEach(i => next.delete(i.id)); }
                        else { cat.items.forEach(i => next.add(i.id)); }
                        setDefaultParams(next);
                        setMultiParams(next);
                        salvaDefaultParams(next);
                      }}
                      style={{fontSize:9,fontWeight:700,textTransform:"uppercase",
                        letterSpacing:"0.07em",color:"#1B2846",cursor:"pointer",
                        marginBottom:8,paddingBottom:6,borderBottom:"0.5px solid #E8E8E4",
                        userSelect:"none"}}>
                      {cat.cat}
                    </div>
                    <div style={{display:"flex",flexDirection:"column",gap:4}}>
                      {cat.items.map(item => {
                        const isOn = defaultParams.has(item.id);
                        return (
                          <span key={item.id}
                            onClick={(e)=>{
                              e.stopPropagation();
                              const next = new Set(defaultParams);
                              if (isOn) next.delete(item.id); else next.add(item.id);
                              setDefaultParams(next);
                              setMultiParams(next);
                              salvaDefaultParams(next);
                            }}
                            style={{
                              padding:"5px 10px",borderRadius:5,cursor:"pointer",
                              fontSize:11,fontWeight: isOn ? 600 : 400,
                              background: isOn ? "#1B2846" : "#fff",
                              color: isOn ? "#fff" : "#444440",
                              border: isOn ? "1px solid #1B2846" : "0.5px solid #E8E8E4",
                              userSelect:"none",
                            }}>
                            {item.l}
                          </span>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>

          </div>
        </div>
      )}

      {/* ================================================================
          DRAWER SISTEMI SALVATI
          ================================================================ */}
      {sistemiDrawerAperto && (
        <div style={{position:"fixed",inset:0,zIndex:1200}}
          onClick={() => setSistemiDrawerAperto(false)}>
          <div style={{
            position:"fixed",top:0,right:0,height:"100vh",
            width:"calc(100vw - 56px)",
            background:"#fff",boxShadow:"-4px 0 24px rgba(0,0,0,0.13)",
            display:"flex",flexDirection:"column",
            zIndex:1201,
          }} onClick={e => e.stopPropagation()}>
            {/* Header drawer */}
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",
              padding:"14px 18px",borderBottom:"1px solid #E8E8E4",
              background:"#FAFAF8",flexShrink:0}}>
              <span style={{fontSize:13,fontWeight:700,color:"#1A1A18"}}>📂 Sistemi Salvati</span>
              <button onClick={() => setSistemiDrawerAperto(false)}
                style={{background:"none",border:"none",cursor:"pointer",
                  color:"#64748B",fontSize:16,padding:"2px 6px",borderRadius:4}}
                title="Chiudi">✕</button>
            </div>
            {/* Contenuto */}
            <div style={{flex:1,overflowY:"auto"}}>
              {sistemiSalvati.length === 0 ? (
                <div style={{fontSize:13,color:"#A3A39E",padding:"24px 18px",textAlign:"center"}}>
                  Nessun sistema salvato.
                </div>
              ) : (
                <Fragment>
                <div style={{display:"flex",justifyContent:"flex-end",alignItems:"center",height:34,padding:"0 16px"}}>
                  <label title="Nasconde i sistemi mai attivati e quelli dismessi. Restano tutti in elenco togliendo la spunta."
                    style={{display:"inline-flex",alignItems:"center",gap:6,fontSize:11,
                      color:"#475569",cursor:"pointer",userSelect:"none"}}>
                    <input type="checkbox" checked={nascondiNonAttiviArch}
                      onChange={e => setNascondiNonAttiviArch(e.target.checked)}
                      style={{cursor:"pointer"}}/>
                    Nascondi non attivi
                  </label>
                </div>
                <table style={{width:"100%",borderCollapse:"collapse",fontFamily:"'DM Sans',sans-serif"}}>
                  <thead>
                    <tr style={{background:"#1B2846",borderBottom:"1px solid #0f1f3d"}}>
                      {["Nome","Mercato","Commenti","Stato","Azioni"].map(h => (
                        <th key={h} style={{
                          padding:"10px 16px",textAlign:"center",
                          fontSize:10,fontWeight:700,color:"#fff",
                          textTransform:"uppercase",letterSpacing:"0.06em",
                        }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {sistemiSalvati.filter(s => !(nascondiNonAttiviArch && s.attivo === false)).map(s => (
                      <tr key={s.id}
                        style={{
                          borderBottom:"1px solid #F4F4F0",
                          background: sysId === s.id ? "#EFF4FF" : "",
                          borderLeft: sysId === s.id ? "3px solid #2563EB" : "3px solid transparent",
                          transition:"background 0.1s",
                        }}
                        onMouseEnter={e => { if (sysId !== s.id) e.currentTarget.style.background="#F8FAFF"; }}
                        onMouseLeave={e => { if (sysId !== s.id) e.currentTarget.style.background=""; }}>
                        <td style={{padding:"10px 16px",textAlign:"center",fontWeight:600,color:"#1E293B",fontSize:12}}>
                          {s.nome}
                          {(s.data_attivazione || s.data_sospensione) && (
                            <div style={{fontSize:10,fontWeight:400,color:"#94A3B8",marginTop:2,
                              fontFamily:"'IBM Plex Mono',monospace"}}>
                              {s.attivo === false
                                ? (s.data_sospensione ? `dismesso dal ${formattaDataIT(s.data_sospensione)}` : "")
                                : `attivo dal ${formattaDataIT(s.data_attivazione)}`}
                              {s.numero_revisione > 0 ? ` · rev. ${s.numero_revisione}` : ""}
                            </div>
                          )}
                        </td>
                        <td style={{padding:"10px 16px",textAlign:"center",fontSize:12,color:"#475569"}}>{s.mercato || "—"}</td>
                        <td style={{padding:"10px 16px",textAlign:"center",fontSize:12,color:"#475569"}}>{s.commenti || "—"}</td>
                        <td style={{padding:"10px 16px",textAlign:"center"}}>
                          <button onClick={(e) => { e.stopPropagation(); toggleAttivoSistema(s); }}
                            style={{width:36,height:20,borderRadius:10,border:"none",cursor:"pointer",
                              background: s.attivo ? "#16A34A" : "#D4D4D4",
                              position:"relative",transition:"background 0.2s",flexShrink:0}}>
                            <div style={{width:14,height:14,borderRadius:7,background:"#fff",
                              position:"absolute",top:3,
                              left: s.attivo ? 19 : 3,
                              transition:"left 0.2s",boxShadow:"0 1px 3px rgba(0,0,0,0.2)"}} />
                          </button>
                          {s.attivo && s.filtri_modificati_il && (
                            <span title="Filtri cambiati e mai confermati come nuova revisione"
                              style={{marginLeft:6,color:"#B45309",fontSize:13,cursor:"default",
                                verticalAlign:"middle"}}>&#9888;</span>
                          )}
                          <div style={{fontSize:10,fontWeight:600,marginTop:3,
                            color: s.attivo ? "#16A34A" : (s.data_attivazione ? "#94A3B8" : "#CBD5E1")}}>
                            {s.attivo ? "Attivo" : (s.data_attivazione ? "Dismesso" : "Mai attivato")}
                          </div>
                        </td>
                        <td style={{padding:"10px 16px",textAlign:"center",whiteSpace:"nowrap"}}>
                          <button onClick={() => { const r = caricaSistema(s); setSistemiDrawerAperto(false); calcola(r.filtriPuliti, undefined, r.mercatiSistema); }}
                            style={{fontSize:11,padding:"4px 12px",borderRadius:6,border:"1px solid #93C5FD",
                              background:"#EFF6FF",color:"#2563EB",cursor:"pointer",marginRight:6,fontWeight:600}}>
                            📂 Carica
                          </button>
                          <button onClick={() => eliminaSistema(s.id)}
                            style={{fontSize:11,padding:"4px 12px",borderRadius:6,border:"1px solid #FECACA",
                              background:"#FFF5F5",color:"#DC2626",cursor:"pointer",fontWeight:600}}>
                            🗑 Elimina
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ================================================================
          STRATO 5.5 — VISTA P/L
          ================================================================ */}
      {vistaPL && hasSistema && risultatiMulti.length > 0 && (() => {
        const { righe, totEventi, totSistema } = buildVistaPLRighe();
        const fmtPL = (v) => v === 0 ? "0.00" : (v > 0 ? "+" : "") + v.toFixed(2);
        return (
          <div style={{margin:"8px 16px 16px",borderRadius:10,overflow:"hidden",
            border:"1px solid #FED7AA",boxShadow:"0 2px 8px rgba(0,0,0,0.06)"}}>
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
              <thead>
                {/* Riga totale fissa */}
                <tr style={{background:"#1B2846"}}>
                  <td colSpan={2} style={{padding:"8px 14px",color:"#fff",fontSize:11,fontWeight:700,
                    textTransform:"uppercase",letterSpacing:"0.06em"}}>
                    🔻 Vista P/L — Totale sistema
                  </td>
                  <td style={{padding:"8px 10px",textAlign:"center",color:"#93C5FD",
                    fontFamily:"'Roboto Mono',monospace",fontWeight:700,fontSize:12}}>
                    {totEventi?.toLocaleString()}
                  </td>
                  <td style={{padding:"8px 10px",textAlign:"center",color:"#93C5FD",
                    fontFamily:"'Roboto Mono',monospace",fontWeight:700,fontSize:12}}>
                    100%
                  </td>
                  <td style={{padding:"8px 14px",textAlign:"right",
                    fontFamily:"'Roboto Mono',monospace",fontWeight:700,fontSize:13,
                    color: totSistema >= 0 ? "#34D399" : "#F87171"}}>
                    {fmtPL(totSistema)}
                  </td>
                  <td style={{padding:"8px 10px"}} />
                </tr>
                {/* Intestazioni colonne */}
                <tr style={{background:"#F8F8F6",borderBottom:"2px solid #FED7AA"}}>
                  <th style={{...thStyle,textAlign:"left",background:"#F8F8F6",color:"#1B2846"}}>Parametro</th>
                  <th style={{...thStyle,textAlign:"left",background:"#F8F8F6",color:"#1B2846"}}>Intervallo</th>
                  <th style={{...thStyle,textAlign:"center",background:"#F8F8F6",color:"#1B2846"}}>Eventi</th>
                  <th style={{...thStyle,textAlign:"center",background:"#F8F8F6",color:"#1B2846"}}>% Tot</th>
                  <th style={{...thStyle,textAlign:"right",background:"#F8F8F6",color:"#EA580C",
                    cursor:"pointer"}}
                    onClick={() => setVistaPLSortDir(d => d === "asc" ? "desc" : "asc")}>
                    {sommaMode ? "P/L Sistema" : "PPE"} {vistaPLSortDir === "asc" ? "▲" : "▼"}
                  </th>
                  <th style={{...thStyle,textAlign:"center",background:"#F8F8F6",color:"#1B2846",width:80}}>
                    Azione
                  </th>
                </tr>
              </thead>
              <tbody>
                {righe.map(({ paramId, label, row, rowIdx, plSistema, pct }, idx) => {
                  const isNeg = plSistema < 0;
                  const bgRow = idx % 2 === 0 ? "#fff" : "#FAFAF8";
                  const v1 = row.v1 !== null && row.v1 !== undefined ? row.v1 : "";
                  const v2 = row.v2 !== null && row.v2 !== undefined ? row.v2 : null;
                  const intervallo = v2 !== null ? `> ${v1} | ≤ ${v2}` : String(v1);
                  return (
                    <tr key={`pl_${paramId}_${rowIdx}`} style={{background:bgRow,
                      borderBottom:"1px solid #F0F0EC"}}>
                      <td style={{...tdStyle,color:"#1D4ED8",fontWeight:600,
                        fontFamily:"'DM Sans',sans-serif",fontSize:11}}>
                        {label}
                      </td>
                      <td style={{...tdStyle,fontFamily:"'Roboto Mono',monospace",fontSize:11}}>
                        {intervallo}
                      </td>
                      <td style={{...tdStyle,textAlign:"center",color:"#444440"}}>
                        {row.eventi?.toLocaleString()}
                      </td>
                      <td style={{...tdStyle,textAlign:"center",color:"#6B6B66"}}>
                        {pct.toFixed(1)}%
                      </td>
                      <td style={{...tdStyle,textAlign:"right",fontFamily:"'Roboto Mono',monospace",
                        fontWeight:700,color: isNeg ? "#DC2626" : "#16A34A"}}>
                        {fmtPL(plSistema)}
                      </td>
                      <td style={{...tdStyle,textAlign:"center"}}>
                        {(() => {
                          const isIntervallo = v2 !== null;
                          const applyFiltro = (tipo) => {
                            // Calcola newFiltri
                            const newFiltri = { ...filtri };
                            const righeP = risultatiMulti.find(b => b.paramId === paramId)?.data?.righe || [];
                            const tipoFiltro = tipoParametro(paramId, righeP);
                            newFiltri[paramId] = allineaTipo(newFiltri[paramId], tipoFiltro);
                            const fkey = tipo === "forza" ? "includi" : "escludi";
                            newFiltri[paramId][fkey] = [...(newFiltri[paramId][fkey]||[]), voceFiltro(tipoFiltro, row)];
                            // Calcola anteprima Prima/Dopo
                            const primaEventi = totEventi;
                            const primaPL = totSistema;
                            const dopoEventi = tipo === "escludi" ? primaEventi - row.eventi : row.eventi;
                            const dopoPL = tipo === "escludi" ? primaPL - row.sistema : row.sistema;
                            // Apre dialog di conferma
                            setVistaPLConfirm({
                              tipo, paramId, label,
                              intervallo: v2 !== null ? `> ${v1} | ≤ ${v2}` : String(v1),
                              primaEventi, primaPL,
                              dopoEventi, dopoPL,
                              newFiltri,
                            });
                          };
                          if (isNeg) return (
                            <button onClick={() => applyFiltro("escludi")}
                              style={{padding:"3px 10px",fontSize:10,fontWeight:700,
                                border:"1.5px solid #FECACA",borderRadius:5,
                                background:"#FEF2F2",color:"#DC2626",cursor:"pointer"}}>
                              Escludi
                            </button>
                          );
                          if (plSistema > 0) return (
                            <button onClick={() => applyFiltro("forza")}
                              style={{padding:"3px 10px",fontSize:10,fontWeight:700,
                                border:"1.5px solid #86EFAC",borderRadius:5,
                                background:"#F0FDF4",color:"#16A34A",cursor:"pointer"}}>
                              Forza
                            </button>
                          );
                          return <span style={{color:"#D1D5DB",fontSize:11}}>—</span>;
                        })()}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      })()}

      {/* ================================================================
          STRATO 5.6 — VISTA P/L MERCATI
          ================================================================ */}
      {vistaMercati && risultatiMulti.length > 0 && (() => {
        const { righe, colonnePL, totEventi } = buildVistaMercatiRighe();
        const fmtPL = (v) => v === 0 ? "0.00" : (v > 0 ? "+" : "") + v.toFixed(2);
        const sortCol = vistaMercatiSortCol || (colonnePL.length > 0 ? colonnePL[0].col : null);
        const handleSort = (col) => {
          if (vistaMercatiSortCol === col) {
            setVistaMercatiSortDir(d => d === "desc" ? "asc" : "desc");
          } else {
            setVistaMercatiSortCol(col);
            setVistaMercatiSortDir("desc");
          }
        };
        // Calcola maxAbs per heatmap per ogni colonna
        const maxAbsMap = {};
        colonnePL.forEach(({ col }) => {
          maxAbsMap[col] = Math.max(...righe.map(r => Math.abs(r.row.mercati?.[col] || 0)), 1);
        });
        return (
          <div style={{margin:"8px 16px 16px",borderRadius:10,overflow:"hidden",
            border:"1px solid #86EFAC",boxShadow:"0 2px 8px rgba(0,0,0,0.06)"}}>
            <div style={{overflowX:"auto"}}>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                <thead>
                  {/* Riga header */}
                  <tr style={{background:"#1B2846"}}>
                    <td colSpan={4} style={{padding:"8px 14px",color:"#fff",fontSize:11,fontWeight:700,
                      textTransform:"uppercase",letterSpacing:"0.06em"}}>
                      📊 Vista P/L Mercati
                    </td>
                    {colonnePL.map(({ col }) => (
                      <td key={col} style={{padding:"8px 6px",textAlign:"center",
                        fontFamily:"'Roboto Mono',monospace",fontWeight:700,fontSize:11}}>
                      </td>
                    ))}
                  </tr>
                  {/* Intestazioni colonne cliccabili */}
                  <tr style={{background:"#F8F8F6",borderBottom:"2px solid #86EFAC"}}>
                    <th style={{...thStyle,textAlign:"left",background:"#F8F8F6",color:"#1B2846"}}>Parametro</th>
                    <th style={{...thStyle,textAlign:"left",background:"#F8F8F6",color:"#1B2846"}}>Intervallo</th>
                    <th style={{...thStyle,textAlign:"center",background:"#F8F8F6",color:"#1B2846"}}>Eventi</th>
                    <th style={{...thStyle,textAlign:"center",background:"#F8F8F6",color:"#1B2846"}}>% Tot</th>
                    {colonnePL.map(({ col }) => {
                      const isB = col.includes("_b") || col.startsWith("pl_b") || col.startsWith("pl_qb");
                      const isSorted = col === sortCol;
                      return (
                        <th key={col}
                          style={{...thStyle,textAlign:"right",
                            background: isSorted ? "#1B2846" : (isB ? "#FFF0F6" : "#EFF9FF"),
                            borderTop: isB ? "3px solid #F472B6" : "3px solid #38BDF8",
                            color: isSorted ? "#fff" : (isB ? "#9D174D" : "#0369A1"),
                            cursor:"pointer",userSelect:"none",whiteSpace:"nowrap"}}
                          onClick={() => handleSort(col)}>
                          {fmtCol(col)} {isSorted ? (vistaMercatiSortDir === "desc" ? "▼" : "▲") : ""}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {righe.map(({ paramId, label, row, rowIdx, pct }, idx) => {
                    const bgRow = idx % 2 === 0 ? "#fff" : "#FAFAF8";
                    const v1 = row.v1 !== null && row.v1 !== undefined ? row.v1 : "";
                    const v2 = row.v2 !== null && row.v2 !== undefined ? row.v2 : null;
                    const intervallo = v2 !== null ? `> ${v1} | ≤ ${v2}` : String(v1);
                    return (
                      <tr key={`pm_${paramId}_${rowIdx}`} style={{background:bgRow,
                        borderBottom:"1px solid #F0F0EC"}}>
                        <td style={{...tdStyle,color:"#1D4ED8",fontWeight:600,
                          fontFamily:"'DM Sans',sans-serif",fontSize:11}}>
                          {label}
                        </td>
                        <td style={{...tdStyle,fontFamily:"'Roboto Mono',monospace",fontSize:11}}>
                          {intervallo}
                        </td>
                        <td style={{...tdStyle,textAlign:"center",color:"#444440"}}>
                          {row.eventi?.toLocaleString()}
                        </td>
                        <td style={{...tdStyle,textAlign:"center",color:"#6B6B66"}}>
                          {pct.toFixed(1)}%
                        </td>
                        {colonnePL.map(({ col }) => {
                          const raw = row.mercati?.[col] || 0;
                          const val = sommaMode ? raw : (row.eventi > 0 ? +(raw / row.eventi).toFixed(2) : 0);
                          const bg = heatBg(val, maxAbsMap[col]);
                          const isSorted = col === sortCol;
                          return (
                            <td key={col} style={{...tdStyle,textAlign:"right",
                              fontFamily:"'Roboto Mono',monospace",fontWeight:700,
                              color: val > 0 ? "#16A34A" : val < 0 ? "#DC2626" : "#A3A39E",
                              ...(isSorted ? {background:"#eff6ff"} : bg)}}>
                              {val !== 0 ? fmtPL(val) : "—"}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        );
      })()}

      {/* ================================================================
          STRATO 5.7 — VISTA ZONE CONTINUE
          ================================================================ */}
      {vistaZone && hasSistema && risultatiMulti.length > 0 && (() => {
        const Z = buildZoneContinue();
        const fmtPL = (v) => v === 0 ? "0.00" : (v > 0 ? "+" : "") + v.toFixed(2);
        const fmtVar = (v) => (v > 0 ? "+" : "") + v.toFixed(2);
        const ordina = (arr) => {
          if (!zoneSortCol) return arr;
          const get = (z) => zoneSortCol === "eventi" ? z.eventi : zoneSortCol === "ppe" ? z.ppe : z.pl;
          return [...arr].sort((a, b) => zoneSortDir === "desc" ? get(b) - get(a) : get(a) - get(b));
        };
        const cliccaCol = (col) => {
          if (zoneSortCol === col) setZoneSortDir(d => d === "desc" ? "asc" : "desc");
          else { setZoneSortCol(col); setZoneSortDir("desc"); }
        };
        const frecciaCol = (col) => zoneSortCol === col ? (zoneSortDir === "desc" ? " ▼" : " ▲") : " ⇅";
        const listaForzare = zoneMostraTutte ? (Z.candidate || []) : Z.daForzare;

        const thS = {padding:"6px 8px",fontSize:10,fontWeight:700,color:"#1B2846",
          background:"#F8F8F6",textTransform:"uppercase",letterSpacing:"0.03em"};
        const thGruppo = {padding:"4px 8px",fontSize:9,fontWeight:700,color:"#94A3B8",
          background:"#F8F8F6",textAlign:"center",textTransform:"uppercase",
          letterSpacing:"0.04em",borderBottom:"1px solid #E8E8E4"};
        const td = {padding:"6px 8px",fontSize:11,borderBottom:"1px solid #F0F0EC"};
        const tdNum = {...td,textAlign:"right",fontFamily:"'Roboto Mono',monospace"};

        const applicaZona = (z, tipo) => {
          const newFiltri = { ...filtri };
          if (!newFiltri[z.paramId]) newFiltri[z.paramId] = { tipo:"intervallo", includi:[], escludi:[] };
          else newFiltri[z.paramId] = { ...newFiltri[z.paramId], tipo:"intervallo" };
          const fkey = tipo === "forza" ? "includi" : "escludi";
          newFiltri[z.paramId][fkey] = [...(newFiltri[z.paramId][fkey]||[]), { min: Number(z.v1), max: Number(z.v2) }];
          setVistaPLConfirm({
            tipo, paramId: z.paramId, label: z.label,
            intervallo: `> ${z.v1} | ≤ ${z.v2}`,
            primaEventi: Z.sysEventi, primaPL: Z.sysPunti,
            dopoEventi: z.dopoEventi, dopoPL: z.dopoPL,
            newFiltri,
          });
        };

        const Tabella = ({ lista, verso }) => (
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead>
              <tr>
                <th colSpan={5} style={{...thGruppo,textAlign:"left"}} />
                <th colSpan={2} style={thGruppo}>Sistema dopo</th>
                <th colSpan={2} style={thGruppo}>Variazione</th>
                <th style={thGruppo} />
              </tr>
              <tr style={{borderBottom:"2px solid #99F6E4"}}>
                <th style={{...thS,textAlign:"left"}}>Parametro</th>
                <th style={{...thS,textAlign:"left"}}>Fascia</th>
                <th style={{...thS,textAlign:"right",cursor:"pointer"}} onClick={() => cliccaCol("eventi")}>Ev{frecciaCol("eventi")}</th>
                <th style={{...thS,textAlign:"right",cursor:"pointer"}} onClick={() => cliccaCol("pl")}>P/L{frecciaCol("pl")}</th>
                <th style={{...thS,textAlign:"right",cursor:"pointer"}} onClick={() => cliccaCol("ppe")}>PPE{frecciaCol("ppe")}</th>
                <th style={{...thS,textAlign:"right"}}>P/L</th>
                <th style={{...thS,textAlign:"right"}}>PPE</th>
                <th style={{...thS,textAlign:"right"}}>P/L</th>
                <th style={{...thS,textAlign:"right"}}>PPE</th>
                <th style={{...thS,textAlign:"center",width:74}}>Azione</th>
              </tr>
            </thead>
            <tbody>
              {lista.length === 0 && (
                <tr><td colSpan={10} style={{...td,textAlign:"center",color:"#94A3B8",padding:"14px"}}>
                  Nessuna fascia trovata con i filtri attuali.
                </td></tr>
              )}
              {ordina(lista).map((z, idx) => (
                <tr key={`${verso}_${z.paramId}_${z.v1}_${z.v2}`} style={{background: idx % 2 === 0 ? "#fff" : "#FAFAF8"}}>
                  <td style={{...td,color:"#1D4ED8",fontWeight:600}}>{z.label}</td>
                  <td style={{...td,fontFamily:"'Roboto Mono',monospace"}}>{`> ${z.v1} | ≤ ${z.v2}`}</td>
                  <td style={tdNum}>
                    {z.eventi?.toLocaleString("it-IT")}
                    {z.sottoSoglia && <span title={`Dopo questa mossa il sistema resterebbe con una media di ${z.dopoPerStagione} eventi per stagione, sotto la soglia di ${Z.sogliaEventiStagione} (numero minimo consigliabile).`}
                      style={{color:"#D97706",marginLeft:4,cursor:"help"}}>⚠</span>}
                  </td>
                  <td style={{...tdNum,color: z.pl < 0 ? "#DC2626" : "#16A34A"}}>{fmtPL(z.pl)}</td>
                  <td style={{...tdNum,color: z.ppe < 0 ? "#DC2626" : "#16A34A"}}>{z.ppe.toFixed(2)}</td>
                  <td style={tdNum}>{z.dopoPL.toFixed(2)}</td>
                  <td style={tdNum}>{z.dopoPPE.toFixed(2)}</td>
                  <td style={{...tdNum,fontWeight:700,color: z.varPL > 0 ? "#16A34A" : z.varPL < 0 ? "#DC2626" : "#6B6B66"}}>{fmtVar(z.varPL)}</td>
                  <td style={{...tdNum,fontWeight:700,color: z.varPPE > 0 ? "#16A34A" : z.varPPE < 0 ? "#DC2626" : "#6B6B66"}}>{fmtVar(z.varPPE)}</td>
                  <td style={{...td,textAlign:"center",whiteSpace:"nowrap"}}>
                    <button onClick={() => applicaZona(z, verso)}
                      style={{padding:"3px 10px",fontSize:10,fontWeight:700,borderRadius:5,cursor:"pointer",
                        border: verso === "escludi" ? "1.5px solid #FECACA" : "1.5px solid #86EFAC",
                        background: verso === "escludi" ? "#FEF2F2" : "#F0FDF4",
                        color: verso === "escludi" ? "#DC2626" : "#16A34A"}}>
                      {verso === "escludi" ? "Escludi" : "Forza"}
                    </button>
                    {rigaInStandby(z.paramId, z.v1, z.v2) ? (
                      <span title="Questa zona è già nella Lista Standby"
                        style={{marginLeft:4,padding:"3px 8px",fontSize:10,fontWeight:700,borderRadius:5,
                          display:"inline-block",cursor:"help",
                          border:"1.5px solid #E5E1F5",background:"#FAF9FE",color:"#A99CD6"}}>
                        ⏸ In lista
                      </span>
                    ) : (
                      <button onClick={() => aggiungiFasce([{ paramId: z.paramId, label: z.label, v1: z.v1, v2: z.v2 }])}
                        title="Mette questa zona nella Lista Standby, senza applicarla al sistema."
                        style={{marginLeft:4,padding:"3px 8px",fontSize:10,fontWeight:700,borderRadius:5,cursor:"pointer",
                          border:"1.5px solid #C4B5FD",background:"#F5F3FF",color:"#7C3AED"}}>
                        Standby
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        );

        return (
          <div style={{margin:"8px 16px 16px",borderRadius:10,overflow:"hidden",
            border:"1px solid #99F6E4",boxShadow:"0 2px 8px rgba(0,0,0,0.06)"}}>
            <div style={{background:"#1B2846",padding:"8px 14px",display:"flex",
              alignItems:"center",gap:10,flexWrap:"wrap"}}>
              <span style={{color:"#fff",fontSize:11,fontWeight:700,textTransform:"uppercase",
                letterSpacing:"0.06em"}}>▤ Zone Continue</span>
              <span style={{color:"#93C5FD",fontFamily:"'Roboto Mono',monospace",fontSize:11}}>
                {Z.sysEventi?.toLocaleString("it-IT")} eventi · {fmtPL(Z.sysPunti)} punti · PPE {Z.sysPPE.toFixed(2)}
                {Z.sysPerStagione !== null ? ` · ${Z.sysPerStagione} ev/stagione` : ""}
              </span>
            </div>
            <div style={{background:"#F8F8F6",padding:"5px 14px",fontSize:10,color:"#6B6B66",
              borderBottom:"1px solid #E8E8E4"}}>
              I numeri valgono per la prossima mossa: dopo ogni filtro la classifica si rifà.
            </div>

            <div style={{background:"#FEF2F2",padding:"7px 14px",fontSize:11,fontWeight:700,
              color:"#991B1B",borderBottom:"1px solid #FECACA"}}>
              Fasce da escludere — {Z.escludereTot} fasce
            </div>
            <Tabella lista={Z.daEscludere} verso="escludi" />

            <div style={{height:14,background:"#F1F0EC",
              borderTop:"1px solid #E0DFD9",borderBottom:"1px solid #E0DFD9"}} />

            <div style={{background:"#F0FDF4",padding:"7px 14px",display:"flex",alignItems:"center",
              gap:10,flexWrap:"wrap",borderBottom:"1px solid #BBF7D0"}}>
              <span style={{fontSize:11,fontWeight:700,color:"#166534"}}>
                Fasce da forzare — {Z.daForzare.length} alternative su {Z.forzareTot} fasce
              </span>
              <button onClick={() => setZoneMostraTutte(v => !v)}
                title="Alcune forzature sono nascoste perche' un'altra fascia le batte sia sul P/L sia sul PPE: non le sceglieresti mai. Da qui le rivedi."
                style={{marginLeft:"auto",padding:"3px 10px",fontSize:10,borderRadius:5,cursor:"pointer",
                  border:"1px solid #86EFAC",
                  background: zoneMostraTutte ? "#DCFCE7" : "#fff", color:"#166534"}}>
                {zoneMostraTutte ? "Mostra solo le alternative" : "Mostra anche le forzature meno interessanti"}
              </button>
            </div>
            <Tabella lista={listaForzare} verso="forza" />
          </div>
        );
      })()}

      {/* ================================================================
          STRATO 6 — MATRICE (protagonista)
          ================================================================ */}
      {!vistaPL && !vistaMercati && !vistaZone && <div ref={matriceRef} onMouseDown={(e) => {
        // Previeni selezione testo durante drag — ma non su input/select/button
        if (!e.target.closest('input, select, button') && e.target.closest('table') && e.target.closest('tbody')) e.preventDefault();
      }} style={{
        margin:"8px 16px 16px",
        background:"#fff",border:"1px solid #E8E8E4",borderRadius:10,
        overflowX:"auto",overflowY:"auto",
        minHeight: `calc(100vh - 200px)`,
        maxHeight: `calc(100vh - 200px)`,
        boxShadow:"0 2px 8px rgba(0,0,0,0.06)",
        userSelect: isDragging.current ? "none" : "auto",
      }}>
        {risultato && risultatiMulti.length === 0 ? (
          /* SINGOLO PARAMETRO */
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
            <thead>
              {/* Riga 1: super-header — vuoto a sinistra, MERCATI a destra */}
              <tr>
                <th colSpan={3} style={{...thStyle,background:"#1B2846",borderBottom:"1px solid #1B2846"}}>
                  {inConsultazione && (
                    <span style={{display:"inline-block",background:"#E4EFFC",color:"#1E40AF",
                      borderRadius:5,padding:"1px 8px",fontSize:10,fontWeight:700,
                      textTransform:"none",letterSpacing:0}}>
                      solo {[...stagioniVista].sort().join(", ")}
                    </span>
                  )}
                </th>
                <th style={{...thStyle,background:"#1B2846",borderBottom:"1px solid #1B2846",
                  borderLeft:"2px solid #C7C7D4",borderRight:"2px solid #C7C7D4"}}></th>
                {risultato.colonne.length > 0 && (
                  <th colSpan={risultato.colonne.length} style={{...thStyle,textAlign:"center",
                    background:"#1B2846",borderLeft:"2px solid #C7C7D4",
                    borderBottom:"1px solid #1B2846",
                    fontSize:11,letterSpacing:"0.06em",color:"#fff"}}>
                    MERCATI
                  </th>
                )}
              </tr>
              {/* Riga 2: colonne */}
              <tr>
                <th style={{...thStyle,textAlign:"left",top:28,background:"#1B2846",color:"#fff"}}>
                  Parametro statistico
                </th>
                <th style={{...thStyle,textAlign:"center",top:28,background:"#1B2846",color:"#fff"}}>Eventi</th>
                <th style={{...thStyle,textAlign:"center",top:28,background:"#1B2846",color:"#fff"}}>% sul totale</th>
                <th style={{...thStyle,top:28,background:"#1B2846",
                  borderLeft:"2px solid #C7C7D4",borderRight:"2px solid #C7C7D4",
                  color:"#fff"}}>Sistema</th>
                {risultato.colonne.map((c, ci) => {
                  const isB = c.includes("_b") || c.startsWith("pl_b") || c.startsWith("pl_qb");
                  const isSorted = sortCol === c;
                  const hMid = MERCATI_PL_MAP && Object.entries(MERCATI_PL_MAP).find(([k,[cp,cb]]) => cp===c||cb===c)?.[0];
                  const hStato = hMid ? mercatiStato[hMid] : 0;
                  const hIsPunta = hMid ? MERCATI_PL_MAP[hMid][0] === c : false;
                  const hIsVis = hIsPunta ? hStato !== 2 : hStato !== 3;
                  return (
                    <th key={c} style={{...thStyle, top:28,
                      background: isSorted ? "#1B2846" : (hIsVis ? "#fff" : (isB ? "#FFF0F6" : "#EFF9FF")),
                      borderTop: hIsVis ? "none" : (isB ? "3px solid #F472B6" : "3px solid #38BDF8"),
                      color: isSorted ? "#fff" : (isB ? "#9D174D" : "#0369A1"),
                      cursor:"pointer",whiteSpace:"nowrap"}}
                      onClick={() => toggleSortCol(c)}>
                      {fmtCol(c)}{" "}
                      {!isSorted && (
                        <span style={{display:"inline-block",padding:"0px 4px",borderRadius:3,fontSize:8,fontWeight:700,marginLeft:3,
                          background: hIsVis ? "#DCFCE7" : (isB ? "#F472B6" : "#38BDF8"),
                          color: hIsVis ? "#15803D" : "#fff"}}>
                          {hIsVis ? "VIS" : (isB ? "BAN" : "PUN")}
                        </span>
                      )}
                      <span style={{fontSize:9,opacity: isSorted ? 1 : 0.6,color: isSorted ? "#fff" : "#888"}}>
                        {isSorted && sortDir === "asc" ? "▲" : isSorted && sortDir === "desc" ? "▼" : "⇅"}
                      </span>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {/* Riga input personalizzato (solo per parametri intervallo) */}
              {risultato.righe.length > 0 && risultato.righe[0].v2 !== null && risultato.righe[0].v2 !== undefined && (() => {
                const pid = risultato._paramId || parametro;
                const ci = getCI(pid);
                const inputStyle = {
                  width:62,padding:"3px 5px",fontSize:11,border:"1px solid #94A3B8",borderRadius:4,
                  fontFamily:"'Roboto Mono',monospace",textAlign:"center",background:"#fff"
                };
                const selectStyle = {
                  padding:"2px 2px",fontSize:10,border:"1px solid #94A3B8",borderRadius:4,
                  fontFamily:"'Roboto Mono',monospace",background:"#fff",cursor:"pointer"
                };
                const btnCI = (label, tipo, color, borderColor) => (
                  <button onClick={() => applicaCustomInput(pid, tipo)}
                    disabled={inConsultazione}
                    title={inConsultazione ? "Non disponibile mentre stai consultando alcune stagioni." : undefined}
                    style={{padding:"3px 10px",fontSize:10,fontWeight:700,border:`1.5px solid ${borderColor}`,
                      borderRadius:5,background:"#fff",color,
                      cursor: inConsultazione ? "not-allowed" : "pointer",
                      opacity: inConsultazione ? 0.35 : 1, marginLeft:4}}>
                    {label}
                  </button>
                );
                return (
                  <tr onMouseDown={e => e.stopPropagation()} style={{background:"#CBD5E1",borderBottom:"2px solid #64748B"}}>
                    <td colSpan={4 + risultato.colonne.length} style={{padding:"6px 10px"}}>
                      <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap",fontSize:11}}>
                        <span style={{fontWeight:700,color:"#334155",marginRight:2}}>Valore:</span>
                        <input type="text" value={ci.valore} placeholder="—"
                          onChange={e => { setCI(pid,"valore",e.target.value); if(e.target.value) { setCI(pid,"da",""); setCI(pid,"a",""); } }}
                          style={{...inputStyle,width:72}} />
                        <span style={{color:"#64748B",fontWeight:600,margin:"0 2px"}}>oppure</span>
                        <span style={{fontWeight:700,color:"#334155"}}>Da</span>
                        <select value={ci.opDa} onChange={e => setCI(pid,"opDa",e.target.value)} style={selectStyle}>
                          <option value=">">&gt;</option>
                          <option value="≥">≥</option>
                        </select>
                        <input type="text" value={ci.da} placeholder="—"
                          onChange={e => { setCI(pid,"da",e.target.value); if(e.target.value) setCI(pid,"valore",""); }}
                          style={inputStyle} />
                        <span style={{fontWeight:700,color:"#334155"}}>A</span>
                        <select value={ci.opA} onChange={e => setCI(pid,"opA",e.target.value)} style={selectStyle}>
                          <option value="<">&lt;</option>
                          <option value="≤">≤</option>
                        </select>
                        <input type="text" value={ci.a} placeholder="—"
                          onChange={e => { setCI(pid,"a",e.target.value); if(e.target.value) setCI(pid,"valore",""); }}
                          style={inputStyle} />
                        {btnCI("Forza","forza","#2563EB","#93C5FD")}
                        {btnCI("Escludi","escludi","#DC2626","#FECACA")}
                      </div>
                    </td>
                  </tr>
                );
              })()}
              {(sortCol && sortDir ? sortRows(risultato.righe) : risultato.righe.map((r, idx) => ({r, idx}))).map(({r: row, idx: i}) => {
                if (row.eventi === 0 && !selectedRows.has(i)) return null;
                const isSel = selectedRows.has(i);
                const inSb = rigaInStandby(risultato._paramId || parametro, row.v1, row.v2);
                const sysVal = hasSistema ?
                  (sommaMode ? row.sistema : (row.eventi > 0 ? +(row.sistema/row.eventi).toFixed(2) : 0))
                  : 0;
                return (
                  <tr key={i}
                    {...(naBloccata(row) ? {} : {
                      onMouseDown: (e) => handleRowMouseDown(i, e),
                      onMouseEnter: () => handleRowMouseEnter(i),
                      onMouseUp: () => handleRowMouseUp(i),
                    })}
                    title={naBloccata(row) ? TITOLO_NA_BLOCCATA : undefined}
                    style={{
                      cursor: naBloccata(row) ? "not-allowed" : "pointer",transition:"background 0.1s",
                      background: isSel ? "#EFF4FF" : (inSb ? "#F7F4FF" : "transparent"),
                      borderLeft: isSel ? "3px solid #2563EB" : (inSb ? "3px solid #C4B5FD" : "3px solid transparent"),
                    }}>
                    <td style={{padding:"4px 8px",fontWeight:600,whiteSpace:"nowrap",
                      fontFamily:"'Roboto Mono',monospace",fontSize:11,
                      color: naBloccata(row) ? "#8A8A85" : "#1A1A18",
                      fontStyle: naBloccata(row) ? "italic" : "normal",
                      borderBottom:"1px solid #F0F0EC"}}>
                      {inSb && <span title="Questa fascia è già nella Lista Standby"
                        style={{color:"#7C3AED",marginRight:5,cursor:"help"}}>⏸</span>}
                      {naBloccata(row) ? <span>&#8856; {row.etichetta}</span> : fmtRange(row.v1, row.v2)}
                    </td>
                    <td style={{...tdStyle,textAlign:"center",color:"#6B6B66"}}>{row.eventi}</td>
                    <td style={{...tdStyle,textAlign:"center",color:"#A3A39E",fontSize:10}}>{row.pct}%</td>
                    <td style={{...tdStyle,textAlign:"right",
                      borderLeft:"2px solid #C7C7D4",borderRight:"2px solid #C7C7D4",
                      ...heatBg(sysVal, maxAbs)}}>
                      {hasSistema ? <FmtVal v={sysVal} /> : <span style={{color:"#A3A39E"}}>—</span>}
                    </td>
                    {risultato.colonne.map((c, ci) => {
                      const raw = row.mercati[c] || 0;
                      const v = sommaMode ? raw : (row.eventi > 0 ? +(raw/row.eventi).toFixed(2) : 0);
                      const mId = MERCATI_PL_MAP && Object.entries(MERCATI_PL_MAP).find(([k,[cp,cb]]) => cp===c||cb===c)?.[0];
                      const mStato = mId ? mercatiStato[mId] : 0;
                      const isPuntaCol = mId ? MERCATI_PL_MAP[mId][0] === c : false;
                      const isVis = isPuntaCol ? mStato !== 2 : mStato !== 3;
                      return (
                        <td key={c} style={{...tdStyle,textAlign:"right",
                          ...(isVis
                            ? {background:"#fff", color: v > 0 ? "#16A34A" : v < 0 ? "#DC2626" : "#A3A39E"}
                            : heatBg(v,maxAbs))}}>
                          <FmtVal v={v} />
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
              {/* Riga totale */}
              <tr style={{background:"#CBD5E1",fontWeight:700,borderTop:"2px solid #64748B"}}>
                <td style={{padding:"6px 8px",fontWeight:800,fontSize:11,
                  fontFamily:"'Roboto Mono',monospace",textTransform:"uppercase",
                  letterSpacing:"0.04em",borderBottom:"2px solid #64748B"}}>Totale</td>
                <td style={{...tdStyle,textAlign:"center",fontWeight:700,borderBottom:"2px solid #64748B"}}>
                  {risultato.righe.reduce((s,r) => s+r.eventi, 0).toLocaleString()}
                </td>
                <td style={{...tdStyle,textAlign:"center",fontWeight:700,borderBottom:"2px solid #64748B"}}>
                  {risultato.righe.reduce((s,r) => s+r.pct, 0).toFixed(1)}%
                </td>
                <td style={{...tdStyle,textAlign:"right",
                  borderLeft:"2px solid #C7C7D4",borderRight:"2px solid #C7C7D4",fontWeight:700,borderBottom:"2px solid #64748B"}}>
                  {hasSistema ?
                    <FmtVal v={+risultato.righe.reduce((s,r) => s+r.sistema, 0).toFixed(2)} /> :
                    <span style={{color:"#A3A39E"}}>—</span>}
                </td>
                {risultato.colonne.map((c, ci) => {
                  const t = +risultato.righe.reduce((s,r) => s+(r.mercati[c]||0), 0).toFixed(2);
                  return (
                    <td key={c} style={{...tdStyle,textAlign:"right",fontWeight:700,borderBottom:"2px solid #64748B"}}>
                      <FmtVal v={t} />
                    </td>
                  );
                })}
              </tr>
            </tbody>
          </table>

        ) : risultatiMulti.length > 0 ? (
          /* MULTI-PARAMETRO */
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
            <thead>
              {/* Riga 1: super-header — vuoto a sinistra, MERCATI a destra */}
              <tr>
                <th colSpan={3} style={{...thStyle,background:"#1B2846",borderBottom:"1px solid #1B2846"}}>
                  {inConsultazione && (
                    <span style={{display:"inline-block",background:"#E4EFFC",color:"#1E40AF",
                      borderRadius:5,padding:"1px 8px",fontSize:10,fontWeight:700,
                      textTransform:"none",letterSpacing:0}}>
                      solo {[...stagioniVista].sort().join(", ")}
                    </span>
                  )}
                </th>
                <th style={{...thStyle,background:"#1B2846",borderBottom:"1px solid #1B2846",
                  borderLeft:"2px solid #C7C7D4",borderRight:"2px solid #C7C7D4"}}></th>
                {(risultatiMulti[0]?.data?.colonne||[]).length > 0 && (
                  <th colSpan={(risultatiMulti[0]?.data?.colonne||[]).length} style={{...thStyle,textAlign:"center",
                    background:"#1B2846",
                    borderBottom:"1px solid #1B2846",
                    fontSize:11,letterSpacing:"0.06em",color:"#fff"}}>
                    MERCATI
                  </th>
                )}
              </tr>
              {/* Riga 2: colonne */}
              <tr>
                <th style={{...thStyle,textAlign:"left",top:28,background:"#1B2846",color:"#fff"}}>Parametro statistico</th>
                <th style={{...thStyle,textAlign:"center",top:28,background:"#1B2846",color:"#fff"}}>Eventi</th>
                <th style={{...thStyle,textAlign:"center",top:28,background:"#1B2846",color:"#fff"}}>% sul totale</th>
                <th style={{...thStyle,top:28,background:"#1B2846",
                  borderLeft:"2px solid #C7C7D4",borderRight:"2px solid #C7C7D4",
                  color:"#fff"}}>Sistema</th>
                {(risultatiMulti[0]?.data?.colonne||[]).map((c, ci) => {
                  const isB = c.includes("_b")||c.startsWith("pl_b")||c.startsWith("pl_qb");
                  const isSorted = sortCol === c;
                  const hMid2 = MERCATI_PL_MAP && Object.entries(MERCATI_PL_MAP).find(([k,[cp,cb]]) => cp===c||cb===c)?.[0];
                  const hStato2 = hMid2 ? mercatiStato[hMid2] : 0;
                  const hIsPunta2 = hMid2 ? MERCATI_PL_MAP[hMid2][0] === c : false;
                  const hIsVis2 = hIsPunta2 ? hStato2 !== 2 : hStato2 !== 3;
                  return (
                    <th key={c} style={{...thStyle,top:28,
                      background: isSorted ? "#1B2846" : (hIsVis2 ? "#fff" : (isB ? "#FFF0F6" : "#EFF9FF")),
                      borderTop: hIsVis2 ? "none" : (isB ? "3px solid #F472B6" : "3px solid #38BDF8"),
                      color: isSorted ? "#fff" : (isB ? "#9D174D" : "#0369A1"),
                      cursor:"pointer",whiteSpace:"nowrap"}}
                      onClick={() => toggleSortCol(c)}>
                      {fmtCol(c)}{" "}
                      {!isSorted && (
                        <span style={{display:"inline-block",padding:"0px 4px",borderRadius:3,fontSize:8,fontWeight:700,marginLeft:3,
                          background: hIsVis2 ? "#DCFCE7" : (isB ? "#F472B6" : "#38BDF8"),
                          color: hIsVis2 ? "#15803D" : "#fff"}}>
                          {hIsVis2 ? "VIS" : (isB ? "BAN" : "PUN")}
                        </span>
                      )}
                      <span style={{fontSize:9,opacity: isSorted ? 1 : 0.6,color: isSorted ? "#fff" : "#888"}}>
                        {isSorted && sortDir === "asc" ? "▲" : isSorted && sortDir === "desc" ? "▼" : "⇅"}
                      </span>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {risultatiMulti.map(({ paramId, label, data }, blockIdx) => {
                const colonne = data.colonne || [];
                const blockMaxAbs = Math.max(
                  ...data.righe.flatMap(r => Object.values(r.mercati).map(v => Math.abs(v||0))), 1
                );
                return [
                  <tr key={`sep_${paramId}`} style={{position:"sticky",top:56,zIndex:9}}>
                    <td colSpan={4 + colonne.length} style={{
                      background:"#EFF4FF",
                      borderTop: blockIdx > 0 ? "2px solid #BFDBFE" : "none",
                      borderBottom:"1px solid #BFDBFE",
                      padding:"6px 14px",
                    }}>
                      <span style={{fontSize:11,fontWeight:700,color:"#1D4ED8",
                        fontFamily:"'Roboto Mono',monospace",letterSpacing:"0.02em"}}>
                        📊 {label}
                      </span>
                      <span style={{fontSize:10,color:"#60A5FA",marginLeft:8}}>
                        — {data.totale_partite?.toLocaleString()} eventi totali
                      </span>
                    </td>
                  </tr>,
                  /* Riga input personalizzato (solo intervallo) */
                  ...(data.righe.length > 0 && data.righe[0].v2 !== null && data.righe[0].v2 !== undefined ? [(() => {
                    const ci = getCI(paramId);
                    const inputStyle = {
                      width:62,padding:"3px 5px",fontSize:11,border:"1px solid #94A3B8",borderRadius:4,
                      fontFamily:"'Roboto Mono',monospace",textAlign:"center",background:"#fff"
                    };
                    const selectStyle = {
                      padding:"2px 2px",fontSize:10,border:"1px solid #94A3B8",borderRadius:4,
                      fontFamily:"'Roboto Mono',monospace",background:"#fff",cursor:"pointer"
                    };
                    const btnCI = (lbl, tipo, color, borderColor) => (
                      <button onClick={() => applicaCustomInput(paramId, tipo)}
                        disabled={inConsultazione}
                        title={inConsultazione ? "Non disponibile mentre stai consultando alcune stagioni." : undefined}
                        style={{padding:"3px 10px",fontSize:10,fontWeight:700,border:`1.5px solid ${borderColor}`,
                          borderRadius:5,background:"#fff",color,
                          cursor: inConsultazione ? "not-allowed" : "pointer",
                          opacity: inConsultazione ? 0.35 : 1, marginLeft:4}}>
                        {lbl}
                      </button>
                    );
                    return (
                      <tr key={`ci_${paramId}`} onMouseDown={e => e.stopPropagation()} style={{background:"#CBD5E1",borderBottom:"2px solid #64748B"}}>
                        <td colSpan={4 + colonne.length} style={{padding:"6px 10px"}}>
                          <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap",fontSize:11}}>
                            <span style={{fontWeight:700,color:"#334155",marginRight:2}}>Valore:</span>
                            <input type="text" value={ci.valore} placeholder="—"
                              onChange={e => { setCI(paramId,"valore",e.target.value); if(e.target.value) { setCI(paramId,"da",""); setCI(paramId,"a",""); } }}
                              style={{...inputStyle,width:72}} />
                            <span style={{color:"#64748B",fontWeight:600,margin:"0 2px"}}>oppure</span>
                            <span style={{fontWeight:700,color:"#334155"}}>Da</span>
                            <select value={ci.opDa} onChange={e => setCI(paramId,"opDa",e.target.value)} style={selectStyle}>
                              <option value=">">&gt;</option>
                              <option value="≥">≥</option>
                            </select>
                            <input type="text" value={ci.da} placeholder="—"
                              onChange={e => { setCI(paramId,"da",e.target.value); if(e.target.value) setCI(paramId,"valore",""); }}
                              style={inputStyle} />
                            <span style={{fontWeight:700,color:"#334155"}}>A</span>
                            <select value={ci.opA} onChange={e => setCI(paramId,"opA",e.target.value)} style={selectStyle}>
                              <option value="<">&lt;</option>
                              <option value="≤">≤</option>
                            </select>
                            <input type="text" value={ci.a} placeholder="—"
                              onChange={e => { setCI(paramId,"a",e.target.value); if(e.target.value) setCI(paramId,"valore",""); }}
                              style={inputStyle} />
                            {btnCI("Forza","forza","#2563EB","#93C5FD")}
                            {btnCI("Escludi","escludi","#DC2626","#FECACA")}
                          </div>
                        </td>
                      </tr>
                    );
                  })()] : []),
                  ...((sortCol && sortDir)
                    ? sortRows(data.righe).map(({r: row, idx: i}) => {
                        if (row.eventi === 0) return null;
                        const rowKey = `${paramId}__${i}`;
                        const isSel = selectedRows.has(rowKey);
                        const inSb = rigaInStandby(paramId, row.v1, row.v2);
                        const sysVal = hasSistema ?
                          (sommaMode ? row.sistema : (row.eventi>0 ? +(row.sistema/row.eventi).toFixed(2) : 0)) : 0;
                        return (
                          <tr key={rowKey}
                            {...(naBloccata(row) ? {} : {
                              onMouseDown: (e) => handleRowMouseDown(rowKey, e),
                              onMouseEnter: () => handleRowMouseEnter(rowKey),
                              onMouseUp: () => handleRowMouseUp(rowKey),
                            })}
                            title={naBloccata(row) ? TITOLO_NA_BLOCCATA : undefined}
                            style={{
                              cursor: naBloccata(row) ? "not-allowed" : "pointer",transition:"background 0.1s",
                              background: isSel ? "#EFF4FF" : (inSb ? "#F7F4FF" : "transparent"),
                              borderLeft: isSel ? "3px solid #2563EB" : (inSb ? "3px solid #C4B5FD" : "3px solid transparent"),
                            }}>
                            <td style={{padding:"4px 8px",fontWeight:600,whiteSpace:"nowrap",
                              fontFamily:"'Roboto Mono',monospace",fontSize:11,
                      color: naBloccata(row) ? "#8A8A85" : "#1A1A18",
                      fontStyle: naBloccata(row) ? "italic" : "normal",
                              borderBottom:"1px solid #F0F0EC"}}>
                              {inSb && <span title="Questa fascia è già nella Lista Standby"
                                style={{color:"#7C3AED",marginRight:5,cursor:"help"}}>⏸</span>}
                              {naBloccata(row) ? <span>&#8856; {row.etichetta}</span> : fmtRange(row.v1, row.v2)}
                            </td>
                            <td style={{...tdStyle,textAlign:"center",color:"#6B6B66"}}>{row.eventi}</td>
                            <td style={{...tdStyle,textAlign:"center",color:"#A3A39E",fontSize:10}}>{row.pct}%</td>
                            <td style={{...tdStyle,textAlign:"right",
                              borderLeft:"2px solid #C7C7D4",borderRight:"2px solid #C7C7D4",
                              ...heatBg(sysVal,blockMaxAbs)}}>
                              {hasSistema ? <FmtVal v={sysVal}/> : <span style={{color:"#A3A39E"}}>—</span>}
                            </td>
                            {colonne.map((c, ci) => {
                              const raw = row.mercati[c]||0;
                              const v = sommaMode ? raw : (row.eventi>0 ? +(raw/row.eventi).toFixed(2) : 0);
                              const mId2 = MERCATI_PL_MAP && Object.entries(MERCATI_PL_MAP).find(([k,[cp,cb]]) => cp===c||cb===c)?.[0];
                              const mStato2 = mId2 ? mercatiStato[mId2] : 0;
                              const isPuntaCol2 = mId2 ? MERCATI_PL_MAP[mId2][0] === c : false;
                              const isVis2 = isPuntaCol2 ? mStato2 !== 2 : mStato2 !== 3;
                              return (
                                <td key={c} style={{...tdStyle,textAlign:"right",
                                  ...(isVis2
                                    ? {background:"#fff", color: v > 0 ? "#16A34A" : v < 0 ? "#DC2626" : "#A3A39E"}
                                    : heatBg(v,blockMaxAbs))}}>
                                  <FmtVal v={v}/>
                                </td>
                              );
                            })}
                          </tr>
                        );
                      }).filter(Boolean)
                    : data.righe.map((row, i) => {
                    if (row.eventi === 0) return null;
                    const rowKey = `${paramId}__${i}`;
                    const isSel = selectedRows.has(rowKey);
                    const inSb = rigaInStandby(paramId, row.v1, row.v2);
                    const sysVal = hasSistema ?
                      (sommaMode ? row.sistema : (row.eventi>0 ? +(row.sistema/row.eventi).toFixed(2) : 0)) : 0;
                    return (
                      <tr key={rowKey}
                        {...(naBloccata(row) ? {} : {
                          onMouseDown: (e) => handleRowMouseDown(rowKey, e),
                          onMouseEnter: () => handleRowMouseEnter(rowKey),
                          onMouseUp: () => handleRowMouseUp(rowKey),
                        })}
                        title={naBloccata(row) ? TITOLO_NA_BLOCCATA : undefined}
                        style={{
                          cursor: naBloccata(row) ? "not-allowed" : "pointer",transition:"background 0.1s",
                          background: isSel ? "#EFF4FF" : (inSb ? "#F7F4FF" : "transparent"),
                          borderLeft: isSel ? "3px solid #2563EB" : (inSb ? "3px solid #C4B5FD" : "3px solid transparent"),
                        }}>
                        <td style={{padding:"4px 8px",fontWeight:600,whiteSpace:"nowrap",
                          fontFamily:"'Roboto Mono',monospace",fontSize:11,
                      color: naBloccata(row) ? "#8A8A85" : "#1A1A18",
                      fontStyle: naBloccata(row) ? "italic" : "normal",
                          borderBottom:"1px solid #F0F0EC"}}>
                          {inSb && <span title="Questa fascia è già nella Lista Standby"
                            style={{color:"#7C3AED",marginRight:5,cursor:"help"}}>⏸</span>}
                          {naBloccata(row) ? <span>&#8856; {row.etichetta}</span> : fmtRange(row.v1, row.v2)}
                        </td>
                        <td style={{...tdStyle,textAlign:"center",color:"#6B6B66"}}>{row.eventi}</td>
                        <td style={{...tdStyle,textAlign:"center",color:"#A3A39E",fontSize:10}}>{row.pct}%</td>
                        <td style={{...tdStyle,textAlign:"right",
                          borderLeft:"2px solid #C7C7D4",borderRight:"2px solid #C7C7D4",
                          ...heatBg(sysVal,blockMaxAbs)}}>
                          {hasSistema ? <FmtVal v={sysVal}/> : <span style={{color:"#A3A39E"}}>—</span>}
                        </td>
                        {colonne.map((c, ci) => {
                          const raw = row.mercati[c]||0;
                          const v = sommaMode ? raw : (row.eventi>0 ? +(raw/row.eventi).toFixed(2) : 0);
                          const mId3 = MERCATI_PL_MAP && Object.entries(MERCATI_PL_MAP).find(([k,[cp,cb]]) => cp===c||cb===c)?.[0];
                          const mStato3 = mId3 ? mercatiStato[mId3] : 0;
                          const isPuntaCol3 = mId3 ? MERCATI_PL_MAP[mId3][0] === c : false;
                          const isVis3 = isPuntaCol3 ? mStato3 !== 2 : mStato3 !== 3;
                          return (
                            <td key={c} style={{...tdStyle,textAlign:"right",
                              ...(isVis3
                                ? {background:"#fff", color: v > 0 ? "#16A34A" : v < 0 ? "#DC2626" : "#A3A39E"}
                                : heatBg(v,blockMaxAbs))}}>
                              <FmtVal v={v}/>
                            </td>
                          );
                        })}
                      </tr>
                    );
                  }).filter(Boolean)),
                  <tr key={`tot_${paramId}`}
                    style={{background:"#CBD5E1",fontWeight:700,borderTop:"2px solid #64748B",borderBottom:"2px solid #64748B"}}>
                    <td style={{padding:"5px 8px",fontWeight:800,fontSize:10,
                      fontFamily:"'Roboto Mono',monospace",textTransform:"uppercase",
                      letterSpacing:"0.04em",color:"#6B6B66"}}>Totale</td>
                    <td style={{...tdStyle,textAlign:"center",fontWeight:700}}>
                      {data.righe.reduce((s,r)=>s+r.eventi,0).toLocaleString()}
                    </td>
                    <td style={{...tdStyle,textAlign:"center",fontWeight:700}}>
                      {data.righe.reduce((s,r)=>s+r.pct,0).toFixed(1)}%
                    </td>
                    <td style={{...tdStyle,textAlign:"right",fontWeight:700,
                      borderLeft:"2px solid #C7C7D4",borderRight:"2px solid #C7C7D4"}}>
                      {hasSistema ?
                        <FmtVal v={+data.righe.reduce((s,r)=>s+r.sistema,0).toFixed(2)}/> :
                        <span style={{color:"#A3A39E"}}>—</span>}
                    </td>
                    {colonne.map((c, ci) => {
                      const t = +data.righe.reduce((s,r)=>s+(r.mercati[c]||0),0).toFixed(2);
                      return (
                        <td key={c} style={{...tdStyle,textAlign:"right",fontWeight:700}}>
                          <FmtVal v={t}/>
                        </td>
                      );
                    })}
                  </tr>
                ];
              })}
            </tbody>
          </table>

        ) : (
          /* STATO VUOTO */
          <div style={{textAlign:"center",padding:"80px 20px",color:"#A3A39E"}}>
            <div style={{fontSize:48,marginBottom:16,opacity:0.2}}>📊</div>
            <div style={{fontSize:15,fontWeight:600,color:"#6B6B66",marginBottom:8}}>
              Clicca <span style={{color:"#2563EB"}}>▶</span> Calcola per avviare l'analisi
            </div>
          </div>
        )}
      </div>}

      {/* ================================================================
          MODAL CONFERMA VISTA P/L
          ================================================================ */}
      {vistaPLConfirm && (() => {
        const { tipo, label, intervallo, primaEventi, primaPL, dopoEventi, dopoPL, newFiltri } = vistaPLConfirm;
        const isEscludi = tipo === "escludi";
        const fmtPL = (v) => (v >= 0 ? "+" : "") + v.toFixed(2);
        const fmtE = (v) => v?.toLocaleString("it-IT");
        return (
          <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.45)",zIndex:1000,
            display:"flex",alignItems:"center",justifyContent:"center"}}>
            <div style={{background:"#fff",borderRadius:12,padding:"28px 32px",
              boxShadow:"0 8px 40px rgba(0,0,0,0.18)",minWidth:420,maxWidth:500}}>
              {/* Titolo */}
              <div style={{fontSize:15,fontWeight:700,color:"#1A1A18",marginBottom:6}}>
                {isEscludi ? "❌ Confermi l'esclusione?" : "✅ Confermi la forzatura?"}
              </div>
              <div style={{fontSize:12,color:"#6B6B66",marginBottom:20}}>
                <span style={{fontWeight:600,color:"#1D4ED8"}}>{label}</span>
                {" — "}
                <span style={{fontFamily:"'Roboto Mono',monospace"}}>{intervallo}</span>
              </div>
              {/* Tabella Prima/Dopo */}
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:12,marginBottom:24}}>
                <thead>
                  <tr style={{background:"#F8F8F6"}}>
                    <th style={{padding:"8px 12px",textAlign:"left",color:"#6B6B66",fontWeight:600,
                      fontSize:10,textTransform:"uppercase",letterSpacing:"0.06em"}}></th>
                    <th style={{padding:"8px 12px",textAlign:"center",color:"#6B6B66",fontWeight:600,
                      fontSize:10,textTransform:"uppercase",letterSpacing:"0.06em"}}>Prima</th>
                    <th style={{padding:"8px 12px",textAlign:"center",color:"#6B6B66",fontWeight:600,
                      fontSize:10,textTransform:"uppercase",letterSpacing:"0.06em"}}>Dopo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{borderTop:"1px solid #F0F0EC"}}>
                    <td style={{padding:"10px 12px",fontWeight:600,color:"#444440"}}>Eventi</td>
                    <td style={{padding:"10px 12px",textAlign:"center",
                      fontFamily:"'Roboto Mono',monospace",color:"#444440"}}>
                      {fmtE(primaEventi)}
                    </td>
                    <td style={{padding:"10px 12px",textAlign:"center",
                      fontFamily:"'Roboto Mono',monospace",fontWeight:700,
                      color: "#1A1A18"}}>
                      {fmtE(dopoEventi)}
                    </td>
                  </tr>
                  <tr style={{borderTop:"1px solid #F0F0EC"}}>
                    <td style={{padding:"10px 12px",fontWeight:600,color:"#444440"}}>P/L Sistema</td>
                    <td style={{padding:"10px 12px",textAlign:"center",
                      fontFamily:"'Roboto Mono',monospace",
                      color: primaPL >= 0 ? "#16A34A" : "#DC2626"}}>
                      {fmtPL(primaPL)}
                    </td>
                    <td style={{padding:"10px 12px",textAlign:"center",
                      fontFamily:"'Roboto Mono',monospace",fontWeight:700,
                      color: dopoPL >= 0 ? "#16A34A" : "#DC2626"}}>
                      {fmtPL(dopoPL)}
                    </td>
                  </tr>
                </tbody>
              </table>
              {/* Bottoni */}
              <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
                <button onClick={() => setVistaPLConfirm(null)}
                  style={{...btnGhost}}>
                  Annulla
                </button>
                <button onClick={() => {
                    setVistaPLConfirm(null);
                    pushUndo();
                    setFiltri(newFiltri);
                    calcola(newFiltri);
                  }}
                  style={{...btnBase,
                    background: isEscludi ? "#DC2626" : "#16A34A",
                    color:"#fff"}}>
                  {isEscludi ? "Escludi" : "Forza"}
                </button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ================================================================
          MODAL SALVA SISTEMA
          ================================================================ */}
      {showModal && (
        <div style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",
          background:"rgba(0,0,0,0.3)",backdropFilter:"blur(4px)",zIndex:1000,
          display:"flex",justifyContent:"center",alignItems:"center"}}
          onClick={(e) => { if (e.target === e.currentTarget) setShowModal(false); }}>
          <div style={{background:"#fff",borderRadius:14,padding:24,width:420,maxWidth:"92%",
            boxShadow:"0 20px 60px rgba(0,0,0,0.15)"}}>
            <h3 style={{fontSize:16,fontWeight:700,marginBottom:16,letterSpacing:"-0.02em"}}>
              {isNuovoSistema ? "➕ Nuovo Sistema" : "💾 Salva Sistema"}
            </h3>
            <label style={modalLabel}>ID (es. S1, S2...)</label>
            <input value={sysId} onChange={e => setSysId(e.target.value)}
              placeholder="S1" style={modalInput} />
            <label style={modalLabel}>Nome</label>
            <input value={sysNome} onChange={e => setSysNome(e.target.value)}
              placeholder="English Championship (BX)" style={modalInput} />
            <label style={modalLabel}>Commenti</label>
            <textarea value={sysComm} onChange={e => setSysComm(e.target.value)}
              placeholder="Note opzionali..." style={{...modalInput,height:70,resize:"vertical"}} />
            <div style={{display:"flex",alignItems:"center",gap:7,marginTop:12,marginBottom:4,
              background:"#F1F5F9",borderRadius:6,padding:"8px 10px"}}>
              <span style={{width:8,height:8,borderRadius:5,flexShrink:0,
                background: sysAttivo ? "#16A34A" : "#94A3B8"}} />
              <span style={{fontSize:11,color:"#334155"}}>
                {sysAttivo ? `Attivo dal ${formattaDataIT(sysDataAttiv)}`
                  : (sysDataAttiv ? `Dismesso${sysDataSosp ? ` dal ${formattaDataIT(sysDataSosp)}` : ""}` : "Mai attivato")}
              </span>
            </div>
            <div style={{marginTop:14,fontSize:11,color:"#A3A39E",lineHeight:1.6}}>
              <strong>Mercati:</strong> {getMercatoSistemaLabel()}<br/>
              <strong>Filtri:</strong> {Object.keys(filtri).length ?
                Object.entries(filtri).map(([k,c]) => fmtFiltro(k,c).label + ": " + fmtFiltro(k,c).desc).join("; ") :
                "Nessuno"}
            </div>
            <div style={{marginTop:18,display:"flex",gap:8,justifyContent:"flex-end"}}>
              <button onClick={() => setShowModal(false)} style={btnGhost}>Annulla</button>
              <button onClick={salvaSistema} style={btnSave}>Salva</button>
            </div>
          </div>
        </div>
      )}

      {/* --- WHAT IF: Drawer --- */}
      {/* ================================================================
          TENUTA DEI FILTRI NEL TEMPO
          ================================================================ */}
      {tenutaOpen && (() => {
        const voci = vociTenuta();
        const fmtPL = v => (v > 0 ? "+" : "") + Number(v).toFixed(2);
        const fmtPPE = v => Number(v).toFixed(2);
        const fmtVar3 = v => (v > 0 ? "+" : "")
          + Number(v).toFixed((v !== 0 && Math.abs(v) < 0.005) ? 3 : 2);
        const cPL = v => v > 0 ? "#15803D" : (v < 0 ? "#DC2626" : "#6B7280");

        const th = { padding:"5px 8px", fontSize:9.5, fontWeight:700, color:"#6B6B66",
          textTransform:"uppercase", letterSpacing:"0.04em", borderBottom:"1.5px solid #B4B2A9",
          whiteSpace:"nowrap", textAlign:"right" };
        const tdN = { padding:"6px 8px", textAlign:"right", fontFamily:"'Roboto Mono',monospace",
          fontSize:11, borderBottom:"1px solid #EFEFEC", whiteSpace:"nowrap" };
        const tdL = { padding:"6px 8px", textAlign:"left", fontSize:11,
          borderBottom:"1px solid #EFEFEC", whiteSpace:"nowrap", color:"#374151" };
        const azz = { background:"#DBEAFE" };
        const sep = { borderLeft:"2px solid #64748B" };
        const titoloBlocco = { padding:"10px 8px 4px", fontSize:11, fontWeight:600,
          color:"#0D9488", textAlign:"left" };

        const tabellaBande = () => {
          const { voce, bande, conFiltro, senzaFiltro } = tenutaDati;
          if (!bande || !conFiltro || !senzaFiltro) return null;

          const vuoto = { eventi:0, punti:0, ppe:0 };
          const bloccoDi = (arr, i) => arr[i] || { stagioni:{}, totale:vuoto };

          // Stagioni di ogni banda: unione dei due scenari, in ordine
          const stagPerBanda = bande.map((b, i) => Array.from(new Set([
            ...Object.keys(bloccoDi(conFiltro, i).stagioni),
            ...Object.keys(bloccoDi(senzaFiltro, i).stagioni),
          ])).sort());

          // Una stagione tagliata da piu' bande compare piu' volte: va marcata
          const conteggio = {};
          stagPerBanda.forEach(l => l.forEach(st => { conteggio[st] = (conteggio[st] || 0) + 1; }));
          const spezzate = Object.keys(conteggio).filter(st => conteggio[st] > 1);

          const haVoce = bande.map(b => voceNellaBanda(b, voce));
          const nessunaBanda = haVoce.every(x => !x);

          // Fondo: bianco il backtest, azzurri alternati le bande
          const sfondo = (i) => bande[i].backtest ? {} : { background: (i % 2 === 1) ? "#DBEAFE" : "#BFDBFE" };
          const colonneB = (i) => [
            ...stagPerBanda[i].map(st => ({ st })),
            { st:null, totale:true },
          ];

          const prendiVal = (arr, i, c) => {
            const b = bloccoDi(arr, i);
            return c.totale ? b.totale : (b.stagioni[c.st] || vuoto);
          };

          const celleBanda = (i, prendi, colora) =>
            colonneB(i).map((c, k) => {
              const conf = prendiVal(conFiltro, i, c);
              const senz = prendiVal(senzaFiltro, i, c);
              const v = prendi(conf, senz);
              return (
                <td key={`${i}-${k}`} style={{...tdN, ...sfondo(i),
                  ...(i > 0 && k === 0 ? sep : {}),
                  ...(c.totale ? {fontWeight:600} : {}),
                  color: colora ? cPL(v) : "#374151"}}>
                  {colora === "ppe" ? fmtPPE(v)
                    : colora === "var3" ? fmtVar3(v)
                    : colora ? fmtPL(v) : v}
                </td>
              );
            });

          const rigaB = (etichetta, prendi, colora, richiedeVoce, conTesto) => (
            <tr key={etichetta}>
              <td style={tdL}>{etichetta}</td>
              {bande.map((b, i) => (
                (richiedeVoce && !haVoce[i]) ? (
                  <td key={`g-${i}`} colSpan={colonneB(i).length}
                    style={{...tdN, textAlign:"center", background:"#F1EFE8",
                      color:"#888780", fontStyle: conTesto ? "italic" : "normal",
                      ...(i > 0 ? sep : {})}}>
                    {conTesto ? "Filtro non impostato in questo periodo" : "\u2014"}
                  </td>
                ) : celleBanda(i, prendi, colora)
              ))}
            </tr>
          );

          return (
            <div style={{overflowX:"auto"}}>
              <div style={{fontSize:12, color:"#374151", marginBottom:10}}>
                <strong>{sysNome}</strong> · filtro <strong>{voce.label}: {voce.desc}</strong> · attivato il {formattaDataIT(sysDataAttiv)}
              </div>
              {nessunaBanda && (
                <div style={{fontSize:11, color:"#3730A3", background:"#EEF2FF",
                  border:"1px solid #C7D2FE", borderRadius:6, padding:"6px 10px", marginBottom:10}}>
                  Questo filtro non era impostato in nessuno dei periodi passati: si può giudicare solo da quando l'hai messo.
                </div>
              )}
              <table style={{borderCollapse:"collapse", minWidth:"100%"}}>
                <thead>
                  <tr>
                    <th style={{...th, textAlign:"left"}}></th>
                    {bande.map((b, i) => (
                      <th key={`h-${i}`} colSpan={colonneB(i).length}
                        style={{...th, textAlign:"center", ...sfondo(i), ...(i > 0 ? sep : {})}}>
                        {b.etichetta}
                      </th>
                    ))}
                  </tr>
                  <tr>
                    <th style={{...th, textAlign:"left"}}>Stagione</th>
                    {bande.map((b, i) => colonneB(i).map((c, k) => (
                      <th key={`s-${i}-${k}`} style={{...th, ...sfondo(i),
                        ...(i > 0 && k === 0 ? sep : {})}}>
                        {c.totale ? "Totale" : c.st}
                        {!c.totale && spezzate.includes(c.st) ? " (parziale)" : ""}
                      </th>
                    )))}
                  </tr>
                </thead>
                <tbody>
                  <tr><td style={titoloBlocco} colSpan={99}>Il sistema com'è</td></tr>
                  {rigaB("Eventi", (c) => c.eventi, null, false, false)}
                  {rigaB("P/L", (c) => c.punti, true, false, false)}
                  {rigaB("PPE", (c) => c.ppe, "ppe", false, false)}

                  <tr><td style={titoloBlocco} colSpan={99}>Cosa esclude il filtro</td></tr>
                  {rigaB("Ev. esclusi", (c, sz) => Math.abs(sz.eventi - c.eventi), null, true, true)}
                  {rigaB("P/L escluso", (c, sz) => +(sz.punti - c.punti).toFixed(2), true, true, false)}

                  <tr><td style={titoloBlocco} colSpan={99}>Se lo togliessi</td></tr>
                  {rigaB("Eventi", (c, sz) => sz.eventi, null, true, true)}
                  {rigaB("P/L", (c, sz) => sz.punti, true, true, false)}
                  {rigaB("PPE", (c, sz) => sz.ppe, "ppe", true, false)}
                  {rigaB("Var. P/L", (c, sz) => +(sz.punti - c.punti).toFixed(2), true, true, false)}
                  {rigaB("Var. PPE", (c, sz) => sz.ppe - c.ppe, "var3", true, false)}
                </tbody>
              </table>
            </div>
          );
        };

        const tabella = () => {
          const { voce, conFiltro, senzaFiltro } = tenutaDati;
          const pp = conFiltro.per_periodo, ps = senzaFiltro.per_periodo;
          if (!pp || !ps) return null;

          const stagPrima = Array.from(new Set([
            ...Object.keys(pp.prima.stagioni), ...Object.keys(ps.prima.stagioni)
          ])).sort();
          const stagDopo = Array.from(new Set([
            ...Object.keys(pp.dopo.stagioni), ...Object.keys(ps.dopo.stagioni)
          ])).sort();
          const spezzata = stagPrima.filter(x => stagDopo.includes(x));
          // La stagione in corso e' l'ultima che compare nel periodo dopo l'attivazione
          const stagCorrente = stagDopo.length > 0 ? stagDopo[stagDopo.length - 1] : null;

          const vuoto = { eventi:0, punti:0, ppe:0 };
          const g = (blocco, stag) => blocco.stagioni[stag] || vuoto;

          const colonne = [
            ...stagPrima.map(st => ({ st, lato:"prima", primaDelSep:false })),
            { st:null, lato:"prima", totale:true },
            ...stagDopo.map((st, i) => ({ st, lato:"dopo", primaDelSep: i === 0 })),
            { st:null, lato:"dopo", totale:true },
          ];

          const val = (lato, totale, stag, blocco) => {
            const b = lato === "prima" ? blocco.prima : blocco.dopo;
            return totale ? b.totale : g(b, stag);
          };

          const riga = (etichetta, prendi, colora) => (
            <tr>
              <td style={tdL}>{etichetta}</td>
              {colonne.map((c, i) => {
                const conf = val(c.lato, c.totale, c.st, pp);
                const senz = val(c.lato, c.totale, c.st, ps);
                const v = prendi(conf, senz);
                return (
                  <td key={i} style={{...tdN,
                    ...(c.lato === "dopo" ? azz : {}),
                    ...(c.primaDelSep ? sep : {}),
                    ...(c.totale ? {fontWeight:600} : {}),
                    color: colora ? cPL(v) : "#374151",
                  }}>
                    {colora === "ppe" ? fmtPPE(v) : (colora ? fmtPL(v) : v)}
                  </td>
                );
              })}
            </tr>
          );

          return (
            <div style={{overflowX:"auto"}}>
              <div style={{fontSize:12, color:"#374151", marginBottom:10}}>
                <strong>{sysNome}</strong> · filtro <strong>{voce.label}: {voce.desc}</strong> · attivato il {formattaDataIT(sysDataAttiv)}
              </div>
              {spezzata.length > 0 && (
                <div style={{fontSize:11, color:"#92400E", background:"#FFFBEB",
                  border:"1px solid #FDE68A", borderRadius:6, padding:"6px 10px", marginBottom:10}}>
                  La stagione {spezzata.join(", ")} è divisa dalla data di attivazione: compare in entrambi i periodi, con le partite di prima a sinistra e quelle di dopo a destra.
                </div>
              )}
              <table style={{borderCollapse:"collapse", minWidth:"100%"}}>
                <thead>
                  <tr>
                    <th style={{...th, textAlign:"left"}}></th>
                    <th style={{...th, textAlign:"center"}} colSpan={stagPrima.length + 1}>Backtest storico</th>
                    <th style={{...th, textAlign:"center", ...azz, ...sep}} colSpan={stagDopo.length + 1}>Dopo l'attivazione</th>
                  </tr>
                  <tr>
                    <th style={{...th, textAlign:"left"}}>Stagione</th>
                    {colonne.map((c, i) => (
                      <th key={i} style={{...th,
                        ...(c.lato === "dopo" ? azz : {}),
                        ...(c.primaDelSep ? sep : {})}}>
                        {c.totale ? "Totale" : c.st}
                        {!c.totale && spezzata.includes(c.st) ? " (parziale)" : ""}
                        {!c.totale && c.lato === "dopo" && c.st === stagCorrente ? " (in corso)" : ""}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr><td style={titoloBlocco} colSpan={colonne.length + 1}>Il sistema com'è</td></tr>
                  {riga("Eventi", (c) => c.eventi, null)}
                  {riga("P/L", (c) => c.punti, true)}
                  {riga("PPE", (c) => c.ppe, "ppe")}

                  <tr><td style={titoloBlocco} colSpan={colonne.length + 1}>Cosa esclude il filtro</td></tr>
                  {riga("Ev. esclusi", (c, sz) => Math.abs(sz.eventi - c.eventi), null)}
                  {riga("P/L escluso", (c, sz) => +(sz.punti - c.punti).toFixed(2), true)}

                  <tr><td style={titoloBlocco} colSpan={colonne.length + 1}>Se lo togliessi</td></tr>
                  {riga("Eventi", (c, sz) => sz.eventi, null)}
                  {riga("P/L", (c, sz) => sz.punti, true)}
                  {riga("PPE", (c, sz) => sz.ppe, "ppe")}
                  {riga("Var. P/L", (c, sz) => +(sz.punti - c.punti).toFixed(2), true)}
                  <tr>
                    <td style={tdL}>Var. PPE</td>
                    {colonne.map((c, i) => {
                      const conf = val(c.lato, c.totale, c.st, pp);
                      const senz = val(c.lato, c.totale, c.st, ps);
                      const v = senz.ppe - conf.ppe;
                      return (
                        <td key={i} style={{...tdN,
                          ...(c.lato === "dopo" ? azz : {}),
                          ...(c.primaDelSep ? sep : {}),
                          ...(c.totale ? {fontWeight:600} : {}),
                          color: cPL(v)}}>
                          {fmtVar3(v)}
                        </td>
                      );
                    })}
                  </tr>
                </tbody>
              </table>
            </div>
          );
        };

        return (
        <>
          <div onClick={() => setTenutaOpen(false)}
            style={{position:"fixed", inset:0, background:"rgba(0,0,0,0.25)", zIndex:1000}} />
          <div style={{
            position:"fixed", top:0, right:0, bottom:0,
            width:"calc(100vw - 56px)", background:"#FFFFFF",
            boxShadow:"-4px 0 20px rgba(0,0,0,0.08)",
            zIndex:1001, display:"flex", flexDirection:"column",
          }}>
            <div style={{padding:"14px 18px 10px", borderBottom:"1px solid #E5E7EB", flexShrink:0}}>
              <div style={{display:"flex", alignItems:"baseline", justifyContent:"space-between"}}>
                <span style={{fontSize:16, fontWeight:600, color:"#1F2937"}}>Tenuta dei filtri nel tempo</span>
                <span style={{display:"flex", alignItems:"center", gap:12}}>
                  <span style={{fontSize:12, color:"#6B7280"}}>
                    {sysNome} · attivato il {formattaDataIT(sysDataAttiv)}
                  </span>
                  <button onClick={() => setTenutaOpen(false)}
                    style={{background:"transparent", border:"none", cursor:"pointer",
                      fontSize:22, color:"#6B7280", padding:"0 2px", lineHeight:1}}
                    title="Chiudi">×</button>
                </span>
              </div>
            </div>

            <div style={{flex:1, overflowY:"auto", padding:"12px 18px 24px"}}>
              <div style={{display:"flex", flexWrap:"wrap", gap:6, marginBottom:14}}>
                {voci.map(v => (
                  <button key={v.id} onClick={() => apriTenutaVoce(v)}
                    title={v.dismesso ? "Filtro usato in passato e poi tolto: si può ancora consultare" : undefined}
                    style={{
                      padding:"5px 11px", borderRadius:20, fontSize:11, fontWeight:500,
                      fontFamily:"'Roboto Mono',monospace", cursor:"pointer",
                      background: tenutaSel === v.id ? (v.dismesso ? "#5F5E5A" : "#0D9488")
                        : (v.dismesso ? "#D3D1C7" : "#F8FAFC"),
                      color: tenutaSel === v.id ? "#FFFFFF" : (v.dismesso ? "#444441" : "#334155"),
                      border: "1px solid " + (tenutaSel === v.id
                        ? (v.dismesso ? "#5F5E5A" : "#0D9488")
                        : (v.dismesso ? "#B4B2A9" : "#CBD5E1")),
                    }}>
                    {v.dismesso && (
                      <span style={{fontFamily:"system-ui,sans-serif"}}>non più in uso · </span>
                    )}
                    {v.verso === "includi" ? "✚" : "✕"} {v.label}: {v.desc}
                  </button>
                ))}
              </div>

              {!tenutaSel && (
                <div style={{fontSize:12, color:"#6B7280", padding:"20px 0"}}>
                  Scegli un filtro per vedere come si è comportato prima e dopo l'attivazione del sistema.
                </div>
              )}
              {tenutaLoading && (
                <div style={{fontSize:12, color:"#6B7280", padding:"20px 0"}}>Calcolo in corso…</div>
              )}
              {tenutaErrore && (
                <div style={{fontSize:12, color:"#DC2626", padding:"20px 0"}}>⚠ {tenutaErrore}</div>
              )}
              {!tenutaLoading && !tenutaErrore && tenutaDati && (tenutaDati.bande ? tabellaBande() : tabella())}
            </div>
          </div>
        </>
        );
      })()}

      {standbyOpen && (() => {
        const sbSysPPE = sbSysEventi > 0 ? sbSysPunti / sbSysEventi : 0;
        const nApplicati = standby.filter(r => versoApplicatoDi(r)).length;
        const fmtN = v => (v > 0 ? "+" : "") + Number(v).toFixed(2);
        // La variazione di PPE passa a tre decimali solo quando due
        // mostrerebbero 0.00 su un valore che in realtà si muove.
        const fmtVar3 = v => (v > 0 ? "+" : "")
          + Number(v).toFixed((v !== 0 && Math.abs(v) < 0.005) ? 3 : 2);
        const colNum = { padding:"7px 6px", textAlign:"right", fontFamily:"'Roboto Mono',monospace",
          fontSize:11, borderBottom:"1px solid #EFEFEC", whiteSpace:"nowrap" };
        const colTxt = { padding:"7px 6px", textAlign:"left", fontSize:11,
          borderBottom:"1px solid #EFEFEC" };
        const thSb = { padding:"5px 6px", fontSize:9.5, fontWeight:700, color:"#6B6B66",
          textTransform:"uppercase", letterSpacing:"0.04em", borderBottom:"1.5px solid #B4B2A9",
          whiteSpace:"nowrap" };
        const bordoSx = { borderLeft:"1.5px solid #888780" };
        const bordoDx = { borderRight:"1.5px solid #888780" };

        // Calcola per ogni riga i numeri da mostrare (mai memorizzati)
        const righeCalc = standby.map(r => {
          const versoApp = versoApplicatoDi(r);
          if (versoApp) {
            const senza = standbyAnnullaInfo[`${r.id}__${hashFiltri}`];
            if (!senza) return { r, versoApp, pronto: false, attesa: true };
            if (senza.errore) return { r, versoApp, pronto: false, guasto: true };
            const dopoPL = +Number(senza.punti).toFixed(2);
            const dopoEventi = senza.eventi;
            const dopoPPE = dopoEventi > 0 ? dopoPL / dopoEventi : 0;
            const perStag = sbNStagioni > 0 ? +(dopoEventi / sbNStagioni).toFixed(0) : null;
            return { r, versoApp, pronto: true, m: {
              verso: versoApp,
              eventi: Math.abs(dopoEventi - sbSysEventi),
              pl: +(dopoPL - sbSysPunti).toFixed(2),
              ppe: 0,
              dopoPL, dopoEventi, dopoPPE, dopoPerStagione: perStag,
              sottoSoglia: perStag !== null && perStag < SB_SOGLIA_STAGIONE,
              varPL: +(dopoPL - sbSysPunti).toFixed(2),
              varPPE: dopoPPE - sbSysPPE,
            }};
          }
          const m = misuraFascia(r.paramId, r.v1, r.v2);
          return { r, versoApp: null, pronto: !!m, m };
        });

        return (
        <>
          <div onClick={() => setStandbyOpen(false)}
            style={{position:"fixed", inset:0, background:"rgba(0,0,0,0.25)", zIndex:1000}} />
          <div style={{
            position:"fixed", top:0, right:0, bottom:0,
            width:"clamp(560px, 46vw, 860px)", maxWidth:"96vw", background:"#FFFFFF",
            boxShadow:"-4px 0 20px rgba(0,0,0,0.08)",
            zIndex:1001, display:"flex", flexDirection:"column",
          }}>
            <div style={{padding:"14px 18px 10px", borderBottom:"1px solid #E5E7EB", flexShrink:0}}>
              <div style={{display:"flex", alignItems:"baseline", justifyContent:"space-between"}}>
                <span style={{fontSize:16, fontWeight:600, color:"#1F2937"}}>Lista Standby</span>
                <span style={{display:"flex", alignItems:"center", gap:12}}>
                  <span style={{fontSize:12, color:"#6B7280"}}>
                    {standby.length} {standby.length === 1 ? "filtro" : "filtri"} · {nApplicati} applicat{nApplicati === 1 ? "o" : "i"}
                  </span>
                  {standby.length > 0 && (
                    <button onClick={svuotaStandby}
                      title="Toglie tutte le righe dalla lista. I filtri applicati al sistema restano attivi."
                      style={{padding:"3px 10px", fontSize:11, fontWeight:600, borderRadius:5, cursor:"pointer",
                        border:"1px solid #CBD5E1", background:"#F8FAFC", color:"#475569"}}>
                      Svuota
                    </button>
                  )}
                  <button onClick={() => setStandbyOpen(false)}
                    style={{background:"transparent", border:"none", cursor:"pointer",
                      fontSize:22, color:"#6B7280", padding:"0 2px", lineHeight:1}}
                    title="Chiudi">×</button>
                </span>
              </div>
              <div style={{fontSize:11.5, color:"#6B7280", marginTop:4, fontFamily:"'Roboto Mono',monospace"}}>
                {sysId ? `Sistema ${sysId}` : "Sistema in costruzione"}: eventi {sbSysEventi.toLocaleString("it-IT")} · P/L {fmtN(sbSysPunti)} · PPE {sbSysPPE.toFixed(3)}
              </div>
            </div>

            <div style={{flex:1, overflowY:"auto", padding:"0 8px 20px"}}>
              {standby.length === 0 ? (
                <div style={{padding:"36px 18px", textAlign:"center", color:"#94A3B8", fontSize:12.5, lineHeight:1.7}}>
                  La lista è vuota.<br/>
                  Seleziona una o più righe nella tabella e premi <strong style={{color:"#7C3AED"}}>Standby</strong>,
                  oppure usa il pulsante Standby nelle Zone Continue.
                </div>
              ) : (
                <table style={{width:"100%", borderCollapse:"collapse"}}>
                  <thead>
                    <tr>
                      <th colSpan={4} style={{...thSb, borderBottom:"none"}} />
                      <th colSpan={3} style={{...thSb, textAlign:"center", background:"#F1EFE8",
                        borderBottom:"none", ...bordoSx, ...bordoDx}}>Se applico il filtro</th>
                      <th colSpan={3} style={{...thSb, borderBottom:"none"}} />
                    </tr>
                    <tr>
                      <th style={{...thSb, textAlign:"left"}}>Parametro</th>
                      <th style={{...thSb, textAlign:"left"}}>Fascia</th>
                      <th style={{...thSb, textAlign:"right"}}>Ev. fascia</th>
                      <th style={{...thSb, textAlign:"right"}}>P/L fascia</th>
                      <th style={{...thSb, textAlign:"right", ...bordoSx}}>Eventi</th>
                      <th style={{...thSb, textAlign:"right"}}>P/L</th>
                      <th style={{...thSb, textAlign:"right", ...bordoDx}}>PPE</th>
                      <th style={{...thSb, textAlign:"right"}}>Var. P/L</th>
                      <th style={{...thSb, textAlign:"right"}}>Var. PPE</th>
                      <th style={{...thSb, textAlign:"center"}}>Azione</th>
                    </tr>
                  </thead>
                  <tbody>
                    {righeCalc.map(({ r, versoApp, pronto, m, attesa, guasto }) => {
                      const verso = versoApp || (m ? m.verso : null);
                      const etichettaFatta = verso === "forza" ? "Forzato" : "Escluso";
                      return (
                        <Fragment key={r.id}>
                          <tr style={{background: versoApp ? "#F5F3FF" : "#fff"}}>
                            <td style={{...colTxt, color:"#1D4ED8", fontWeight:600}}>
                              <span onClick={() => caricaDettStandby(r)}
                                title={r.aperto ? "Chiudi il dettaglio per stagione" : "Apri il dettaglio per stagione"}
                                style={{cursor:"pointer", color:"#475569", marginRight:6,
                                  fontSize:14, lineHeight:1, display:"inline-block", width:14}}>
                                {r.aperto ? "▾" : "▸"}
                              </span>
                              {versoApp && (
                                <span style={{color:"#16A34A", fontWeight:700, marginRight:4}}>
                                  ✓ {etichettaFatta}
                                </span>
                              )}
                              {r.label}
                            </td>
                            <td style={{...colTxt, fontFamily:"'Roboto Mono',monospace", color:"#444440"}}>
                              {sbEValore(r) ? String(r.v1) : `> ${r.v1} | ≤ ${r.v2}`}
                              {pronto && m.sottoSoglia && (
                                <span title={`Dopo questa mossa il sistema resterebbe con una media di ${m.dopoPerStagione} eventi per stagione, sotto la soglia di ${SB_SOGLIA_STAGIONE} (numero minimo consigliabile).`}
                                  style={{color:"#D97706", marginLeft:5, cursor:"help"}}>⚠</span>
                              )}
                            </td>
                            {!pronto ? (
                              <td colSpan={7} style={{...colTxt, color:"#94A3B8", fontStyle:"italic"}}>
                                {attesa ? "Calcolo in corso…"
                                  : guasto ? "Numeri non disponibili adesso. Il filtro resta applicato: puoi annullarlo comunque."
                                  : "Parametro non presente nel calcolo attuale — riattivalo e premi Calcola."}
                              </td>
                            ) : (
                              <>
                                <td style={colNum}>{m.eventi.toLocaleString("it-IT")}</td>
                                <td style={{...colNum, color: m.pl < 0 ? "#DC2626" : "#16A34A"}}>{fmtN(m.pl)}</td>
                                <td style={{...colNum, ...bordoSx}}>{m.dopoEventi.toLocaleString("it-IT")}</td>
                                <td style={colNum}>{fmtN(m.dopoPL)}</td>
                                <td style={{...colNum, ...bordoDx}}>{m.dopoPPE.toFixed(2)}</td>
                                <td style={{...colNum, fontWeight:700, color: m.varPL > 0 ? "#16A34A" : m.varPL < 0 ? "#DC2626" : "#6B6B66"}}>{fmtN(m.varPL)}</td>
                                <td style={{...colNum, fontWeight:700, color: m.varPPE > 0 ? "#16A34A" : m.varPPE < 0 ? "#DC2626" : "#6B6B66"}}>{fmtVar3(m.varPPE)}</td>
                              </>
                            )}
                            <td style={{...colNum, textAlign:"center", whiteSpace:"nowrap"}}>
                              {versoApp ? (
                                <button onClick={() => annullaStandby(r)}
                                  style={{padding:"3px 9px", fontSize:10, fontWeight:700, borderRadius:5, cursor:"pointer",
                                    border:"1.5px solid #CBD5E1", background:"#F8FAFC", color:"#475569"}}>
                                  Annulla
                                </button>
                              ) : pronto ? (
                                <button onClick={() => applicaStandby(r)}
                                  style={{padding:"3px 9px", fontSize:10, fontWeight:700, borderRadius:5, cursor:"pointer",
                                    border: verso === "escludi" ? "1.5px solid #FECACA" : "1.5px solid #86EFAC",
                                    background: verso === "escludi" ? "#FEF2F2" : "#F0FDF4",
                                    color: verso === "escludi" ? "#DC2626" : "#16A34A"}}>
                                  {verso === "escludi" ? "Escludi" : "Forza"}
                                </button>
                              ) : null}
                              <span onClick={() => togliDaStandby(r)} title="Togli la riga dalla Lista Standby"
                                style={{marginLeft:8, cursor:"pointer", color:"#64748B", fontSize:15,
                                  verticalAlign:"middle"}}>🗑</span>
                            </td>
                          </tr>
                          {r.aperto && (
                            <tr style={{background:"#FAFAF8"}}>
                              <td colSpan={10} style={{padding:"6px 10px 12px", borderBottom:"1px solid #EFEFEC"}}>
                                {r.dettLoading && <span style={{fontSize:11, color:"#94A3B8"}}>Carico il dettaglio per stagione…</span>}
                                {r.dettErr && <span style={{fontSize:11, color:"#DC2626"}}>Dettaglio non disponibile: {r.dettErr}</span>}
                                {r.dett && (() => {
                                  const dopo = r.dett.stagioni || [];
                                  const prima = statSistema?.stagioni || [];
                                  const tutti = [...new Set([...prima, ...dopo].map(s => s.stagione))].sort();
                                  const trovaP = n => prima.find(s => s.stagione === n);
                                  const trovaD = n => dopo.find(s => s.stagione === n);
                                  // Le stagioni senza eventi non aggiungono informazione: restano fuori
                                  const nomi = tutti.filter(n => (trovaP(n)?.eventi || 0) > 0 || (trovaD(n)?.eventi || 0) > 0);
                                  const cell = { padding:"3px 8px", textAlign:"right", fontFamily:"'Roboto Mono',monospace",
                                    fontSize:10.5, minWidth:64, whiteSpace:"nowrap" };
                                  const lbl = { padding:"3px 8px", textAlign:"left", fontSize:10.5, color:"#1A1A18",
                                    fontWeight:600, whiteSpace:"nowrap", position:"sticky", left:0, background:"#FAFAF8", zIndex:2 };
                                  const tot = { ...cell, fontWeight:700, color:"#1A1A18", position:"sticky", right:0,
                                    background:"#FAFAF8", zIndex:2, borderLeft:"1px solid #D3D1C7" };
                                  const F = n => {
                                    const evP = trovaP(n)?.eventi || 0, plP = trovaP(n)?.punti || 0;
                                    const evD = trovaD(n)?.eventi || 0, plD = trovaD(n)?.punti || 0;
                                    return { evP, plP, evD, plD,
                                      evF: verso === "forza" ? evD : evP - evD,
                                      plF: verso === "forza" ? plD : plP - plD };
                                  };
                                  let tEvP = 0, tPlP = 0, tEvF = 0, tPlF = 0, tEvD = 0, tPlD = 0;
                                  nomi.forEach(n => {
                                    const f = F(n);
                                    tEvP += f.evP; tPlP += f.plP; tEvF += f.evF;
                                    tPlF += f.plF; tEvD += f.evD; tPlD += f.plD;
                                  });
                                  const ppe = (pl, ev) => ev > 0 ? pl / ev : 0;
                                  // PPE a due decimali come gli altri KPI. La variazione passa
                                  // a tre solo quando due mostrerebbero 0.00 su un valore che
                                  // in realtà si muove.
                                  const fmtPPE = v => Number(v).toFixed(2);
                                  const fmtVarPPE = fmtVar3;
                                  const sez = { padding:"7px 8px 2px", textAlign:"left", fontSize:10.5,
                                    color:"#6B6B66", fontWeight:600, whiteSpace:"nowrap",
                                    position:"sticky", left:0, background:"#FAFAF8", zIndex:2 };
                                  const col = v => v < 0 ? "#DC2626" : "#16A34A";
                                  const rigaN = (etichetta, valori, totale, colora, fmt) => (
                                    <tr>
                                      <td style={lbl}>{etichetta}</td>
                                      {nomi.map((n, k) => (
                                        <td key={n} style={{...cell, color: colora ? col(valori[k]) : undefined}}>
                                          {fmt(valori[k])}
                                        </td>
                                      ))}
                                      <td style={{...tot, color: colora ? col(totale) : undefined}}>{fmt(totale)}</td>
                                    </tr>
                                  );
                                  const num = v => v.toLocaleString("it-IT");
                                  return (
                                    <div ref={el => { if (el) el.scrollLeft = el.scrollWidth; }}
                                      style={{overflowX:"auto", overflowY:"hidden"}}>
                                      <table style={{borderCollapse:"collapse", minWidth:"100%"}}>
                                        <tbody>
                                          <tr>
                                            <td style={lbl}>Stagione</td>
                                            {nomi.map(n => <td key={n} style={{...cell, color:"#1A1A18", fontWeight:600}}>{n}</td>)}
                                            <td style={tot}>Totale</td>
                                          </tr>
                                          <tr><td colSpan={nomi.length + 2} style={sez}>Come sta ora</td></tr>
                                          {rigaN("Eventi", nomi.map(n => F(n).evP), tEvP, false, num)}
                                          {rigaN("P/L", nomi.map(n => +F(n).plP.toFixed(2)), +tPlP.toFixed(2), true, fmtN)}
                                          {rigaN("PPE", nomi.map(n => ppe(F(n).plP, F(n).evP)), ppe(tPlP, tEvP), false, fmtPPE)}
                                          <tr><td colSpan={nomi.length + 2} style={sez}>
                                            {verso === "forza" ? "Cosa tiene il filtro" : "Cosa toglie il filtro"}
                                          </td></tr>
                                          {rigaN("Ev. fascia", nomi.map(n => F(n).evF), tEvF, false, num)}
                                          {rigaN("P/L fascia", nomi.map(n => +F(n).plF.toFixed(2)), +tPlF.toFixed(2), true, fmtN)}
                                          <tr><td colSpan={nomi.length + 2} style={sez}>Se applico il filtro</td></tr>
                                          {rigaN("Eventi", nomi.map(n => F(n).evD), tEvD, false, num)}
                                          {rigaN("P/L", nomi.map(n => +F(n).plD.toFixed(2)), +tPlD.toFixed(2), true, fmtN)}
                                          {rigaN("PPE", nomi.map(n => ppe(F(n).plD, F(n).evD)), ppe(tPlD, tEvD), false, fmtPPE)}
                                          {rigaN("Var. P/L", nomi.map(n => +(F(n).plD - F(n).plP).toFixed(2)), +(tPlD - tPlP).toFixed(2), true, fmtN)}
                                          {rigaN("Var. PPE", nomi.map(n => ppe(F(n).plD, F(n).evD) - ppe(F(n).plP, F(n).evP)), ppe(tPlD, tEvD) - ppe(tPlP, tEvP), true, fmtVarPPE)}
                                        </tbody>
                                      </table>
                                    </div>
                                  );
                                })()}
                              </td>
                            </tr>
                          )}
                        </Fragment>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </>
        );
      })()}

      {storicoRevAperto && revInfo && (
        <>
          <div
            onClick={() => setStoricoRevAperto(false)}
            style={{position:"fixed", inset:0, background:"rgba(0,0,0,0.25)", zIndex:1000}}
          />
          <div style={{
            position:"fixed", top:0, right:0, bottom:0,
            width:560, background:"#FFFFFF",
            boxShadow:"-4px 0 20px rgba(0,0,0,0.08)",
            zIndex:1001, display:"flex", flexDirection:"column",
          }}>
            <div style={{
              padding:"16px 20px", borderBottom:"1px solid #E5E7EB",
              display:"flex", alignItems:"flex-start", justifyContent:"space-between",
              flexShrink:0,
            }}>
              <div>
                <div style={{fontSize:17, fontWeight:600, color:"#1F2937"}}>Storico revisioni</div>
                <div style={{fontSize:12, color:"#6B7280", marginTop:2}}>
                  Come sono cambiati i filtri di {sysNome || sysId}
                </div>
              </div>
              <button
                onClick={() => setStoricoRevAperto(false)}
                style={{background:"transparent", border:"none", cursor:"pointer",
                  fontSize:24, color:"#6B7280", padding:"0 4px", lineHeight:1}}
                title="Chiudi">&times;</button>
            </div>

            <div style={{
              padding:"10px 20px", borderBottom:"1px solid #F3F4F6",
              display:"flex", gap:16, alignItems:"center", flexWrap:"wrap", flexShrink:0,
            }}>
              <span style={{fontSize:11, color:"#6B7280"}}>Legenda</span>
              {["aggiunto","tolto","modificato"].map(t => (
                <span key={t} style={{fontSize:11, color: COLORI_DIFF[t].fg}}>
                  <span style={{display:"inline-block", width:8, height:8, borderRadius:2,
                    background: COLORI_DIFF[t].pallino, marginRight:5}} />
                  {COLORI_DIFF[t].titolo.toLowerCase()}
                </span>
              ))}
            </div>

            <div style={{flex:1, overflowY:"auto", padding:"14px 20px"}}>
              {(revInfo.revisioni || []).slice().sort((a,b) => b.numero - a.numero).map((rev, idx, arr) => {
                const isUltima = idx === 0;
                const precedente = (revInfo.revisioni || []).find(x => x.numero === rev.numero - 1);
                const diff = precedente ? differenzeRev(precedente.filtri, rev.filtri) : [];
                return (
                  <div key={rev.numero} style={{
                    border:"1px solid #E5E7EB", borderRadius:12,
                    padding:"12px 14px", marginBottom:12,
                  }}>
                    <div style={{display:"flex", alignItems:"center",
                      justifyContent:"space-between", marginBottom:8}}>
                      <div>
                        <span style={{fontSize:14, fontWeight:600, color:"#1F2937"}}>
                          rev. {rev.numero}
                        </span>
                        <span style={{fontSize:12, color:"#6B7280", marginLeft:8}}>
                          dal {formattaDataIT(rev.data_inizio)}
                        </span>
                      </div>
                      {isUltima && arr.length > 1 && (
                        <button
                          onClick={annullaUltimaRevisione}
                          disabled={annullamentoRevInCorso}
                          title="Torna ai filtri della revisione precedente"
                          style={{fontSize:11,
                            color: annullamentoRevInCorso ? "#9CA3AF" : "#991B1B",
                            border:"1px solid " + (annullamentoRevInCorso ? "#E5E7EB" : "#F09595"),
                            background: annullamentoRevInCorso ? "#F9FAFB" : "#FCEBEB",
                            borderRadius:6, padding:"3px 9px",
                            cursor: annullamentoRevInCorso ? "wait" : "pointer", lineHeight:1.4}}>
                          {annullamentoRevInCorso ? "Annullamento in corso\u2026" : "Annulla questa revisione"}
                        </button>
                      )}
                    </div>

                    {rev.numero === 0 ? (
                      <>
                        <div style={{fontSize:11, color:"#6B7280", marginBottom:8}}>
                          I filtri con cui il sistema &egrave; stato attivato
                        </div>
                        {elencoFiltriRev(rev.filtri).length === 0 ? (
                          <div style={{fontSize:12, color:"#9CA3AF", fontStyle:"italic"}}>
                            Nessun filtro.
                          </div>
                        ) : elencoFiltriRev(rev.filtri).map(f => (
                          <div key={f.paramId} style={{
                            display:"flex", justifyContent:"space-between", gap:16,
                            fontSize:12, color:"#374151", padding:"4px 0",
                            borderBottom:"1px solid #F3F4F6",
                          }}>
                            <span style={{color:"#6B7280", flexShrink:0}}>{f.label}</span>
                            <span style={{textAlign:"right"}}>{f.desc}</span>
                          </div>
                        ))}
                      </>
                    ) : diff.length === 0 ? (
                      <div style={{fontSize:12, color:"#9CA3AF", fontStyle:"italic"}}>
                        Nessuna differenza rispetto alla revisione precedente.
                      </div>
                    ) : diff.map(d => {
                      const c = COLORI_DIFF[d.tipo];
                      return (
                        <div key={d.paramId} style={{
                          fontSize:12, color:c.fg, background:c.bg,
                          borderRadius:6, padding:"6px 9px", marginBottom:6,
                        }}>
                          <span style={{fontWeight:600}}>{c.titolo}</span>
                          {" \u00B7 "}{d.label}
                          {d.tipo === "modificato" ? (
                            <div style={{marginTop:3, color:c.fg2}}>
                              da {d.descPrec} &rarr; {d.desc}
                            </div>
                          ) : d.desc ? (
                            <div style={{marginTop:3, color:c.fg2}}>{d.desc}</div>
                          ) : null}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )}

      {whatifOpen && (
        <>
          {/* Overlay */}
          <div
            onClick={() => setWhatifOpen(false)}
            style={{
              position:"fixed", inset:0, background:"rgba(0,0,0,0.25)",
              zIndex:1000,
            }}
          />
          {/* Drawer */}
          <div style={{
            position:"fixed", top:0, right:0, bottom:0,
            width:680, background:"#FFFFFF",
            boxShadow:"-4px 0 20px rgba(0,0,0,0.08)",
            zIndex:1001, display:"flex", flexDirection:"column",
          }}>
            {/* Header */}
            <div style={{
              padding:"16px 20px", borderBottom:"1px solid #E5E7EB",
              display:"flex", alignItems:"center", justifyContent:"space-between",
              flexShrink:0,
            }}>
              <div>
                <div style={{fontSize:17, fontWeight:600, color:"#1F2937"}}>What If</div>
                <div style={{fontSize:12, color:"#6B7280", marginTop:2}}>
                  Performance per mercato sui filtri attivi
                </div>
              </div>
              <button
                onClick={() => setWhatifOpen(false)}
                style={{
                  background:"transparent", border:"none", cursor:"pointer",
                  fontSize:24, color:"#6B7280", padding:"0 4px", lineHeight:1,
                }}
                title="Chiudi">×</button>
            </div>

            {/* Toolbar: toggle Punta/Banca + info */}
            <div style={{
              padding:"12px 20px", borderBottom:"1px solid #F3F4F6",
              display:"flex", alignItems:"center", justifyContent:"space-between",
              gap:12, flexShrink:0,
            }}>
              <div style={{
                display:"inline-flex", border:"1px solid #E5E7EB",
                borderRadius:6, overflow:"hidden",
              }}>
                <button
                  onClick={() => setWhatifLato("punta")}
                  style={{
                    padding:"6px 16px", fontSize:13, fontWeight:500,
                    border:"none", cursor:"pointer",
                    background: whatifLato === "punta" ? "#DBEAFE" : "#FFFFFF",
                    color: whatifLato === "punta" ? "#1E40AF" : "#6B7280",
                  }}>Punta</button>
                <button
                  onClick={() => setWhatifLato("banca")}
                  style={{
                    padding:"6px 16px", fontSize:13, fontWeight:500,
                    border:"none", borderLeft:"1px solid #E5E7EB", cursor:"pointer",
                    background: whatifLato === "banca" ? "#FCE7F3" : "#FFFFFF",
                    color: whatifLato === "banca" ? "#9F1239" : "#6B7280",
                  }}>Banca</button>
              </div>
              <div style={{fontSize:12, color:"#6B7280"}}>
                {whatifDati ? (
                  <>Eventi: <strong style={{color:"#111827"}}>{whatifDati.eventi.toLocaleString("it-IT")}</strong></>
                ) : ""}
              </div>
            </div>

            {/* Contenuto scrollabile */}
            <div style={{flex:1, overflowY:"auto", padding:"12px 20px"}}>
              {whatifLoading && (
                <div style={{
                  display:"flex", flexDirection:"column", alignItems:"center",
                  justifyContent:"center", padding:"60px 0", gap:12,
                }}>
                  <div style={{
                    width:32, height:32, border:"3px solid #E5E7EB",
                    borderTopColor:"#7C3AED", borderRadius:"50%",
                    animation:"whatif-spin 0.8s linear infinite",
                  }} />
                  <div style={{fontSize:13, color:"#6B7280"}}>Calcolo in corso...</div>
                  <style>{`@keyframes whatif-spin { to { transform: rotate(360deg); } }`}</style>
                </div>
              )}

              {whatifErrore && !whatifLoading && (
                <div style={{
                  padding:"16px", background:"#FEF2F2", border:"1px solid #FECACA",
                  borderRadius:6, color:"#991B1B", fontSize:13,
                }}>
                  {whatifErrore}
                  <div style={{marginTop:8}}>
                    <button
                      onClick={caricaWhatIf}
                      style={{
                        padding:"4px 12px", fontSize:12, background:"#FFFFFF",
                        border:"1px solid #FECACA", borderRadius:4,
                        color:"#991B1B", cursor:"pointer",
                      }}>Riprova</button>
                  </div>
                </div>
              )}

              {!whatifLoading && !whatifErrore && whatifDati && whatifDati.eventi === 0 && (
                <div style={{
                  padding:"40px 16px", textAlign:"center",
                  color:"#6B7280", fontSize:13,
                }}>
                  Nessun evento corrisponde ai filtri attuali.
                </div>
              )}

              {!whatifLoading && !whatifErrore && whatifDati && whatifDati.eventi > 0 && (
                <table style={{width:"100%", borderCollapse:"collapse", fontSize:13}}>
                  <thead>
                    <tr style={{background:"#F9FAFB"}}>
                      <th style={{textAlign:"left", padding:"10px 12px", fontWeight:500, color:"#6B7280", fontSize:12, borderBottom:"1px solid #E5E7EB"}}>Mercato</th>
                      <th style={{textAlign:"right", padding:"10px 12px", fontWeight:500, color:"#6B7280", fontSize:12, borderBottom:"1px solid #E5E7EB"}}>Punti</th>
                      <th style={{textAlign:"right", padding:"10px 12px", fontWeight:500, color:"#6B7280", fontSize:12, borderBottom:"1px solid #E5E7EB"}}>PPE</th>
                      <th style={{textAlign:"right", padding:"10px 12px", fontWeight:500, color:"#6B7280", fontSize:12, borderBottom:"1px solid #E5E7EB"}}>% Vinc.</th>
                      <th style={{textAlign:"right", padding:"10px 12px", fontWeight:500, color:"#6B7280", fontSize:12, borderBottom:"1px solid #E5E7EB"}}>Q. Media</th>
                    </tr>
                  </thead>
                  <tbody>
                    {whatifDati.mercati.map((m) => {
                      const suf = whatifLato === "punta" ? "_p" : "_b";
                      const punti = m[`punti${suf}`];
                      const ppe = m[`ppe${suf}`];
                      const pct = m[`pct${suf}`];
                      const qmedia = m[`qmedia${suf}`];
                      const eventi = m[`eventi${suf}`];
                      const colP = punti > 0 ? "#16A34A" : (punti < 0 ? "#DC2626" : "#6B7280");
                      const colPpe = ppe > 0 ? "#16A34A" : (ppe < 0 ? "#DC2626" : "#6B7280");
                      const fmt = (v) => (v > 0 ? "+" : "") + v.toFixed(2).replace(".", ",");
                      return (
                        <tr key={m.chiave} style={{borderBottom:"1px solid #F3F4F6"}}>
                          <td style={{padding:"8px 12px", color:"#374151"}}>{m.label}</td>
                          <td style={{textAlign:"right", padding:"8px 12px", color:colP, fontWeight:punti !== 0 ? 500 : 400}}>
                            {eventi === 0 ? "–" : fmt(punti)}
                          </td>
                          <td style={{textAlign:"right", padding:"8px 12px", color:colPpe}}>
                            {eventi === 0 ? "–" : fmt(ppe)}
                          </td>
                          <td style={{textAlign:"right", padding:"8px 12px", color:"#374151"}}>
                            {eventi === 0 ? "–" : `${pct.toFixed(1).replace(".", ",")}%`}
                          </td>
                          <td style={{textAlign:"right", padding:"8px 12px", color:"#374151"}}>
                            {eventi === 0 || qmedia === 0 ? "–" : qmedia.toFixed(2).replace(".", ",")}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
